
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire43f2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire43f2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("b8reE", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $81b591678b09dda1$export$ffb0004e005737fa, (v) => $81b591678b09dda1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $81b591678b09dda1$export$34b9dba7ce09269b, (v) => $81b591678b09dda1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $81b591678b09dda1$export$25062201e9e25d76, (v) => $81b591678b09dda1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $81b591678b09dda1$export$ffb0004e005737fa;
var $81b591678b09dda1$export$34b9dba7ce09269b;
var $81b591678b09dda1$export$25062201e9e25d76;
'use strict';

var $8tsvq = parcelRequire("8tsvq");
var $81b591678b09dda1$var$k = Symbol.for("react.element"), $81b591678b09dda1$var$l = Symbol.for("react.fragment"), $81b591678b09dda1$var$m = Object.prototype.hasOwnProperty, $81b591678b09dda1$var$n = $8tsvq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $81b591678b09dda1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $81b591678b09dda1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$81b591678b09dda1$var$m.call(a, b) && !$81b591678b09dda1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $81b591678b09dda1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $81b591678b09dda1$var$n.current
    };
}
$81b591678b09dda1$export$ffb0004e005737fa = $81b591678b09dda1$var$l;
$81b591678b09dda1$export$34b9dba7ce09269b = $81b591678b09dda1$var$q;
$81b591678b09dda1$export$25062201e9e25d76 = $81b591678b09dda1$var$q;

});
parcelRegister("8tsvq", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4rIOO"));

});
parcelRegister("4rIOO", function(module, exports) {

$parcel$export(module.exports, "Children", () => $33cc730c2de4ccfb$export$dca3b0875bd9a954, (v) => $33cc730c2de4ccfb$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $33cc730c2de4ccfb$export$16fa2f45be04daa8, (v) => $33cc730c2de4ccfb$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $33cc730c2de4ccfb$export$ffb0004e005737fa, (v) => $33cc730c2de4ccfb$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $33cc730c2de4ccfb$export$e2c29f18771995cb, (v) => $33cc730c2de4ccfb$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $33cc730c2de4ccfb$export$221d75b3f55bb0bd, (v) => $33cc730c2de4ccfb$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $33cc730c2de4ccfb$export$5f8d39834fd61797, (v) => $33cc730c2de4ccfb$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $33cc730c2de4ccfb$export$74bf444e3cd11ea5, (v) => $33cc730c2de4ccfb$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $33cc730c2de4ccfb$export$ae55be85d98224ed, (v) => $33cc730c2de4ccfb$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $33cc730c2de4ccfb$export$3ba232387fd5d6dd, (v) => $33cc730c2de4ccfb$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $33cc730c2de4ccfb$export$e530037191fcd5d7, (v) => $33cc730c2de4ccfb$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $33cc730c2de4ccfb$export$fd42f52fd3ae1109, (v) => $33cc730c2de4ccfb$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $33cc730c2de4ccfb$export$c8a8987d4410bf2d, (v) => $33cc730c2de4ccfb$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $33cc730c2de4ccfb$export$d38cd72104c1f0e9, (v) => $33cc730c2de4ccfb$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $33cc730c2de4ccfb$export$7d1e3a5e95ceca43, (v) => $33cc730c2de4ccfb$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $33cc730c2de4ccfb$export$257a8862b851cb5b, (v) => $33cc730c2de4ccfb$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $33cc730c2de4ccfb$export$a8257692ac88316c, (v) => $33cc730c2de4ccfb$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $33cc730c2de4ccfb$export$488013bae63b21da, (v) => $33cc730c2de4ccfb$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $33cc730c2de4ccfb$export$7c73462e0d25e514, (v) => $33cc730c2de4ccfb$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $33cc730c2de4ccfb$export$7568632d0d33d16d, (v) => $33cc730c2de4ccfb$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $33cc730c2de4ccfb$export$88948ce120ea2619, (v) => $33cc730c2de4ccfb$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $33cc730c2de4ccfb$export$35808ee640e87ca7, (v) => $33cc730c2de4ccfb$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $33cc730c2de4ccfb$export$fae74005e78b1a27, (v) => $33cc730c2de4ccfb$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $33cc730c2de4ccfb$export$dc8fbce3eb94dc1e, (v) => $33cc730c2de4ccfb$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $33cc730c2de4ccfb$export$6a7bc4e911dc01cf, (v) => $33cc730c2de4ccfb$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $33cc730c2de4ccfb$export$6d9c69b0de29b591, (v) => $33cc730c2de4ccfb$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $33cc730c2de4ccfb$export$f680877a34711e37, (v) => $33cc730c2de4ccfb$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $33cc730c2de4ccfb$export$d5a552a76deda3c2, (v) => $33cc730c2de4ccfb$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $33cc730c2de4ccfb$export$aaabe4eda9ed9969, (v) => $33cc730c2de4ccfb$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $33cc730c2de4ccfb$export$e5c5a5f917a5871c, (v) => $33cc730c2de4ccfb$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $33cc730c2de4ccfb$export$1538c33de8887b59, (v) => $33cc730c2de4ccfb$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $33cc730c2de4ccfb$export$13e3392192263954, (v) => $33cc730c2de4ccfb$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $33cc730c2de4ccfb$export$b8f5890fc79d6aca, (v) => $33cc730c2de4ccfb$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $33cc730c2de4ccfb$export$60241385465d0a34, (v) => $33cc730c2de4ccfb$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $33cc730c2de4ccfb$export$306c0aa65ff9ec16, (v) => $33cc730c2de4ccfb$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $33cc730c2de4ccfb$export$7b286972b8d8ccbf, (v) => $33cc730c2de4ccfb$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $33cc730c2de4ccfb$export$83d89fbfd8236492, (v) => $33cc730c2de4ccfb$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $33cc730c2de4ccfb$export$dca3b0875bd9a954;
var $33cc730c2de4ccfb$export$16fa2f45be04daa8;
var $33cc730c2de4ccfb$export$ffb0004e005737fa;
var $33cc730c2de4ccfb$export$e2c29f18771995cb;
var $33cc730c2de4ccfb$export$221d75b3f55bb0bd;
var $33cc730c2de4ccfb$export$5f8d39834fd61797;
var $33cc730c2de4ccfb$export$74bf444e3cd11ea5;
var $33cc730c2de4ccfb$export$ae55be85d98224ed;
var $33cc730c2de4ccfb$export$3ba232387fd5d6dd;
var $33cc730c2de4ccfb$export$e530037191fcd5d7;
var $33cc730c2de4ccfb$export$fd42f52fd3ae1109;
var $33cc730c2de4ccfb$export$c8a8987d4410bf2d;
var $33cc730c2de4ccfb$export$d38cd72104c1f0e9;
var $33cc730c2de4ccfb$export$7d1e3a5e95ceca43;
var $33cc730c2de4ccfb$export$257a8862b851cb5b;
var $33cc730c2de4ccfb$export$a8257692ac88316c;
var $33cc730c2de4ccfb$export$488013bae63b21da;
var $33cc730c2de4ccfb$export$7c73462e0d25e514;
var $33cc730c2de4ccfb$export$7568632d0d33d16d;
var $33cc730c2de4ccfb$export$88948ce120ea2619;
var $33cc730c2de4ccfb$export$35808ee640e87ca7;
var $33cc730c2de4ccfb$export$fae74005e78b1a27;
var $33cc730c2de4ccfb$export$dc8fbce3eb94dc1e;
var $33cc730c2de4ccfb$export$6a7bc4e911dc01cf;
var $33cc730c2de4ccfb$export$6d9c69b0de29b591;
var $33cc730c2de4ccfb$export$f680877a34711e37;
var $33cc730c2de4ccfb$export$d5a552a76deda3c2;
var $33cc730c2de4ccfb$export$aaabe4eda9ed9969;
var $33cc730c2de4ccfb$export$e5c5a5f917a5871c;
var $33cc730c2de4ccfb$export$1538c33de8887b59;
var $33cc730c2de4ccfb$export$13e3392192263954;
var $33cc730c2de4ccfb$export$b8f5890fc79d6aca;
var $33cc730c2de4ccfb$export$60241385465d0a34;
var $33cc730c2de4ccfb$export$306c0aa65ff9ec16;
var $33cc730c2de4ccfb$export$7b286972b8d8ccbf;
var $33cc730c2de4ccfb$export$83d89fbfd8236492;
'use strict';
var $33cc730c2de4ccfb$var$l = Symbol.for("react.element"), $33cc730c2de4ccfb$var$n = Symbol.for("react.portal"), $33cc730c2de4ccfb$var$p = Symbol.for("react.fragment"), $33cc730c2de4ccfb$var$q = Symbol.for("react.strict_mode"), $33cc730c2de4ccfb$var$r = Symbol.for("react.profiler"), $33cc730c2de4ccfb$var$t = Symbol.for("react.provider"), $33cc730c2de4ccfb$var$u = Symbol.for("react.context"), $33cc730c2de4ccfb$var$v = Symbol.for("react.forward_ref"), $33cc730c2de4ccfb$var$w = Symbol.for("react.suspense"), $33cc730c2de4ccfb$var$x = Symbol.for("react.memo"), $33cc730c2de4ccfb$var$y = Symbol.for("react.lazy"), $33cc730c2de4ccfb$var$z = Symbol.iterator;
function $33cc730c2de4ccfb$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $33cc730c2de4ccfb$var$z && a[$33cc730c2de4ccfb$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $33cc730c2de4ccfb$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $33cc730c2de4ccfb$var$C = Object.assign, $33cc730c2de4ccfb$var$D = {};
function $33cc730c2de4ccfb$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $33cc730c2de4ccfb$var$D;
    this.updater = e || $33cc730c2de4ccfb$var$B;
}
$33cc730c2de4ccfb$var$E.prototype.isReactComponent = {};
$33cc730c2de4ccfb$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$33cc730c2de4ccfb$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $33cc730c2de4ccfb$var$F() {}
$33cc730c2de4ccfb$var$F.prototype = $33cc730c2de4ccfb$var$E.prototype;
function $33cc730c2de4ccfb$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $33cc730c2de4ccfb$var$D;
    this.updater = e || $33cc730c2de4ccfb$var$B;
}
var $33cc730c2de4ccfb$var$H = $33cc730c2de4ccfb$var$G.prototype = new $33cc730c2de4ccfb$var$F;
$33cc730c2de4ccfb$var$H.constructor = $33cc730c2de4ccfb$var$G;
$33cc730c2de4ccfb$var$C($33cc730c2de4ccfb$var$H, $33cc730c2de4ccfb$var$E.prototype);
$33cc730c2de4ccfb$var$H.isPureReactComponent = !0;
var $33cc730c2de4ccfb$var$I = Array.isArray, $33cc730c2de4ccfb$var$J = Object.prototype.hasOwnProperty, $33cc730c2de4ccfb$var$K = {
    current: null
}, $33cc730c2de4ccfb$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $33cc730c2de4ccfb$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$33cc730c2de4ccfb$var$J.call(b, d) && !$33cc730c2de4ccfb$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $33cc730c2de4ccfb$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $33cc730c2de4ccfb$var$K.current
    };
}
function $33cc730c2de4ccfb$var$N(a, b) {
    return {
        $$typeof: $33cc730c2de4ccfb$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $33cc730c2de4ccfb$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $33cc730c2de4ccfb$var$l;
}
function $33cc730c2de4ccfb$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $33cc730c2de4ccfb$var$P = /\/+/g;
function $33cc730c2de4ccfb$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $33cc730c2de4ccfb$var$escape("" + a.key) : b.toString(36);
}
function $33cc730c2de4ccfb$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $33cc730c2de4ccfb$var$l:
                case $33cc730c2de4ccfb$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $33cc730c2de4ccfb$var$Q(h, 0) : d, $33cc730c2de4ccfb$var$I(c) ? (e = "", null != a && (e = a.replace($33cc730c2de4ccfb$var$P, "$&/") + "/"), $33cc730c2de4ccfb$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($33cc730c2de4ccfb$var$O(c) && (c = $33cc730c2de4ccfb$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($33cc730c2de4ccfb$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($33cc730c2de4ccfb$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $33cc730c2de4ccfb$var$Q(k, g);
        h += $33cc730c2de4ccfb$var$R(k, b, e, f, c);
    }
    else if (f = $33cc730c2de4ccfb$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $33cc730c2de4ccfb$var$Q(k, g++), h += $33cc730c2de4ccfb$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $33cc730c2de4ccfb$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $33cc730c2de4ccfb$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $33cc730c2de4ccfb$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $33cc730c2de4ccfb$var$U = {
    current: null
}, $33cc730c2de4ccfb$var$V = {
    transition: null
}, $33cc730c2de4ccfb$var$W = {
    ReactCurrentDispatcher: $33cc730c2de4ccfb$var$U,
    ReactCurrentBatchConfig: $33cc730c2de4ccfb$var$V,
    ReactCurrentOwner: $33cc730c2de4ccfb$var$K
};
function $33cc730c2de4ccfb$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$33cc730c2de4ccfb$export$dca3b0875bd9a954 = {
    map: $33cc730c2de4ccfb$var$S,
    forEach: function(a, b, e) {
        $33cc730c2de4ccfb$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $33cc730c2de4ccfb$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $33cc730c2de4ccfb$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$33cc730c2de4ccfb$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$33cc730c2de4ccfb$export$16fa2f45be04daa8 = $33cc730c2de4ccfb$var$E;
$33cc730c2de4ccfb$export$ffb0004e005737fa = $33cc730c2de4ccfb$var$p;
$33cc730c2de4ccfb$export$e2c29f18771995cb = $33cc730c2de4ccfb$var$r;
$33cc730c2de4ccfb$export$221d75b3f55bb0bd = $33cc730c2de4ccfb$var$G;
$33cc730c2de4ccfb$export$5f8d39834fd61797 = $33cc730c2de4ccfb$var$q;
$33cc730c2de4ccfb$export$74bf444e3cd11ea5 = $33cc730c2de4ccfb$var$w;
$33cc730c2de4ccfb$export$ae55be85d98224ed = $33cc730c2de4ccfb$var$W;
$33cc730c2de4ccfb$export$3ba232387fd5d6dd = $33cc730c2de4ccfb$var$X;
$33cc730c2de4ccfb$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $33cc730c2de4ccfb$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $33cc730c2de4ccfb$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$33cc730c2de4ccfb$var$J.call(b, f) && !$33cc730c2de4ccfb$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $33cc730c2de4ccfb$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$33cc730c2de4ccfb$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $33cc730c2de4ccfb$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $33cc730c2de4ccfb$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$33cc730c2de4ccfb$export$c8a8987d4410bf2d = $33cc730c2de4ccfb$var$M;
$33cc730c2de4ccfb$export$d38cd72104c1f0e9 = function(a) {
    var b = $33cc730c2de4ccfb$var$M.bind(null, a);
    b.type = a;
    return b;
};
$33cc730c2de4ccfb$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$33cc730c2de4ccfb$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $33cc730c2de4ccfb$var$v,
        render: a
    };
};
$33cc730c2de4ccfb$export$a8257692ac88316c = $33cc730c2de4ccfb$var$O;
$33cc730c2de4ccfb$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $33cc730c2de4ccfb$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $33cc730c2de4ccfb$var$T
    };
};
$33cc730c2de4ccfb$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $33cc730c2de4ccfb$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$33cc730c2de4ccfb$export$7568632d0d33d16d = function(a) {
    var b = $33cc730c2de4ccfb$var$V.transition;
    $33cc730c2de4ccfb$var$V.transition = {};
    try {
        a();
    } finally{
        $33cc730c2de4ccfb$var$V.transition = b;
    }
};
$33cc730c2de4ccfb$export$88948ce120ea2619 = $33cc730c2de4ccfb$var$X;
$33cc730c2de4ccfb$export$35808ee640e87ca7 = function(a, b) {
    return $33cc730c2de4ccfb$var$U.current.useCallback(a, b);
};
$33cc730c2de4ccfb$export$fae74005e78b1a27 = function(a) {
    return $33cc730c2de4ccfb$var$U.current.useContext(a);
};
$33cc730c2de4ccfb$export$dc8fbce3eb94dc1e = function() {};
$33cc730c2de4ccfb$export$6a7bc4e911dc01cf = function(a) {
    return $33cc730c2de4ccfb$var$U.current.useDeferredValue(a);
};
$33cc730c2de4ccfb$export$6d9c69b0de29b591 = function(a, b) {
    return $33cc730c2de4ccfb$var$U.current.useEffect(a, b);
};
$33cc730c2de4ccfb$export$f680877a34711e37 = function() {
    return $33cc730c2de4ccfb$var$U.current.useId();
};
$33cc730c2de4ccfb$export$d5a552a76deda3c2 = function(a, b, e) {
    return $33cc730c2de4ccfb$var$U.current.useImperativeHandle(a, b, e);
};
$33cc730c2de4ccfb$export$aaabe4eda9ed9969 = function(a, b) {
    return $33cc730c2de4ccfb$var$U.current.useInsertionEffect(a, b);
};
$33cc730c2de4ccfb$export$e5c5a5f917a5871c = function(a, b) {
    return $33cc730c2de4ccfb$var$U.current.useLayoutEffect(a, b);
};
$33cc730c2de4ccfb$export$1538c33de8887b59 = function(a, b) {
    return $33cc730c2de4ccfb$var$U.current.useMemo(a, b);
};
$33cc730c2de4ccfb$export$13e3392192263954 = function(a, b, e) {
    return $33cc730c2de4ccfb$var$U.current.useReducer(a, b, e);
};
$33cc730c2de4ccfb$export$b8f5890fc79d6aca = function(a) {
    return $33cc730c2de4ccfb$var$U.current.useRef(a);
};
$33cc730c2de4ccfb$export$60241385465d0a34 = function(a) {
    return $33cc730c2de4ccfb$var$U.current.useState(a);
};
$33cc730c2de4ccfb$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $33cc730c2de4ccfb$var$U.current.useSyncExternalStore(a, b, e);
};
$33cc730c2de4ccfb$export$7b286972b8d8ccbf = function() {
    return $33cc730c2de4ccfb$var$U.current.useTransition();
};
$33cc730c2de4ccfb$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("jhxbP", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $e09959a092a7608b$export$ae55be85d98224ed, (v) => $e09959a092a7608b$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $e09959a092a7608b$export$d39a5bbd09211389, (v) => $e09959a092a7608b$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $e09959a092a7608b$export$882461b6382ed46c, (v) => $e09959a092a7608b$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $e09959a092a7608b$export$466bfc07425424d5, (v) => $e09959a092a7608b$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $e09959a092a7608b$export$cd75ccfd720a3cd4, (v) => $e09959a092a7608b$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $e09959a092a7608b$export$fa8d919ba61d84db, (v) => $e09959a092a7608b$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $e09959a092a7608b$export$757ceba2d55c277e, (v) => $e09959a092a7608b$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $e09959a092a7608b$export$b3890eb0ae9dca99, (v) => $e09959a092a7608b$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $e09959a092a7608b$export$502457920280e6be, (v) => $e09959a092a7608b$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $e09959a092a7608b$export$c78a37762a8d58e1, (v) => $e09959a092a7608b$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $e09959a092a7608b$export$dc54d992c10e8a18, (v) => $e09959a092a7608b$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $e09959a092a7608b$export$83d89fbfd8236492, (v) => $e09959a092a7608b$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e09959a092a7608b$export$ae55be85d98224ed;
var $e09959a092a7608b$export$d39a5bbd09211389;
var $e09959a092a7608b$export$882461b6382ed46c;
var $e09959a092a7608b$export$466bfc07425424d5;
var $e09959a092a7608b$export$cd75ccfd720a3cd4;
var $e09959a092a7608b$export$fa8d919ba61d84db;
var $e09959a092a7608b$export$757ceba2d55c277e;
var $e09959a092a7608b$export$b3890eb0ae9dca99;
var $e09959a092a7608b$export$502457920280e6be;
var $e09959a092a7608b$export$c78a37762a8d58e1;
var $e09959a092a7608b$export$dc54d992c10e8a18;
var $e09959a092a7608b$export$83d89fbfd8236492;
'use strict';

var $8tsvq = parcelRequire("8tsvq");

var $7DCtq = parcelRequire("7DCtq");
function $e09959a092a7608b$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e09959a092a7608b$var$da = new Set, $e09959a092a7608b$var$ea = {};
function $e09959a092a7608b$var$fa(a, b) {
    $e09959a092a7608b$var$ha(a, b);
    $e09959a092a7608b$var$ha(a + "Capture", b);
}
function $e09959a092a7608b$var$ha(a, b) {
    $e09959a092a7608b$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e09959a092a7608b$var$da.add(b[a]);
}
var $e09959a092a7608b$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e09959a092a7608b$var$ja = Object.prototype.hasOwnProperty, $e09959a092a7608b$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e09959a092a7608b$var$la = {}, $e09959a092a7608b$var$ma = {};
function $e09959a092a7608b$var$oa(a) {
    if ($e09959a092a7608b$var$ja.call($e09959a092a7608b$var$ma, a)) return !0;
    if ($e09959a092a7608b$var$ja.call($e09959a092a7608b$var$la, a)) return !1;
    if ($e09959a092a7608b$var$ka.test(a)) return $e09959a092a7608b$var$ma[a] = !0;
    $e09959a092a7608b$var$la[a] = !0;
    return !1;
}
function $e09959a092a7608b$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e09959a092a7608b$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e09959a092a7608b$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e09959a092a7608b$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e09959a092a7608b$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e09959a092a7608b$var$z[b] = new $e09959a092a7608b$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e09959a092a7608b$var$ra = /[\-:]([a-z])/g;
function $e09959a092a7608b$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e09959a092a7608b$var$ra, $e09959a092a7608b$var$sa);
    $e09959a092a7608b$var$z[b] = new $e09959a092a7608b$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e09959a092a7608b$var$ra, $e09959a092a7608b$var$sa);
    $e09959a092a7608b$var$z[b] = new $e09959a092a7608b$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e09959a092a7608b$var$ra, $e09959a092a7608b$var$sa);
    $e09959a092a7608b$var$z[b] = new $e09959a092a7608b$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e09959a092a7608b$var$z.xlinkHref = new $e09959a092a7608b$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e09959a092a7608b$var$z[a] = new $e09959a092a7608b$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e09959a092a7608b$var$ta(a, b, c, d) {
    var e = $e09959a092a7608b$var$z.hasOwnProperty(b) ? $e09959a092a7608b$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e09959a092a7608b$var$qa(b, c, e, d) && (c = null), d || null === e ? $e09959a092a7608b$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e09959a092a7608b$var$ua = $8tsvq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e09959a092a7608b$var$va = Symbol.for("react.element"), $e09959a092a7608b$var$wa = Symbol.for("react.portal"), $e09959a092a7608b$var$ya = Symbol.for("react.fragment"), $e09959a092a7608b$var$za = Symbol.for("react.strict_mode"), $e09959a092a7608b$var$Aa = Symbol.for("react.profiler"), $e09959a092a7608b$var$Ba = Symbol.for("react.provider"), $e09959a092a7608b$var$Ca = Symbol.for("react.context"), $e09959a092a7608b$var$Da = Symbol.for("react.forward_ref"), $e09959a092a7608b$var$Ea = Symbol.for("react.suspense"), $e09959a092a7608b$var$Fa = Symbol.for("react.suspense_list"), $e09959a092a7608b$var$Ga = Symbol.for("react.memo"), $e09959a092a7608b$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e09959a092a7608b$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e09959a092a7608b$var$Ja = Symbol.iterator;
function $e09959a092a7608b$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e09959a092a7608b$var$Ja && a[$e09959a092a7608b$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e09959a092a7608b$var$A = Object.assign, $e09959a092a7608b$var$La;
function $e09959a092a7608b$var$Ma(a) {
    if (void 0 === $e09959a092a7608b$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e09959a092a7608b$var$La = b && b[1] || "";
    }
    return "\n" + $e09959a092a7608b$var$La + a;
}
var $e09959a092a7608b$var$Na = !1;
function $e09959a092a7608b$var$Oa(a, b) {
    if (!a || $e09959a092a7608b$var$Na) return "";
    $e09959a092a7608b$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e09959a092a7608b$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e09959a092a7608b$var$Ma(a) : "";
}
function $e09959a092a7608b$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e09959a092a7608b$var$Ma(a.type);
        case 16:
            return $e09959a092a7608b$var$Ma("Lazy");
        case 13:
            return $e09959a092a7608b$var$Ma("Suspense");
        case 19:
            return $e09959a092a7608b$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e09959a092a7608b$var$Oa(a.type, !1), a;
        case 11:
            return a = $e09959a092a7608b$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e09959a092a7608b$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e09959a092a7608b$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e09959a092a7608b$var$ya:
            return "Fragment";
        case $e09959a092a7608b$var$wa:
            return "Portal";
        case $e09959a092a7608b$var$Aa:
            return "Profiler";
        case $e09959a092a7608b$var$za:
            return "StrictMode";
        case $e09959a092a7608b$var$Ea:
            return "Suspense";
        case $e09959a092a7608b$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e09959a092a7608b$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e09959a092a7608b$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e09959a092a7608b$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e09959a092a7608b$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e09959a092a7608b$var$Qa(a.type) || "Memo";
        case $e09959a092a7608b$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e09959a092a7608b$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e09959a092a7608b$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e09959a092a7608b$var$Qa(b);
        case 8:
            return b === $e09959a092a7608b$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e09959a092a7608b$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e09959a092a7608b$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e09959a092a7608b$var$Ua(a) {
    var b = $e09959a092a7608b$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e09959a092a7608b$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e09959a092a7608b$var$Ua(a));
}
function $e09959a092a7608b$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e09959a092a7608b$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e09959a092a7608b$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e09959a092a7608b$var$Ya(a, b) {
    var c = b.checked;
    return $e09959a092a7608b$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e09959a092a7608b$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e09959a092a7608b$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e09959a092a7608b$var$ab(a, b) {
    b = b.checked;
    null != b && $e09959a092a7608b$var$ta(a, "checked", b, !1);
}
function $e09959a092a7608b$var$bb(a, b) {
    $e09959a092a7608b$var$ab(a, b);
    var c = $e09959a092a7608b$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e09959a092a7608b$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e09959a092a7608b$var$cb(a, b.type, $e09959a092a7608b$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e09959a092a7608b$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e09959a092a7608b$var$cb(a, b, c) {
    if ("number" !== b || $e09959a092a7608b$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e09959a092a7608b$var$eb = Array.isArray;
function $e09959a092a7608b$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e09959a092a7608b$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e09959a092a7608b$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e09959a092a7608b$var$p(91));
    return $e09959a092a7608b$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e09959a092a7608b$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e09959a092a7608b$var$p(92));
            if ($e09959a092a7608b$var$eb(c)) {
                if (1 < c.length) throw Error($e09959a092a7608b$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e09959a092a7608b$var$Sa(c)
    };
}
function $e09959a092a7608b$var$ib(a, b) {
    var c = $e09959a092a7608b$var$Sa(b.value), d = $e09959a092a7608b$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e09959a092a7608b$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e09959a092a7608b$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e09959a092a7608b$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e09959a092a7608b$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e09959a092a7608b$var$mb, $e09959a092a7608b$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e09959a092a7608b$var$mb = $e09959a092a7608b$var$mb || document.createElement("div");
        $e09959a092a7608b$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e09959a092a7608b$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e09959a092a7608b$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e09959a092a7608b$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e09959a092a7608b$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e09959a092a7608b$var$pb).forEach(function(a) {
    $e09959a092a7608b$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e09959a092a7608b$var$pb[b] = $e09959a092a7608b$var$pb[a];
    });
});
function $e09959a092a7608b$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e09959a092a7608b$var$pb.hasOwnProperty(a) && $e09959a092a7608b$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e09959a092a7608b$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e09959a092a7608b$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e09959a092a7608b$var$tb = $e09959a092a7608b$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e09959a092a7608b$var$ub(a, b) {
    if (b) {
        if ($e09959a092a7608b$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e09959a092a7608b$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e09959a092a7608b$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e09959a092a7608b$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e09959a092a7608b$var$p(62));
    }
}
function $e09959a092a7608b$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e09959a092a7608b$var$wb = null;
function $e09959a092a7608b$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e09959a092a7608b$var$yb = null, $e09959a092a7608b$var$zb = null, $e09959a092a7608b$var$Ab = null;
function $e09959a092a7608b$var$Bb(a) {
    if (a = $e09959a092a7608b$var$Cb(a)) {
        if ("function" !== typeof $e09959a092a7608b$var$yb) throw Error($e09959a092a7608b$var$p(280));
        var b = a.stateNode;
        b && (b = $e09959a092a7608b$var$Db(b), $e09959a092a7608b$var$yb(a.stateNode, a.type, b));
    }
}
function $e09959a092a7608b$var$Eb(a) {
    $e09959a092a7608b$var$zb ? $e09959a092a7608b$var$Ab ? $e09959a092a7608b$var$Ab.push(a) : $e09959a092a7608b$var$Ab = [
        a
    ] : $e09959a092a7608b$var$zb = a;
}
function $e09959a092a7608b$var$Fb() {
    if ($e09959a092a7608b$var$zb) {
        var a = $e09959a092a7608b$var$zb, b = $e09959a092a7608b$var$Ab;
        $e09959a092a7608b$var$Ab = $e09959a092a7608b$var$zb = null;
        $e09959a092a7608b$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e09959a092a7608b$var$Bb(b[a]);
    }
}
function $e09959a092a7608b$var$Gb(a, b) {
    return a(b);
}
function $e09959a092a7608b$var$Hb() {}
var $e09959a092a7608b$var$Ib = !1;
function $e09959a092a7608b$var$Jb(a, b, c) {
    if ($e09959a092a7608b$var$Ib) return a(b, c);
    $e09959a092a7608b$var$Ib = !0;
    try {
        return $e09959a092a7608b$var$Gb(a, b, c);
    } finally{
        if ($e09959a092a7608b$var$Ib = !1, null !== $e09959a092a7608b$var$zb || null !== $e09959a092a7608b$var$Ab) $e09959a092a7608b$var$Hb(), $e09959a092a7608b$var$Fb();
    }
}
function $e09959a092a7608b$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e09959a092a7608b$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e09959a092a7608b$var$p(231, b, typeof c));
    return c;
}
var $e09959a092a7608b$var$Lb = !1;
if ($e09959a092a7608b$var$ia) try {
    var $e09959a092a7608b$var$Mb = {};
    Object.defineProperty($e09959a092a7608b$var$Mb, "passive", {
        get: function() {
            $e09959a092a7608b$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e09959a092a7608b$var$Mb, $e09959a092a7608b$var$Mb);
    window.removeEventListener("test", $e09959a092a7608b$var$Mb, $e09959a092a7608b$var$Mb);
} catch (a) {
    $e09959a092a7608b$var$Lb = !1;
}
function $e09959a092a7608b$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e09959a092a7608b$var$Ob = !1, $e09959a092a7608b$var$Pb = null, $e09959a092a7608b$var$Qb = !1, $e09959a092a7608b$var$Rb = null, $e09959a092a7608b$var$Sb = {
    onError: function(a) {
        $e09959a092a7608b$var$Ob = !0;
        $e09959a092a7608b$var$Pb = a;
    }
};
function $e09959a092a7608b$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e09959a092a7608b$var$Ob = !1;
    $e09959a092a7608b$var$Pb = null;
    $e09959a092a7608b$var$Nb.apply($e09959a092a7608b$var$Sb, arguments);
}
function $e09959a092a7608b$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e09959a092a7608b$var$Tb.apply(this, arguments);
    if ($e09959a092a7608b$var$Ob) {
        if ($e09959a092a7608b$var$Ob) {
            var l = $e09959a092a7608b$var$Pb;
            $e09959a092a7608b$var$Ob = !1;
            $e09959a092a7608b$var$Pb = null;
        } else throw Error($e09959a092a7608b$var$p(198));
        $e09959a092a7608b$var$Qb || ($e09959a092a7608b$var$Qb = !0, $e09959a092a7608b$var$Rb = l);
    }
}
function $e09959a092a7608b$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e09959a092a7608b$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e09959a092a7608b$var$Xb(a) {
    if ($e09959a092a7608b$var$Vb(a) !== a) throw Error($e09959a092a7608b$var$p(188));
}
function $e09959a092a7608b$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e09959a092a7608b$var$Vb(a);
        if (null === b) throw Error($e09959a092a7608b$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e09959a092a7608b$var$Xb(e), a;
                if (f === d) return $e09959a092a7608b$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e09959a092a7608b$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e09959a092a7608b$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e09959a092a7608b$var$p(190));
    }
    if (3 !== c.tag) throw Error($e09959a092a7608b$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e09959a092a7608b$var$Zb(a) {
    a = $e09959a092a7608b$var$Yb(a);
    return null !== a ? $e09959a092a7608b$var$$b(a) : null;
}
function $e09959a092a7608b$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e09959a092a7608b$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e09959a092a7608b$var$ac = $7DCtq.unstable_scheduleCallback, $e09959a092a7608b$var$bc = $7DCtq.unstable_cancelCallback, $e09959a092a7608b$var$cc = $7DCtq.unstable_shouldYield, $e09959a092a7608b$var$dc = $7DCtq.unstable_requestPaint, $e09959a092a7608b$var$B = $7DCtq.unstable_now, $e09959a092a7608b$var$ec = $7DCtq.unstable_getCurrentPriorityLevel, $e09959a092a7608b$var$fc = $7DCtq.unstable_ImmediatePriority, $e09959a092a7608b$var$gc = $7DCtq.unstable_UserBlockingPriority, $e09959a092a7608b$var$hc = $7DCtq.unstable_NormalPriority, $e09959a092a7608b$var$ic = $7DCtq.unstable_LowPriority, $e09959a092a7608b$var$jc = $7DCtq.unstable_IdlePriority, $e09959a092a7608b$var$kc = null, $e09959a092a7608b$var$lc = null;
function $e09959a092a7608b$var$mc(a) {
    if ($e09959a092a7608b$var$lc && "function" === typeof $e09959a092a7608b$var$lc.onCommitFiberRoot) try {
        $e09959a092a7608b$var$lc.onCommitFiberRoot($e09959a092a7608b$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e09959a092a7608b$var$oc = Math.clz32 ? Math.clz32 : $e09959a092a7608b$var$nc, $e09959a092a7608b$var$pc = Math.log, $e09959a092a7608b$var$qc = Math.LN2;
function $e09959a092a7608b$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e09959a092a7608b$var$pc(a) / $e09959a092a7608b$var$qc | 0) | 0;
}
var $e09959a092a7608b$var$rc = 64, $e09959a092a7608b$var$sc = 4194304;
function $e09959a092a7608b$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e09959a092a7608b$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e09959a092a7608b$var$tc(h) : (f &= g, 0 !== f && (d = $e09959a092a7608b$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e09959a092a7608b$var$tc(g) : 0 !== f && (d = $e09959a092a7608b$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e09959a092a7608b$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e09959a092a7608b$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e09959a092a7608b$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e09959a092a7608b$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e09959a092a7608b$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e09959a092a7608b$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e09959a092a7608b$var$yc() {
    var a = $e09959a092a7608b$var$rc;
    $e09959a092a7608b$var$rc <<= 1;
    0 === ($e09959a092a7608b$var$rc & 4194240) && ($e09959a092a7608b$var$rc = 64);
    return a;
}
function $e09959a092a7608b$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e09959a092a7608b$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e09959a092a7608b$var$oc(b);
    a[b] = c;
}
function $e09959a092a7608b$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e09959a092a7608b$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e09959a092a7608b$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e09959a092a7608b$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e09959a092a7608b$var$C = 0;
function $e09959a092a7608b$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e09959a092a7608b$var$Ec, $e09959a092a7608b$var$Fc, $e09959a092a7608b$var$Gc, $e09959a092a7608b$var$Hc, $e09959a092a7608b$var$Ic, $e09959a092a7608b$var$Jc = !1, $e09959a092a7608b$var$Kc = [], $e09959a092a7608b$var$Lc = null, $e09959a092a7608b$var$Mc = null, $e09959a092a7608b$var$Nc = null, $e09959a092a7608b$var$Oc = new Map, $e09959a092a7608b$var$Pc = new Map, $e09959a092a7608b$var$Qc = [], $e09959a092a7608b$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e09959a092a7608b$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e09959a092a7608b$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e09959a092a7608b$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e09959a092a7608b$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e09959a092a7608b$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e09959a092a7608b$var$Pc.delete(b.pointerId);
    }
}
function $e09959a092a7608b$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e09959a092a7608b$var$Cb(b), null !== b && $e09959a092a7608b$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e09959a092a7608b$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e09959a092a7608b$var$Lc = $e09959a092a7608b$var$Tc($e09959a092a7608b$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e09959a092a7608b$var$Mc = $e09959a092a7608b$var$Tc($e09959a092a7608b$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e09959a092a7608b$var$Nc = $e09959a092a7608b$var$Tc($e09959a092a7608b$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e09959a092a7608b$var$Oc.set(f, $e09959a092a7608b$var$Tc($e09959a092a7608b$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e09959a092a7608b$var$Pc.set(f, $e09959a092a7608b$var$Tc($e09959a092a7608b$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e09959a092a7608b$var$Vc(a) {
    var b = $e09959a092a7608b$var$Wc(a.target);
    if (null !== b) {
        var c = $e09959a092a7608b$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e09959a092a7608b$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e09959a092a7608b$var$Ic(a.priority, function() {
                        $e09959a092a7608b$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e09959a092a7608b$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e09959a092a7608b$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e09959a092a7608b$var$wb = d;
            c.target.dispatchEvent(d);
            $e09959a092a7608b$var$wb = null;
        } else return b = $e09959a092a7608b$var$Cb(c), null !== b && $e09959a092a7608b$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e09959a092a7608b$var$Zc(a, b, c) {
    $e09959a092a7608b$var$Xc(a) && c.delete(b);
}
function $e09959a092a7608b$var$$c() {
    $e09959a092a7608b$var$Jc = !1;
    null !== $e09959a092a7608b$var$Lc && $e09959a092a7608b$var$Xc($e09959a092a7608b$var$Lc) && ($e09959a092a7608b$var$Lc = null);
    null !== $e09959a092a7608b$var$Mc && $e09959a092a7608b$var$Xc($e09959a092a7608b$var$Mc) && ($e09959a092a7608b$var$Mc = null);
    null !== $e09959a092a7608b$var$Nc && $e09959a092a7608b$var$Xc($e09959a092a7608b$var$Nc) && ($e09959a092a7608b$var$Nc = null);
    $e09959a092a7608b$var$Oc.forEach($e09959a092a7608b$var$Zc);
    $e09959a092a7608b$var$Pc.forEach($e09959a092a7608b$var$Zc);
}
function $e09959a092a7608b$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e09959a092a7608b$var$Jc || ($e09959a092a7608b$var$Jc = !0, $7DCtq.unstable_scheduleCallback($7DCtq.unstable_NormalPriority, $e09959a092a7608b$var$$c)));
}
function $e09959a092a7608b$var$bd(a) {
    function b(b) {
        return $e09959a092a7608b$var$ad(b, a);
    }
    if (0 < $e09959a092a7608b$var$Kc.length) {
        $e09959a092a7608b$var$ad($e09959a092a7608b$var$Kc[0], a);
        for(var c = 1; c < $e09959a092a7608b$var$Kc.length; c++){
            var d = $e09959a092a7608b$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e09959a092a7608b$var$Lc && $e09959a092a7608b$var$ad($e09959a092a7608b$var$Lc, a);
    null !== $e09959a092a7608b$var$Mc && $e09959a092a7608b$var$ad($e09959a092a7608b$var$Mc, a);
    null !== $e09959a092a7608b$var$Nc && $e09959a092a7608b$var$ad($e09959a092a7608b$var$Nc, a);
    $e09959a092a7608b$var$Oc.forEach(b);
    $e09959a092a7608b$var$Pc.forEach(b);
    for(c = 0; c < $e09959a092a7608b$var$Qc.length; c++)d = $e09959a092a7608b$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e09959a092a7608b$var$Qc.length && (c = $e09959a092a7608b$var$Qc[0], null === c.blockedOn);)$e09959a092a7608b$var$Vc(c), null === c.blockedOn && $e09959a092a7608b$var$Qc.shift();
}
var $e09959a092a7608b$var$cd = $e09959a092a7608b$var$ua.ReactCurrentBatchConfig, $e09959a092a7608b$var$dd = !0;
function $e09959a092a7608b$var$ed(a, b, c, d) {
    var e = $e09959a092a7608b$var$C, f = $e09959a092a7608b$var$cd.transition;
    $e09959a092a7608b$var$cd.transition = null;
    try {
        $e09959a092a7608b$var$C = 1, $e09959a092a7608b$var$fd(a, b, c, d);
    } finally{
        $e09959a092a7608b$var$C = e, $e09959a092a7608b$var$cd.transition = f;
    }
}
function $e09959a092a7608b$var$gd(a, b, c, d) {
    var e = $e09959a092a7608b$var$C, f = $e09959a092a7608b$var$cd.transition;
    $e09959a092a7608b$var$cd.transition = null;
    try {
        $e09959a092a7608b$var$C = 4, $e09959a092a7608b$var$fd(a, b, c, d);
    } finally{
        $e09959a092a7608b$var$C = e, $e09959a092a7608b$var$cd.transition = f;
    }
}
function $e09959a092a7608b$var$fd(a, b, c, d) {
    if ($e09959a092a7608b$var$dd) {
        var e = $e09959a092a7608b$var$Yc(a, b, c, d);
        if (null === e) $e09959a092a7608b$var$hd(a, b, d, $e09959a092a7608b$var$id, c), $e09959a092a7608b$var$Sc(a, d);
        else if ($e09959a092a7608b$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e09959a092a7608b$var$Sc(a, d), b & 4 && -1 < $e09959a092a7608b$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e09959a092a7608b$var$Cb(e);
                null !== f && $e09959a092a7608b$var$Ec(f);
                f = $e09959a092a7608b$var$Yc(a, b, c, d);
                null === f && $e09959a092a7608b$var$hd(a, b, d, $e09959a092a7608b$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e09959a092a7608b$var$hd(a, b, d, null, c);
    }
}
var $e09959a092a7608b$var$id = null;
function $e09959a092a7608b$var$Yc(a, b, c, d) {
    $e09959a092a7608b$var$id = null;
    a = $e09959a092a7608b$var$xb(d);
    a = $e09959a092a7608b$var$Wc(a);
    if (null !== a) {
        if (b = $e09959a092a7608b$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e09959a092a7608b$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e09959a092a7608b$var$id = a;
    return null;
}
function $e09959a092a7608b$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e09959a092a7608b$var$ec()){
                case $e09959a092a7608b$var$fc:
                    return 1;
                case $e09959a092a7608b$var$gc:
                    return 4;
                case $e09959a092a7608b$var$hc:
                case $e09959a092a7608b$var$ic:
                    return 16;
                case $e09959a092a7608b$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e09959a092a7608b$var$kd = null, $e09959a092a7608b$var$ld = null, $e09959a092a7608b$var$md = null;
function $e09959a092a7608b$var$nd() {
    if ($e09959a092a7608b$var$md) return $e09959a092a7608b$var$md;
    var a, b = $e09959a092a7608b$var$ld, c = b.length, d, e = "value" in $e09959a092a7608b$var$kd ? $e09959a092a7608b$var$kd.value : $e09959a092a7608b$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e09959a092a7608b$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e09959a092a7608b$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e09959a092a7608b$var$pd() {
    return !0;
}
function $e09959a092a7608b$var$qd() {
    return !1;
}
function $e09959a092a7608b$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e09959a092a7608b$var$pd : $e09959a092a7608b$var$qd;
        this.isPropagationStopped = $e09959a092a7608b$var$qd;
        return this;
    }
    $e09959a092a7608b$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e09959a092a7608b$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e09959a092a7608b$var$pd);
        },
        persist: function() {},
        isPersistent: $e09959a092a7608b$var$pd
    });
    return b;
}
var $e09959a092a7608b$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e09959a092a7608b$var$td = $e09959a092a7608b$var$rd($e09959a092a7608b$var$sd), $e09959a092a7608b$var$ud = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$sd, {
    view: 0,
    detail: 0
}), $e09959a092a7608b$var$vd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$ud), $e09959a092a7608b$var$wd, $e09959a092a7608b$var$xd, $e09959a092a7608b$var$yd, $e09959a092a7608b$var$Ad = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e09959a092a7608b$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e09959a092a7608b$var$yd && ($e09959a092a7608b$var$yd && "mousemove" === a.type ? ($e09959a092a7608b$var$wd = a.screenX - $e09959a092a7608b$var$yd.screenX, $e09959a092a7608b$var$xd = a.screenY - $e09959a092a7608b$var$yd.screenY) : $e09959a092a7608b$var$xd = $e09959a092a7608b$var$wd = 0, $e09959a092a7608b$var$yd = a);
        return $e09959a092a7608b$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e09959a092a7608b$var$xd;
    }
}), $e09959a092a7608b$var$Bd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Ad), $e09959a092a7608b$var$Cd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$Ad, {
    dataTransfer: 0
}), $e09959a092a7608b$var$Dd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Cd), $e09959a092a7608b$var$Ed = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$ud, {
    relatedTarget: 0
}), $e09959a092a7608b$var$Fd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Ed), $e09959a092a7608b$var$Gd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e09959a092a7608b$var$Hd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Gd), $e09959a092a7608b$var$Id = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e09959a092a7608b$var$Jd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Id), $e09959a092a7608b$var$Kd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$sd, {
    data: 0
}), $e09959a092a7608b$var$Ld = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Kd), $e09959a092a7608b$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e09959a092a7608b$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e09959a092a7608b$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e09959a092a7608b$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e09959a092a7608b$var$Od[a]) ? !!b[a] : !1;
}
function $e09959a092a7608b$var$zd() {
    return $e09959a092a7608b$var$Pd;
}
var $e09959a092a7608b$var$Qd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e09959a092a7608b$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e09959a092a7608b$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e09959a092a7608b$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e09959a092a7608b$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e09959a092a7608b$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e09959a092a7608b$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e09959a092a7608b$var$Rd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Qd), $e09959a092a7608b$var$Sd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e09959a092a7608b$var$Td = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Sd), $e09959a092a7608b$var$Ud = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e09959a092a7608b$var$zd
}), $e09959a092a7608b$var$Vd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Ud), $e09959a092a7608b$var$Wd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e09959a092a7608b$var$Xd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Wd), $e09959a092a7608b$var$Yd = $e09959a092a7608b$var$A({}, $e09959a092a7608b$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e09959a092a7608b$var$Zd = $e09959a092a7608b$var$rd($e09959a092a7608b$var$Yd), $e09959a092a7608b$var$$d = [
    9,
    13,
    27,
    32
], $e09959a092a7608b$var$ae = $e09959a092a7608b$var$ia && "CompositionEvent" in window, $e09959a092a7608b$var$be = null;
$e09959a092a7608b$var$ia && "documentMode" in document && ($e09959a092a7608b$var$be = document.documentMode);
var $e09959a092a7608b$var$ce = $e09959a092a7608b$var$ia && "TextEvent" in window && !$e09959a092a7608b$var$be, $e09959a092a7608b$var$de = $e09959a092a7608b$var$ia && (!$e09959a092a7608b$var$ae || $e09959a092a7608b$var$be && 8 < $e09959a092a7608b$var$be && 11 >= $e09959a092a7608b$var$be), $e09959a092a7608b$var$ee = String.fromCharCode(32), $e09959a092a7608b$var$fe = !1;
function $e09959a092a7608b$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e09959a092a7608b$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e09959a092a7608b$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e09959a092a7608b$var$ie = !1;
function $e09959a092a7608b$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e09959a092a7608b$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e09959a092a7608b$var$fe = !0;
            return $e09959a092a7608b$var$ee;
        case "textInput":
            return a = b.data, a === $e09959a092a7608b$var$ee && $e09959a092a7608b$var$fe ? null : a;
        default:
            return null;
    }
}
function $e09959a092a7608b$var$ke(a, b) {
    if ($e09959a092a7608b$var$ie) return "compositionend" === a || !$e09959a092a7608b$var$ae && $e09959a092a7608b$var$ge(a, b) ? (a = $e09959a092a7608b$var$nd(), $e09959a092a7608b$var$md = $e09959a092a7608b$var$ld = $e09959a092a7608b$var$kd = null, $e09959a092a7608b$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e09959a092a7608b$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e09959a092a7608b$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e09959a092a7608b$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e09959a092a7608b$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e09959a092a7608b$var$ne(a, b, c, d) {
    $e09959a092a7608b$var$Eb(d);
    b = $e09959a092a7608b$var$oe(b, "onChange");
    0 < b.length && (c = new $e09959a092a7608b$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e09959a092a7608b$var$pe = null, $e09959a092a7608b$var$qe = null;
function $e09959a092a7608b$var$re(a) {
    $e09959a092a7608b$var$se(a, 0);
}
function $e09959a092a7608b$var$te(a) {
    var b = $e09959a092a7608b$var$ue(a);
    if ($e09959a092a7608b$var$Wa(b)) return a;
}
function $e09959a092a7608b$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e09959a092a7608b$var$we = !1;
if ($e09959a092a7608b$var$ia) {
    var $e09959a092a7608b$var$xe;
    if ($e09959a092a7608b$var$ia) {
        var $e09959a092a7608b$var$ye = "oninput" in document;
        if (!$e09959a092a7608b$var$ye) {
            var $e09959a092a7608b$var$ze = document.createElement("div");
            $e09959a092a7608b$var$ze.setAttribute("oninput", "return;");
            $e09959a092a7608b$var$ye = "function" === typeof $e09959a092a7608b$var$ze.oninput;
        }
        $e09959a092a7608b$var$xe = $e09959a092a7608b$var$ye;
    } else $e09959a092a7608b$var$xe = !1;
    $e09959a092a7608b$var$we = $e09959a092a7608b$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e09959a092a7608b$var$Ae() {
    $e09959a092a7608b$var$pe && ($e09959a092a7608b$var$pe.detachEvent("onpropertychange", $e09959a092a7608b$var$Be), $e09959a092a7608b$var$qe = $e09959a092a7608b$var$pe = null);
}
function $e09959a092a7608b$var$Be(a) {
    if ("value" === a.propertyName && $e09959a092a7608b$var$te($e09959a092a7608b$var$qe)) {
        var b = [];
        $e09959a092a7608b$var$ne(b, $e09959a092a7608b$var$qe, a, $e09959a092a7608b$var$xb(a));
        $e09959a092a7608b$var$Jb($e09959a092a7608b$var$re, b);
    }
}
function $e09959a092a7608b$var$Ce(a, b, c) {
    "focusin" === a ? ($e09959a092a7608b$var$Ae(), $e09959a092a7608b$var$pe = b, $e09959a092a7608b$var$qe = c, $e09959a092a7608b$var$pe.attachEvent("onpropertychange", $e09959a092a7608b$var$Be)) : "focusout" === a && $e09959a092a7608b$var$Ae();
}
function $e09959a092a7608b$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e09959a092a7608b$var$te($e09959a092a7608b$var$qe);
}
function $e09959a092a7608b$var$Ee(a, b) {
    if ("click" === a) return $e09959a092a7608b$var$te(b);
}
function $e09959a092a7608b$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e09959a092a7608b$var$te(b);
}
function $e09959a092a7608b$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e09959a092a7608b$var$He = "function" === typeof Object.is ? Object.is : $e09959a092a7608b$var$Ge;
function $e09959a092a7608b$var$Ie(a, b) {
    if ($e09959a092a7608b$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e09959a092a7608b$var$ja.call(b, e) || !$e09959a092a7608b$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e09959a092a7608b$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e09959a092a7608b$var$Ke(a, b) {
    var c = $e09959a092a7608b$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e09959a092a7608b$var$Je(c);
    }
}
function $e09959a092a7608b$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e09959a092a7608b$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e09959a092a7608b$var$Me() {
    for(var a = window, b = $e09959a092a7608b$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e09959a092a7608b$var$Xa(a.document);
    }
    return b;
}
function $e09959a092a7608b$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e09959a092a7608b$var$Oe(a) {
    var b = $e09959a092a7608b$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e09959a092a7608b$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e09959a092a7608b$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e09959a092a7608b$var$Ke(c, f);
                var g = $e09959a092a7608b$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e09959a092a7608b$var$Pe = $e09959a092a7608b$var$ia && "documentMode" in document && 11 >= document.documentMode, $e09959a092a7608b$var$Qe = null, $e09959a092a7608b$var$Re = null, $e09959a092a7608b$var$Se = null, $e09959a092a7608b$var$Te = !1;
function $e09959a092a7608b$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e09959a092a7608b$var$Te || null == $e09959a092a7608b$var$Qe || $e09959a092a7608b$var$Qe !== $e09959a092a7608b$var$Xa(d) || (d = $e09959a092a7608b$var$Qe, "selectionStart" in d && $e09959a092a7608b$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e09959a092a7608b$var$Se && $e09959a092a7608b$var$Ie($e09959a092a7608b$var$Se, d) || ($e09959a092a7608b$var$Se = d, d = $e09959a092a7608b$var$oe($e09959a092a7608b$var$Re, "onSelect"), 0 < d.length && (b = new $e09959a092a7608b$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e09959a092a7608b$var$Qe)));
}
function $e09959a092a7608b$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e09959a092a7608b$var$We = {
    animationend: $e09959a092a7608b$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e09959a092a7608b$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e09959a092a7608b$var$Ve("Animation", "AnimationStart"),
    transitionend: $e09959a092a7608b$var$Ve("Transition", "TransitionEnd")
}, $e09959a092a7608b$var$Xe = {}, $e09959a092a7608b$var$Ye = {};
$e09959a092a7608b$var$ia && ($e09959a092a7608b$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e09959a092a7608b$var$We.animationend.animation, delete $e09959a092a7608b$var$We.animationiteration.animation, delete $e09959a092a7608b$var$We.animationstart.animation), "TransitionEvent" in window || delete $e09959a092a7608b$var$We.transitionend.transition);
function $e09959a092a7608b$var$Ze(a) {
    if ($e09959a092a7608b$var$Xe[a]) return $e09959a092a7608b$var$Xe[a];
    if (!$e09959a092a7608b$var$We[a]) return a;
    var b = $e09959a092a7608b$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e09959a092a7608b$var$Ye) return $e09959a092a7608b$var$Xe[a] = b[c];
    return a;
}
var $e09959a092a7608b$var$$e = $e09959a092a7608b$var$Ze("animationend"), $e09959a092a7608b$var$af = $e09959a092a7608b$var$Ze("animationiteration"), $e09959a092a7608b$var$bf = $e09959a092a7608b$var$Ze("animationstart"), $e09959a092a7608b$var$cf = $e09959a092a7608b$var$Ze("transitionend"), $e09959a092a7608b$var$df = new Map, $e09959a092a7608b$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e09959a092a7608b$var$ff(a, b) {
    $e09959a092a7608b$var$df.set(a, b);
    $e09959a092a7608b$var$fa(b, [
        a
    ]);
}
for(var $e09959a092a7608b$var$gf = 0; $e09959a092a7608b$var$gf < $e09959a092a7608b$var$ef.length; $e09959a092a7608b$var$gf++){
    var $e09959a092a7608b$var$hf = $e09959a092a7608b$var$ef[$e09959a092a7608b$var$gf], $e09959a092a7608b$var$jf = $e09959a092a7608b$var$hf.toLowerCase(), $e09959a092a7608b$var$kf = $e09959a092a7608b$var$hf[0].toUpperCase() + $e09959a092a7608b$var$hf.slice(1);
    $e09959a092a7608b$var$ff($e09959a092a7608b$var$jf, "on" + $e09959a092a7608b$var$kf);
}
$e09959a092a7608b$var$ff($e09959a092a7608b$var$$e, "onAnimationEnd");
$e09959a092a7608b$var$ff($e09959a092a7608b$var$af, "onAnimationIteration");
$e09959a092a7608b$var$ff($e09959a092a7608b$var$bf, "onAnimationStart");
$e09959a092a7608b$var$ff("dblclick", "onDoubleClick");
$e09959a092a7608b$var$ff("focusin", "onFocus");
$e09959a092a7608b$var$ff("focusout", "onBlur");
$e09959a092a7608b$var$ff($e09959a092a7608b$var$cf, "onTransitionEnd");
$e09959a092a7608b$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e09959a092a7608b$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e09959a092a7608b$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e09959a092a7608b$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e09959a092a7608b$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e09959a092a7608b$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e09959a092a7608b$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e09959a092a7608b$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e09959a092a7608b$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e09959a092a7608b$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e09959a092a7608b$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e09959a092a7608b$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e09959a092a7608b$var$lf));
function $e09959a092a7608b$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e09959a092a7608b$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e09959a092a7608b$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e09959a092a7608b$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e09959a092a7608b$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e09959a092a7608b$var$Qb) throw a = $e09959a092a7608b$var$Rb, $e09959a092a7608b$var$Qb = !1, $e09959a092a7608b$var$Rb = null, a;
}
function $e09959a092a7608b$var$D(a, b) {
    var c = b[$e09959a092a7608b$var$of];
    void 0 === c && (c = b[$e09959a092a7608b$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e09959a092a7608b$var$pf(b, a, 2, !1), c.add(d));
}
function $e09959a092a7608b$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e09959a092a7608b$var$pf(c, a, d, b);
}
var $e09959a092a7608b$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e09959a092a7608b$var$sf(a) {
    if (!a[$e09959a092a7608b$var$rf]) {
        a[$e09959a092a7608b$var$rf] = !0;
        $e09959a092a7608b$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e09959a092a7608b$var$mf.has(b) || $e09959a092a7608b$var$qf(b, !1, a), $e09959a092a7608b$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e09959a092a7608b$var$rf] || (b[$e09959a092a7608b$var$rf] = !0, $e09959a092a7608b$var$qf("selectionchange", !1, b));
    }
}
function $e09959a092a7608b$var$pf(a, b, c, d) {
    switch($e09959a092a7608b$var$jd(b)){
        case 1:
            var e = $e09959a092a7608b$var$ed;
            break;
        case 4:
            e = $e09959a092a7608b$var$gd;
            break;
        default:
            e = $e09959a092a7608b$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e09959a092a7608b$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e09959a092a7608b$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e09959a092a7608b$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e09959a092a7608b$var$Jb(function() {
        var d = f, e = $e09959a092a7608b$var$xb(c), g = [];
        a: {
            var h = $e09959a092a7608b$var$df.get(a);
            if (void 0 !== h) {
                var k = $e09959a092a7608b$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e09959a092a7608b$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e09959a092a7608b$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e09959a092a7608b$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e09959a092a7608b$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e09959a092a7608b$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e09959a092a7608b$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e09959a092a7608b$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e09959a092a7608b$var$Vd;
                        break;
                    case $e09959a092a7608b$var$$e:
                    case $e09959a092a7608b$var$af:
                    case $e09959a092a7608b$var$bf:
                        k = $e09959a092a7608b$var$Hd;
                        break;
                    case $e09959a092a7608b$var$cf:
                        k = $e09959a092a7608b$var$Xd;
                        break;
                    case "scroll":
                        k = $e09959a092a7608b$var$vd;
                        break;
                    case "wheel":
                        k = $e09959a092a7608b$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e09959a092a7608b$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e09959a092a7608b$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e09959a092a7608b$var$Kb(w, x), null != F && t.push($e09959a092a7608b$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e09959a092a7608b$var$wb && (n = c.relatedTarget || c.fromElement) && ($e09959a092a7608b$var$Wc(n) || n[$e09959a092a7608b$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e09959a092a7608b$var$Wc(n) : null, null !== n && (J = $e09959a092a7608b$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e09959a092a7608b$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e09959a092a7608b$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e09959a092a7608b$var$ue(k);
                        u = null == n ? h : $e09959a092a7608b$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e09959a092a7608b$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e09959a092a7608b$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e09959a092a7608b$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e09959a092a7608b$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e09959a092a7608b$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e09959a092a7608b$var$vf(t);
                                x = $e09959a092a7608b$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e09959a092a7608b$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e09959a092a7608b$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e09959a092a7608b$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e09959a092a7608b$var$ve;
                else if ($e09959a092a7608b$var$me(h)) {
                    if ($e09959a092a7608b$var$we) na = $e09959a092a7608b$var$Fe;
                    else {
                        na = $e09959a092a7608b$var$De;
                        var xa = $e09959a092a7608b$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e09959a092a7608b$var$Ee);
                if (na && (na = na(a, d))) {
                    $e09959a092a7608b$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e09959a092a7608b$var$cb(h, "number", h.value);
            }
            xa = d ? $e09959a092a7608b$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e09959a092a7608b$var$me(xa) || "true" === xa.contentEditable) $e09959a092a7608b$var$Qe = xa, $e09959a092a7608b$var$Re = d, $e09959a092a7608b$var$Se = null;
                    break;
                case "focusout":
                    $e09959a092a7608b$var$Se = $e09959a092a7608b$var$Re = $e09959a092a7608b$var$Qe = null;
                    break;
                case "mousedown":
                    $e09959a092a7608b$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e09959a092a7608b$var$Te = !1;
                    $e09959a092a7608b$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e09959a092a7608b$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e09959a092a7608b$var$Ue(g, c, e);
            }
            var $a;
            if ($e09959a092a7608b$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e09959a092a7608b$var$ie ? $e09959a092a7608b$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e09959a092a7608b$var$de && "ko" !== c.locale && ($e09959a092a7608b$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e09959a092a7608b$var$ie && ($a = $e09959a092a7608b$var$nd()) : ($e09959a092a7608b$var$kd = e, $e09959a092a7608b$var$ld = "value" in $e09959a092a7608b$var$kd ? $e09959a092a7608b$var$kd.value : $e09959a092a7608b$var$kd.textContent, $e09959a092a7608b$var$ie = !0)), xa = $e09959a092a7608b$var$oe(d, ba), 0 < xa.length && (ba = new $e09959a092a7608b$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e09959a092a7608b$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e09959a092a7608b$var$ce ? $e09959a092a7608b$var$je(a, c) : $e09959a092a7608b$var$ke(a, c)) d = $e09959a092a7608b$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e09959a092a7608b$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e09959a092a7608b$var$se(g, b);
    });
}
function $e09959a092a7608b$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e09959a092a7608b$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e09959a092a7608b$var$Kb(a, c), null != f && d.unshift($e09959a092a7608b$var$tf(a, f, e)), f = $e09959a092a7608b$var$Kb(a, b), null != f && d.push($e09959a092a7608b$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e09959a092a7608b$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e09959a092a7608b$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e09959a092a7608b$var$Kb(c, f), null != k && g.unshift($e09959a092a7608b$var$tf(c, k, h))) : e || (k = $e09959a092a7608b$var$Kb(c, f), null != k && g.push($e09959a092a7608b$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e09959a092a7608b$var$xf = /\r\n?/g, $e09959a092a7608b$var$yf = /\u0000|\uFFFD/g;
function $e09959a092a7608b$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e09959a092a7608b$var$xf, "\n").replace($e09959a092a7608b$var$yf, "");
}
function $e09959a092a7608b$var$Af(a, b, c) {
    b = $e09959a092a7608b$var$zf(b);
    if ($e09959a092a7608b$var$zf(a) !== b && c) throw Error($e09959a092a7608b$var$p(425));
}
function $e09959a092a7608b$var$Bf() {}
var $e09959a092a7608b$var$Cf = null, $e09959a092a7608b$var$Df = null;
function $e09959a092a7608b$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e09959a092a7608b$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e09959a092a7608b$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e09959a092a7608b$var$Hf = "function" === typeof Promise ? Promise : void 0, $e09959a092a7608b$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e09959a092a7608b$var$Hf ? function(a) {
    return $e09959a092a7608b$var$Hf.resolve(null).then(a).catch($e09959a092a7608b$var$If);
} : $e09959a092a7608b$var$Ff;
function $e09959a092a7608b$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e09959a092a7608b$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e09959a092a7608b$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e09959a092a7608b$var$bd(b);
}
function $e09959a092a7608b$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e09959a092a7608b$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e09959a092a7608b$var$Nf = Math.random().toString(36).slice(2), $e09959a092a7608b$var$Of = "__reactFiber$" + $e09959a092a7608b$var$Nf, $e09959a092a7608b$var$Pf = "__reactProps$" + $e09959a092a7608b$var$Nf, $e09959a092a7608b$var$uf = "__reactContainer$" + $e09959a092a7608b$var$Nf, $e09959a092a7608b$var$of = "__reactEvents$" + $e09959a092a7608b$var$Nf, $e09959a092a7608b$var$Qf = "__reactListeners$" + $e09959a092a7608b$var$Nf, $e09959a092a7608b$var$Rf = "__reactHandles$" + $e09959a092a7608b$var$Nf;
function $e09959a092a7608b$var$Wc(a) {
    var b = a[$e09959a092a7608b$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e09959a092a7608b$var$uf] || c[$e09959a092a7608b$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e09959a092a7608b$var$Mf(a); null !== a;){
                if (c = a[$e09959a092a7608b$var$Of]) return c;
                a = $e09959a092a7608b$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e09959a092a7608b$var$Cb(a) {
    a = a[$e09959a092a7608b$var$Of] || a[$e09959a092a7608b$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e09959a092a7608b$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e09959a092a7608b$var$p(33));
}
function $e09959a092a7608b$var$Db(a) {
    return a[$e09959a092a7608b$var$Pf] || null;
}
var $e09959a092a7608b$var$Sf = [], $e09959a092a7608b$var$Tf = -1;
function $e09959a092a7608b$var$Uf(a) {
    return {
        current: a
    };
}
function $e09959a092a7608b$var$E(a) {
    0 > $e09959a092a7608b$var$Tf || (a.current = $e09959a092a7608b$var$Sf[$e09959a092a7608b$var$Tf], $e09959a092a7608b$var$Sf[$e09959a092a7608b$var$Tf] = null, $e09959a092a7608b$var$Tf--);
}
function $e09959a092a7608b$var$G(a, b) {
    $e09959a092a7608b$var$Tf++;
    $e09959a092a7608b$var$Sf[$e09959a092a7608b$var$Tf] = a.current;
    a.current = b;
}
var $e09959a092a7608b$var$Vf = {}, $e09959a092a7608b$var$H = $e09959a092a7608b$var$Uf($e09959a092a7608b$var$Vf), $e09959a092a7608b$var$Wf = $e09959a092a7608b$var$Uf(!1), $e09959a092a7608b$var$Xf = $e09959a092a7608b$var$Vf;
function $e09959a092a7608b$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e09959a092a7608b$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e09959a092a7608b$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e09959a092a7608b$var$$f() {
    $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf);
    $e09959a092a7608b$var$E($e09959a092a7608b$var$H);
}
function $e09959a092a7608b$var$ag(a, b, c) {
    if ($e09959a092a7608b$var$H.current !== $e09959a092a7608b$var$Vf) throw Error($e09959a092a7608b$var$p(168));
    $e09959a092a7608b$var$G($e09959a092a7608b$var$H, b);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$Wf, c);
}
function $e09959a092a7608b$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e09959a092a7608b$var$p(108, $e09959a092a7608b$var$Ra(a) || "Unknown", e));
    return $e09959a092a7608b$var$A({}, c, d);
}
function $e09959a092a7608b$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e09959a092a7608b$var$Vf;
    $e09959a092a7608b$var$Xf = $e09959a092a7608b$var$H.current;
    $e09959a092a7608b$var$G($e09959a092a7608b$var$H, a);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$Wf, $e09959a092a7608b$var$Wf.current);
    return !0;
}
function $e09959a092a7608b$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e09959a092a7608b$var$p(169));
    c ? (a = $e09959a092a7608b$var$bg(a, b, $e09959a092a7608b$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf), $e09959a092a7608b$var$E($e09959a092a7608b$var$H), $e09959a092a7608b$var$G($e09959a092a7608b$var$H, a)) : $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$Wf, c);
}
var $e09959a092a7608b$var$eg = null, $e09959a092a7608b$var$fg = !1, $e09959a092a7608b$var$gg = !1;
function $e09959a092a7608b$var$hg(a) {
    null === $e09959a092a7608b$var$eg ? $e09959a092a7608b$var$eg = [
        a
    ] : $e09959a092a7608b$var$eg.push(a);
}
function $e09959a092a7608b$var$ig(a) {
    $e09959a092a7608b$var$fg = !0;
    $e09959a092a7608b$var$hg(a);
}
function $e09959a092a7608b$var$jg() {
    if (!$e09959a092a7608b$var$gg && null !== $e09959a092a7608b$var$eg) {
        $e09959a092a7608b$var$gg = !0;
        var a = 0, b = $e09959a092a7608b$var$C;
        try {
            var c = $e09959a092a7608b$var$eg;
            for($e09959a092a7608b$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e09959a092a7608b$var$eg = null;
            $e09959a092a7608b$var$fg = !1;
        } catch (e) {
            throw null !== $e09959a092a7608b$var$eg && ($e09959a092a7608b$var$eg = $e09959a092a7608b$var$eg.slice(a + 1)), $e09959a092a7608b$var$ac($e09959a092a7608b$var$fc, $e09959a092a7608b$var$jg), e;
        } finally{
            $e09959a092a7608b$var$C = b, $e09959a092a7608b$var$gg = !1;
        }
    }
    return null;
}
var $e09959a092a7608b$var$kg = [], $e09959a092a7608b$var$lg = 0, $e09959a092a7608b$var$mg = null, $e09959a092a7608b$var$ng = 0, $e09959a092a7608b$var$og = [], $e09959a092a7608b$var$pg = 0, $e09959a092a7608b$var$qg = null, $e09959a092a7608b$var$rg = 1, $e09959a092a7608b$var$sg = "";
function $e09959a092a7608b$var$tg(a, b) {
    $e09959a092a7608b$var$kg[$e09959a092a7608b$var$lg++] = $e09959a092a7608b$var$ng;
    $e09959a092a7608b$var$kg[$e09959a092a7608b$var$lg++] = $e09959a092a7608b$var$mg;
    $e09959a092a7608b$var$mg = a;
    $e09959a092a7608b$var$ng = b;
}
function $e09959a092a7608b$var$ug(a, b, c) {
    $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$rg;
    $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$sg;
    $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$qg;
    $e09959a092a7608b$var$qg = a;
    var d = $e09959a092a7608b$var$rg;
    a = $e09959a092a7608b$var$sg;
    var e = 32 - $e09959a092a7608b$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e09959a092a7608b$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e09959a092a7608b$var$rg = 1 << 32 - $e09959a092a7608b$var$oc(b) + e | c << e | d;
        $e09959a092a7608b$var$sg = f + a;
    } else $e09959a092a7608b$var$rg = 1 << f | c << e | d, $e09959a092a7608b$var$sg = a;
}
function $e09959a092a7608b$var$vg(a) {
    null !== a.return && ($e09959a092a7608b$var$tg(a, 1), $e09959a092a7608b$var$ug(a, 1, 0));
}
function $e09959a092a7608b$var$wg(a) {
    for(; a === $e09959a092a7608b$var$mg;)$e09959a092a7608b$var$mg = $e09959a092a7608b$var$kg[--$e09959a092a7608b$var$lg], $e09959a092a7608b$var$kg[$e09959a092a7608b$var$lg] = null, $e09959a092a7608b$var$ng = $e09959a092a7608b$var$kg[--$e09959a092a7608b$var$lg], $e09959a092a7608b$var$kg[$e09959a092a7608b$var$lg] = null;
    for(; a === $e09959a092a7608b$var$qg;)$e09959a092a7608b$var$qg = $e09959a092a7608b$var$og[--$e09959a092a7608b$var$pg], $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg] = null, $e09959a092a7608b$var$sg = $e09959a092a7608b$var$og[--$e09959a092a7608b$var$pg], $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg] = null, $e09959a092a7608b$var$rg = $e09959a092a7608b$var$og[--$e09959a092a7608b$var$pg], $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg] = null;
}
var $e09959a092a7608b$var$xg = null, $e09959a092a7608b$var$yg = null, $e09959a092a7608b$var$I = !1, $e09959a092a7608b$var$zg = null;
function $e09959a092a7608b$var$Ag(a, b) {
    var c = $e09959a092a7608b$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e09959a092a7608b$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e09959a092a7608b$var$xg = a, $e09959a092a7608b$var$yg = $e09959a092a7608b$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e09959a092a7608b$var$xg = a, $e09959a092a7608b$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e09959a092a7608b$var$qg ? {
                id: $e09959a092a7608b$var$rg,
                overflow: $e09959a092a7608b$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e09959a092a7608b$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e09959a092a7608b$var$xg = a, $e09959a092a7608b$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e09959a092a7608b$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e09959a092a7608b$var$Eg(a) {
    if ($e09959a092a7608b$var$I) {
        var b = $e09959a092a7608b$var$yg;
        if (b) {
            var c = b;
            if (!$e09959a092a7608b$var$Cg(a, b)) {
                if ($e09959a092a7608b$var$Dg(a)) throw Error($e09959a092a7608b$var$p(418));
                b = $e09959a092a7608b$var$Lf(c.nextSibling);
                var d = $e09959a092a7608b$var$xg;
                b && $e09959a092a7608b$var$Cg(a, b) ? $e09959a092a7608b$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e09959a092a7608b$var$I = !1, $e09959a092a7608b$var$xg = a);
            }
        } else {
            if ($e09959a092a7608b$var$Dg(a)) throw Error($e09959a092a7608b$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e09959a092a7608b$var$I = !1;
            $e09959a092a7608b$var$xg = a;
        }
    }
}
function $e09959a092a7608b$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e09959a092a7608b$var$xg = a;
}
function $e09959a092a7608b$var$Gg(a) {
    if (a !== $e09959a092a7608b$var$xg) return !1;
    if (!$e09959a092a7608b$var$I) return $e09959a092a7608b$var$Fg(a), $e09959a092a7608b$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e09959a092a7608b$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e09959a092a7608b$var$yg)) {
        if ($e09959a092a7608b$var$Dg(a)) throw $e09959a092a7608b$var$Hg(), Error($e09959a092a7608b$var$p(418));
        for(; b;)$e09959a092a7608b$var$Ag(a, b), b = $e09959a092a7608b$var$Lf(b.nextSibling);
    }
    $e09959a092a7608b$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e09959a092a7608b$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e09959a092a7608b$var$yg = $e09959a092a7608b$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e09959a092a7608b$var$yg = null;
        }
    } else $e09959a092a7608b$var$yg = $e09959a092a7608b$var$xg ? $e09959a092a7608b$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e09959a092a7608b$var$Hg() {
    for(var a = $e09959a092a7608b$var$yg; a;)a = $e09959a092a7608b$var$Lf(a.nextSibling);
}
function $e09959a092a7608b$var$Ig() {
    $e09959a092a7608b$var$yg = $e09959a092a7608b$var$xg = null;
    $e09959a092a7608b$var$I = !1;
}
function $e09959a092a7608b$var$Jg(a) {
    null === $e09959a092a7608b$var$zg ? $e09959a092a7608b$var$zg = [
        a
    ] : $e09959a092a7608b$var$zg.push(a);
}
var $e09959a092a7608b$var$Kg = $e09959a092a7608b$var$ua.ReactCurrentBatchConfig;
function $e09959a092a7608b$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e09959a092a7608b$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e09959a092a7608b$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e09959a092a7608b$var$p(284));
        if (!c._owner) throw Error($e09959a092a7608b$var$p(290, a));
    }
    return a;
}
function $e09959a092a7608b$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e09959a092a7608b$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e09959a092a7608b$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $e09959a092a7608b$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e09959a092a7608b$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e09959a092a7608b$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e09959a092a7608b$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e09959a092a7608b$var$Ha && $e09959a092a7608b$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $e09959a092a7608b$var$Lg(a, b, c), d.return = a, d;
        d = $e09959a092a7608b$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e09959a092a7608b$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e09959a092a7608b$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e09959a092a7608b$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e09959a092a7608b$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e09959a092a7608b$var$va:
                    return c = $e09959a092a7608b$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $e09959a092a7608b$var$Lg(a, null, b), c.return = a, c;
                case $e09959a092a7608b$var$wa:
                    return b = $e09959a092a7608b$var$Sg(b, a.mode, c), b.return = a, b;
                case $e09959a092a7608b$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e09959a092a7608b$var$eb(b) || $e09959a092a7608b$var$Ka(b)) return b = $e09959a092a7608b$var$Tg(b, a.mode, c, null), b.return = a, b;
            $e09959a092a7608b$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e09959a092a7608b$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e09959a092a7608b$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e09959a092a7608b$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e09959a092a7608b$var$eb(c) || $e09959a092a7608b$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e09959a092a7608b$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e09959a092a7608b$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e09959a092a7608b$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e09959a092a7608b$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e09959a092a7608b$var$eb(d) || $e09959a092a7608b$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e09959a092a7608b$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e09959a092a7608b$var$Ka(h);
        if ("function" !== typeof l) throw Error($e09959a092a7608b$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e09959a092a7608b$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e09959a092a7608b$var$I && $e09959a092a7608b$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e09959a092a7608b$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e09959a092a7608b$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e09959a092a7608b$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e09959a092a7608b$var$Ha && $e09959a092a7608b$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e09959a092a7608b$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e09959a092a7608b$var$ya ? (d = $e09959a092a7608b$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e09959a092a7608b$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $e09959a092a7608b$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e09959a092a7608b$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e09959a092a7608b$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e09959a092a7608b$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e09959a092a7608b$var$eb(f)) return n(a, d, f, h);
            if ($e09959a092a7608b$var$Ka(f)) return t(a, d, f, h);
            $e09959a092a7608b$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e09959a092a7608b$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e09959a092a7608b$var$Ug = $e09959a092a7608b$var$Og(!0), $e09959a092a7608b$var$Vg = $e09959a092a7608b$var$Og(!1), $e09959a092a7608b$var$Wg = $e09959a092a7608b$var$Uf(null), $e09959a092a7608b$var$Xg = null, $e09959a092a7608b$var$Yg = null, $e09959a092a7608b$var$Zg = null;
function $e09959a092a7608b$var$$g() {
    $e09959a092a7608b$var$Zg = $e09959a092a7608b$var$Yg = $e09959a092a7608b$var$Xg = null;
}
function $e09959a092a7608b$var$ah(a) {
    var b = $e09959a092a7608b$var$Wg.current;
    $e09959a092a7608b$var$E($e09959a092a7608b$var$Wg);
    a._currentValue = b;
}
function $e09959a092a7608b$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e09959a092a7608b$var$ch(a, b) {
    $e09959a092a7608b$var$Xg = a;
    $e09959a092a7608b$var$Zg = $e09959a092a7608b$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e09959a092a7608b$var$dh = !0), a.firstContext = null);
}
function $e09959a092a7608b$var$eh(a) {
    var b = a._currentValue;
    if ($e09959a092a7608b$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e09959a092a7608b$var$Yg) {
            if (null === $e09959a092a7608b$var$Xg) throw Error($e09959a092a7608b$var$p(308));
            $e09959a092a7608b$var$Yg = a;
            $e09959a092a7608b$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e09959a092a7608b$var$Yg = $e09959a092a7608b$var$Yg.next = a;
    }
    return b;
}
var $e09959a092a7608b$var$fh = null;
function $e09959a092a7608b$var$gh(a) {
    null === $e09959a092a7608b$var$fh ? $e09959a092a7608b$var$fh = [
        a
    ] : $e09959a092a7608b$var$fh.push(a);
}
function $e09959a092a7608b$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e09959a092a7608b$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e09959a092a7608b$var$ih(a, d);
}
function $e09959a092a7608b$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e09959a092a7608b$var$jh = !1;
function $e09959a092a7608b$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e09959a092a7608b$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e09959a092a7608b$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e09959a092a7608b$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e09959a092a7608b$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e09959a092a7608b$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e09959a092a7608b$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e09959a092a7608b$var$ih(a, c);
}
function $e09959a092a7608b$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e09959a092a7608b$var$Cc(a, c);
    }
}
function $e09959a092a7608b$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e09959a092a7608b$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $e09959a092a7608b$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e09959a092a7608b$var$A({}, q, r);
                            break a;
                        case 2:
                            $e09959a092a7608b$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e09959a092a7608b$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e09959a092a7608b$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e09959a092a7608b$var$p(191, e));
            e.call(d);
        }
    }
}
var $e09959a092a7608b$var$th = {}, $e09959a092a7608b$var$uh = $e09959a092a7608b$var$Uf($e09959a092a7608b$var$th), $e09959a092a7608b$var$vh = $e09959a092a7608b$var$Uf($e09959a092a7608b$var$th), $e09959a092a7608b$var$wh = $e09959a092a7608b$var$Uf($e09959a092a7608b$var$th);
function $e09959a092a7608b$var$xh(a) {
    if (a === $e09959a092a7608b$var$th) throw Error($e09959a092a7608b$var$p(174));
    return a;
}
function $e09959a092a7608b$var$yh(a, b) {
    $e09959a092a7608b$var$G($e09959a092a7608b$var$wh, b);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$vh, a);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$uh, $e09959a092a7608b$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e09959a092a7608b$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e09959a092a7608b$var$lb(b, a);
    }
    $e09959a092a7608b$var$E($e09959a092a7608b$var$uh);
    $e09959a092a7608b$var$G($e09959a092a7608b$var$uh, b);
}
function $e09959a092a7608b$var$zh() {
    $e09959a092a7608b$var$E($e09959a092a7608b$var$uh);
    $e09959a092a7608b$var$E($e09959a092a7608b$var$vh);
    $e09959a092a7608b$var$E($e09959a092a7608b$var$wh);
}
function $e09959a092a7608b$var$Ah(a) {
    $e09959a092a7608b$var$xh($e09959a092a7608b$var$wh.current);
    var b = $e09959a092a7608b$var$xh($e09959a092a7608b$var$uh.current);
    var c = $e09959a092a7608b$var$lb(b, a.type);
    b !== c && ($e09959a092a7608b$var$G($e09959a092a7608b$var$vh, a), $e09959a092a7608b$var$G($e09959a092a7608b$var$uh, c));
}
function $e09959a092a7608b$var$Bh(a) {
    $e09959a092a7608b$var$vh.current === a && ($e09959a092a7608b$var$E($e09959a092a7608b$var$uh), $e09959a092a7608b$var$E($e09959a092a7608b$var$vh));
}
var $e09959a092a7608b$var$L = $e09959a092a7608b$var$Uf(0);
function $e09959a092a7608b$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e09959a092a7608b$var$Dh = [];
function $e09959a092a7608b$var$Eh() {
    for(var a = 0; a < $e09959a092a7608b$var$Dh.length; a++)$e09959a092a7608b$var$Dh[a]._workInProgressVersionPrimary = null;
    $e09959a092a7608b$var$Dh.length = 0;
}
var $e09959a092a7608b$var$Fh = $e09959a092a7608b$var$ua.ReactCurrentDispatcher, $e09959a092a7608b$var$Gh = $e09959a092a7608b$var$ua.ReactCurrentBatchConfig, $e09959a092a7608b$var$Hh = 0, $e09959a092a7608b$var$M = null, $e09959a092a7608b$var$N = null, $e09959a092a7608b$var$O = null, $e09959a092a7608b$var$Ih = !1, $e09959a092a7608b$var$Jh = !1, $e09959a092a7608b$var$Kh = 0, $e09959a092a7608b$var$Lh = 0;
function $e09959a092a7608b$var$P() {
    throw Error($e09959a092a7608b$var$p(321));
}
function $e09959a092a7608b$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e09959a092a7608b$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e09959a092a7608b$var$Nh(a, b, c, d, e, f) {
    $e09959a092a7608b$var$Hh = f;
    $e09959a092a7608b$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e09959a092a7608b$var$Fh.current = null === a || null === a.memoizedState ? $e09959a092a7608b$var$Oh : $e09959a092a7608b$var$Ph;
    a = c(d, e);
    if ($e09959a092a7608b$var$Jh) {
        f = 0;
        do {
            $e09959a092a7608b$var$Jh = !1;
            $e09959a092a7608b$var$Kh = 0;
            if (25 <= f) throw Error($e09959a092a7608b$var$p(301));
            f += 1;
            $e09959a092a7608b$var$O = $e09959a092a7608b$var$N = null;
            b.updateQueue = null;
            $e09959a092a7608b$var$Fh.current = $e09959a092a7608b$var$Qh;
            a = c(d, e);
        }while ($e09959a092a7608b$var$Jh);
    }
    $e09959a092a7608b$var$Fh.current = $e09959a092a7608b$var$Rh;
    b = null !== $e09959a092a7608b$var$N && null !== $e09959a092a7608b$var$N.next;
    $e09959a092a7608b$var$Hh = 0;
    $e09959a092a7608b$var$O = $e09959a092a7608b$var$N = $e09959a092a7608b$var$M = null;
    $e09959a092a7608b$var$Ih = !1;
    if (b) throw Error($e09959a092a7608b$var$p(300));
    return a;
}
function $e09959a092a7608b$var$Sh() {
    var a = 0 !== $e09959a092a7608b$var$Kh;
    $e09959a092a7608b$var$Kh = 0;
    return a;
}
function $e09959a092a7608b$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e09959a092a7608b$var$O ? $e09959a092a7608b$var$M.memoizedState = $e09959a092a7608b$var$O = a : $e09959a092a7608b$var$O = $e09959a092a7608b$var$O.next = a;
    return $e09959a092a7608b$var$O;
}
function $e09959a092a7608b$var$Uh() {
    if (null === $e09959a092a7608b$var$N) {
        var a = $e09959a092a7608b$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e09959a092a7608b$var$N.next;
    var b = null === $e09959a092a7608b$var$O ? $e09959a092a7608b$var$M.memoizedState : $e09959a092a7608b$var$O.next;
    if (null !== b) $e09959a092a7608b$var$O = b, $e09959a092a7608b$var$N = a;
    else {
        if (null === a) throw Error($e09959a092a7608b$var$p(310));
        $e09959a092a7608b$var$N = a;
        a = {
            memoizedState: $e09959a092a7608b$var$N.memoizedState,
            baseState: $e09959a092a7608b$var$N.baseState,
            baseQueue: $e09959a092a7608b$var$N.baseQueue,
            queue: $e09959a092a7608b$var$N.queue,
            next: null
        };
        null === $e09959a092a7608b$var$O ? $e09959a092a7608b$var$M.memoizedState = $e09959a092a7608b$var$O = a : $e09959a092a7608b$var$O = $e09959a092a7608b$var$O.next = a;
    }
    return $e09959a092a7608b$var$O;
}
function $e09959a092a7608b$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e09959a092a7608b$var$Wh(a) {
    var b = $e09959a092a7608b$var$Uh(), c = b.queue;
    if (null === c) throw Error($e09959a092a7608b$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e09959a092a7608b$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e09959a092a7608b$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e09959a092a7608b$var$M.lanes |= m;
                $e09959a092a7608b$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e09959a092a7608b$var$He(d, b.memoizedState) || ($e09959a092a7608b$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e09959a092a7608b$var$M.lanes |= f, $e09959a092a7608b$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e09959a092a7608b$var$Xh(a) {
    var b = $e09959a092a7608b$var$Uh(), c = b.queue;
    if (null === c) throw Error($e09959a092a7608b$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e09959a092a7608b$var$He(f, b.memoizedState) || ($e09959a092a7608b$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e09959a092a7608b$var$Yh() {}
function $e09959a092a7608b$var$Zh(a, b) {
    var c = $e09959a092a7608b$var$M, d = $e09959a092a7608b$var$Uh(), e = b(), f = !$e09959a092a7608b$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e09959a092a7608b$var$dh = !0);
    d = d.queue;
    $e09959a092a7608b$var$$h($e09959a092a7608b$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e09959a092a7608b$var$O && $e09959a092a7608b$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e09959a092a7608b$var$bi(9, $e09959a092a7608b$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $e09959a092a7608b$var$Q) throw Error($e09959a092a7608b$var$p(349));
        0 !== ($e09959a092a7608b$var$Hh & 30) || $e09959a092a7608b$var$di(c, b, e);
    }
    return e;
}
function $e09959a092a7608b$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e09959a092a7608b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e09959a092a7608b$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e09959a092a7608b$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e09959a092a7608b$var$ei(b) && $e09959a092a7608b$var$fi(a);
}
function $e09959a092a7608b$var$ai(a, b, c) {
    return c(function() {
        $e09959a092a7608b$var$ei(b) && $e09959a092a7608b$var$fi(a);
    });
}
function $e09959a092a7608b$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e09959a092a7608b$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e09959a092a7608b$var$fi(a) {
    var b = $e09959a092a7608b$var$ih(a, 1);
    null !== b && $e09959a092a7608b$var$gi(b, a, 1, -1);
}
function $e09959a092a7608b$var$hi(a) {
    var b = $e09959a092a7608b$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e09959a092a7608b$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e09959a092a7608b$var$ii.bind(null, $e09959a092a7608b$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e09959a092a7608b$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e09959a092a7608b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e09959a092a7608b$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e09959a092a7608b$var$ji() {
    return $e09959a092a7608b$var$Uh().memoizedState;
}
function $e09959a092a7608b$var$ki(a, b, c, d) {
    var e = $e09959a092a7608b$var$Th();
    $e09959a092a7608b$var$M.flags |= a;
    e.memoizedState = $e09959a092a7608b$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e09959a092a7608b$var$li(a, b, c, d) {
    var e = $e09959a092a7608b$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e09959a092a7608b$var$N) {
        var g = $e09959a092a7608b$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $e09959a092a7608b$var$Mh(d, g.deps)) {
            e.memoizedState = $e09959a092a7608b$var$bi(b, c, f, d);
            return;
        }
    }
    $e09959a092a7608b$var$M.flags |= a;
    e.memoizedState = $e09959a092a7608b$var$bi(1 | b, c, f, d);
}
function $e09959a092a7608b$var$mi(a, b) {
    return $e09959a092a7608b$var$ki(8390656, 8, a, b);
}
function $e09959a092a7608b$var$$h(a, b) {
    return $e09959a092a7608b$var$li(2048, 8, a, b);
}
function $e09959a092a7608b$var$ni(a, b) {
    return $e09959a092a7608b$var$li(4, 2, a, b);
}
function $e09959a092a7608b$var$oi(a, b) {
    return $e09959a092a7608b$var$li(4, 4, a, b);
}
function $e09959a092a7608b$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e09959a092a7608b$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e09959a092a7608b$var$li(4, 4, $e09959a092a7608b$var$pi.bind(null, b, a), c);
}
function $e09959a092a7608b$var$ri() {}
function $e09959a092a7608b$var$si(a, b) {
    var c = $e09959a092a7608b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e09959a092a7608b$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e09959a092a7608b$var$ti(a, b) {
    var c = $e09959a092a7608b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e09959a092a7608b$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e09959a092a7608b$var$ui(a, b, c) {
    if (0 === ($e09959a092a7608b$var$Hh & 21)) return a.baseState && (a.baseState = !1, $e09959a092a7608b$var$dh = !0), a.memoizedState = c;
    $e09959a092a7608b$var$He(c, b) || (c = $e09959a092a7608b$var$yc(), $e09959a092a7608b$var$M.lanes |= c, $e09959a092a7608b$var$rh |= c, a.baseState = !0);
    return b;
}
function $e09959a092a7608b$var$vi(a, b) {
    var c = $e09959a092a7608b$var$C;
    $e09959a092a7608b$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e09959a092a7608b$var$Gh.transition;
    $e09959a092a7608b$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e09959a092a7608b$var$C = c, $e09959a092a7608b$var$Gh.transition = d;
    }
}
function $e09959a092a7608b$var$wi() {
    return $e09959a092a7608b$var$Uh().memoizedState;
}
function $e09959a092a7608b$var$xi(a, b, c) {
    var d = $e09959a092a7608b$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e09959a092a7608b$var$zi(a)) $e09959a092a7608b$var$Ai(b, c);
    else if (c = $e09959a092a7608b$var$hh(a, b, c, d), null !== c) {
        var e = $e09959a092a7608b$var$R();
        $e09959a092a7608b$var$gi(c, a, d, e);
        $e09959a092a7608b$var$Bi(c, b, d);
    }
}
function $e09959a092a7608b$var$ii(a, b, c) {
    var d = $e09959a092a7608b$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e09959a092a7608b$var$zi(a)) $e09959a092a7608b$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e09959a092a7608b$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e09959a092a7608b$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e09959a092a7608b$var$hh(a, b, e, d);
        null !== c && (e = $e09959a092a7608b$var$R(), $e09959a092a7608b$var$gi(c, a, d, e), $e09959a092a7608b$var$Bi(c, b, d));
    }
}
function $e09959a092a7608b$var$zi(a) {
    var b = a.alternate;
    return a === $e09959a092a7608b$var$M || null !== b && b === $e09959a092a7608b$var$M;
}
function $e09959a092a7608b$var$Ai(a, b) {
    $e09959a092a7608b$var$Jh = $e09959a092a7608b$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e09959a092a7608b$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e09959a092a7608b$var$Cc(a, c);
    }
}
var $e09959a092a7608b$var$Rh = {
    readContext: $e09959a092a7608b$var$eh,
    useCallback: $e09959a092a7608b$var$P,
    useContext: $e09959a092a7608b$var$P,
    useEffect: $e09959a092a7608b$var$P,
    useImperativeHandle: $e09959a092a7608b$var$P,
    useInsertionEffect: $e09959a092a7608b$var$P,
    useLayoutEffect: $e09959a092a7608b$var$P,
    useMemo: $e09959a092a7608b$var$P,
    useReducer: $e09959a092a7608b$var$P,
    useRef: $e09959a092a7608b$var$P,
    useState: $e09959a092a7608b$var$P,
    useDebugValue: $e09959a092a7608b$var$P,
    useDeferredValue: $e09959a092a7608b$var$P,
    useTransition: $e09959a092a7608b$var$P,
    useMutableSource: $e09959a092a7608b$var$P,
    useSyncExternalStore: $e09959a092a7608b$var$P,
    useId: $e09959a092a7608b$var$P,
    unstable_isNewReconciler: !1
}, $e09959a092a7608b$var$Oh = {
    readContext: $e09959a092a7608b$var$eh,
    useCallback: function(a, b) {
        $e09959a092a7608b$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e09959a092a7608b$var$eh,
    useEffect: $e09959a092a7608b$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e09959a092a7608b$var$ki(4194308, 4, $e09959a092a7608b$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e09959a092a7608b$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e09959a092a7608b$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e09959a092a7608b$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e09959a092a7608b$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e09959a092a7608b$var$xi.bind(null, $e09959a092a7608b$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e09959a092a7608b$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e09959a092a7608b$var$hi,
    useDebugValue: $e09959a092a7608b$var$ri,
    useDeferredValue: function(a) {
        return $e09959a092a7608b$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $e09959a092a7608b$var$hi(!1), b = a[0];
        a = $e09959a092a7608b$var$vi.bind(null, a[1]);
        $e09959a092a7608b$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e09959a092a7608b$var$M, e = $e09959a092a7608b$var$Th();
        if ($e09959a092a7608b$var$I) {
            if (void 0 === c) throw Error($e09959a092a7608b$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e09959a092a7608b$var$Q) throw Error($e09959a092a7608b$var$p(349));
            0 !== ($e09959a092a7608b$var$Hh & 30) || $e09959a092a7608b$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e09959a092a7608b$var$mi($e09959a092a7608b$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e09959a092a7608b$var$bi(9, $e09959a092a7608b$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e09959a092a7608b$var$Th(), b = $e09959a092a7608b$var$Q.identifierPrefix;
        if ($e09959a092a7608b$var$I) {
            var c = $e09959a092a7608b$var$sg;
            var d = $e09959a092a7608b$var$rg;
            c = (d & ~(1 << 32 - $e09959a092a7608b$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e09959a092a7608b$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e09959a092a7608b$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e09959a092a7608b$var$Ph = {
    readContext: $e09959a092a7608b$var$eh,
    useCallback: $e09959a092a7608b$var$si,
    useContext: $e09959a092a7608b$var$eh,
    useEffect: $e09959a092a7608b$var$$h,
    useImperativeHandle: $e09959a092a7608b$var$qi,
    useInsertionEffect: $e09959a092a7608b$var$ni,
    useLayoutEffect: $e09959a092a7608b$var$oi,
    useMemo: $e09959a092a7608b$var$ti,
    useReducer: $e09959a092a7608b$var$Wh,
    useRef: $e09959a092a7608b$var$ji,
    useState: function() {
        return $e09959a092a7608b$var$Wh($e09959a092a7608b$var$Vh);
    },
    useDebugValue: $e09959a092a7608b$var$ri,
    useDeferredValue: function(a) {
        var b = $e09959a092a7608b$var$Uh();
        return $e09959a092a7608b$var$ui(b, $e09959a092a7608b$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e09959a092a7608b$var$Wh($e09959a092a7608b$var$Vh)[0], b = $e09959a092a7608b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e09959a092a7608b$var$Yh,
    useSyncExternalStore: $e09959a092a7608b$var$Zh,
    useId: $e09959a092a7608b$var$wi,
    unstable_isNewReconciler: !1
}, $e09959a092a7608b$var$Qh = {
    readContext: $e09959a092a7608b$var$eh,
    useCallback: $e09959a092a7608b$var$si,
    useContext: $e09959a092a7608b$var$eh,
    useEffect: $e09959a092a7608b$var$$h,
    useImperativeHandle: $e09959a092a7608b$var$qi,
    useInsertionEffect: $e09959a092a7608b$var$ni,
    useLayoutEffect: $e09959a092a7608b$var$oi,
    useMemo: $e09959a092a7608b$var$ti,
    useReducer: $e09959a092a7608b$var$Xh,
    useRef: $e09959a092a7608b$var$ji,
    useState: function() {
        return $e09959a092a7608b$var$Xh($e09959a092a7608b$var$Vh);
    },
    useDebugValue: $e09959a092a7608b$var$ri,
    useDeferredValue: function(a) {
        var b = $e09959a092a7608b$var$Uh();
        return null === $e09959a092a7608b$var$N ? b.memoizedState = a : $e09959a092a7608b$var$ui(b, $e09959a092a7608b$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e09959a092a7608b$var$Xh($e09959a092a7608b$var$Vh)[0], b = $e09959a092a7608b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e09959a092a7608b$var$Yh,
    useSyncExternalStore: $e09959a092a7608b$var$Zh,
    useId: $e09959a092a7608b$var$wi,
    unstable_isNewReconciler: !1
};
function $e09959a092a7608b$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $e09959a092a7608b$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $e09959a092a7608b$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e09959a092a7608b$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e09959a092a7608b$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e09959a092a7608b$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e09959a092a7608b$var$R(), e = $e09959a092a7608b$var$yi(a), f = $e09959a092a7608b$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e09959a092a7608b$var$nh(a, f, e);
        null !== b && ($e09959a092a7608b$var$gi(b, a, e, d), $e09959a092a7608b$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e09959a092a7608b$var$R(), e = $e09959a092a7608b$var$yi(a), f = $e09959a092a7608b$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e09959a092a7608b$var$nh(a, f, e);
        null !== b && ($e09959a092a7608b$var$gi(b, a, e, d), $e09959a092a7608b$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e09959a092a7608b$var$R(), d = $e09959a092a7608b$var$yi(a), e = $e09959a092a7608b$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e09959a092a7608b$var$nh(a, e, d);
        null !== b && ($e09959a092a7608b$var$gi(b, a, d, c), $e09959a092a7608b$var$oh(b, a, d));
    }
};
function $e09959a092a7608b$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e09959a092a7608b$var$Ie(c, d) || !$e09959a092a7608b$var$Ie(e, f) : !0;
}
function $e09959a092a7608b$var$Gi(a, b, c) {
    var d = !1, e = $e09959a092a7608b$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e09959a092a7608b$var$eh(f) : (e = $e09959a092a7608b$var$Zf(b) ? $e09959a092a7608b$var$Xf : $e09959a092a7608b$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e09959a092a7608b$var$Yf(a, e) : $e09959a092a7608b$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e09959a092a7608b$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e09959a092a7608b$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e09959a092a7608b$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $e09959a092a7608b$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $e09959a092a7608b$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e09959a092a7608b$var$eh(f) : (f = $e09959a092a7608b$var$Zf(b) ? $e09959a092a7608b$var$Xf : $e09959a092a7608b$var$H.current, e.context = $e09959a092a7608b$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e09959a092a7608b$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e09959a092a7608b$var$Ei.enqueueReplaceState(e, e.state, null), $e09959a092a7608b$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e09959a092a7608b$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $e09959a092a7608b$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e09959a092a7608b$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e09959a092a7608b$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e09959a092a7608b$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $e09959a092a7608b$var$Ni(a, b, c) {
    c = $e09959a092a7608b$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e09959a092a7608b$var$Oi || ($e09959a092a7608b$var$Oi = !0, $e09959a092a7608b$var$Pi = d);
        $e09959a092a7608b$var$Li(a, b);
    };
    return c;
}
function $e09959a092a7608b$var$Qi(a, b, c) {
    c = $e09959a092a7608b$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e09959a092a7608b$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e09959a092a7608b$var$Li(a, b);
        "function" !== typeof d && (null === $e09959a092a7608b$var$Ri ? $e09959a092a7608b$var$Ri = new Set([
            this
        ]) : $e09959a092a7608b$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e09959a092a7608b$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e09959a092a7608b$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e09959a092a7608b$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $e09959a092a7608b$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e09959a092a7608b$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e09959a092a7608b$var$mh(-1, 1), b.tag = 2, $e09959a092a7608b$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e09959a092a7608b$var$Wi = $e09959a092a7608b$var$ua.ReactCurrentOwner, $e09959a092a7608b$var$dh = !1;
function $e09959a092a7608b$var$Xi(a, b, c, d) {
    b.child = null === a ? $e09959a092a7608b$var$Vg(b, null, c, d) : $e09959a092a7608b$var$Ug(b, a.child, c, d);
}
function $e09959a092a7608b$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e09959a092a7608b$var$ch(b, e);
    d = $e09959a092a7608b$var$Nh(a, b, c, d, f, e);
    c = $e09959a092a7608b$var$Sh();
    if (null !== a && !$e09959a092a7608b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e09959a092a7608b$var$Zi(a, b, e);
    $e09959a092a7608b$var$I && c && $e09959a092a7608b$var$vg(b);
    b.flags |= 1;
    $e09959a092a7608b$var$Xi(a, b, d, e);
    return b.child;
}
function $e09959a092a7608b$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e09959a092a7608b$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e09959a092a7608b$var$bj(a, b, f, d, e);
        a = $e09959a092a7608b$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e09959a092a7608b$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e09959a092a7608b$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $e09959a092a7608b$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e09959a092a7608b$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e09959a092a7608b$var$Ie(f, d) && a.ref === b.ref) {
            if ($e09959a092a7608b$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e09959a092a7608b$var$dh = !0);
            else return b.lanes = a.lanes, $e09959a092a7608b$var$Zi(a, b, e);
        }
    }
    return $e09959a092a7608b$var$cj(a, b, c, d, e);
}
function $e09959a092a7608b$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e09959a092a7608b$var$G($e09959a092a7608b$var$ej, $e09959a092a7608b$var$fj), $e09959a092a7608b$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e09959a092a7608b$var$G($e09959a092a7608b$var$ej, $e09959a092a7608b$var$fj), $e09959a092a7608b$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e09959a092a7608b$var$G($e09959a092a7608b$var$ej, $e09959a092a7608b$var$fj);
            $e09959a092a7608b$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e09959a092a7608b$var$G($e09959a092a7608b$var$ej, $e09959a092a7608b$var$fj), $e09959a092a7608b$var$fj |= d;
    $e09959a092a7608b$var$Xi(a, b, e, c);
    return b.child;
}
function $e09959a092a7608b$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e09959a092a7608b$var$cj(a, b, c, d, e) {
    var f = $e09959a092a7608b$var$Zf(c) ? $e09959a092a7608b$var$Xf : $e09959a092a7608b$var$H.current;
    f = $e09959a092a7608b$var$Yf(b, f);
    $e09959a092a7608b$var$ch(b, e);
    c = $e09959a092a7608b$var$Nh(a, b, c, d, f, e);
    d = $e09959a092a7608b$var$Sh();
    if (null !== a && !$e09959a092a7608b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e09959a092a7608b$var$Zi(a, b, e);
    $e09959a092a7608b$var$I && d && $e09959a092a7608b$var$vg(b);
    b.flags |= 1;
    $e09959a092a7608b$var$Xi(a, b, c, e);
    return b.child;
}
function $e09959a092a7608b$var$hj(a, b, c, d, e) {
    if ($e09959a092a7608b$var$Zf(c)) {
        var f = !0;
        $e09959a092a7608b$var$cg(b);
    } else f = !1;
    $e09959a092a7608b$var$ch(b, e);
    if (null === b.stateNode) $e09959a092a7608b$var$ij(a, b), $e09959a092a7608b$var$Gi(b, c, d), $e09959a092a7608b$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e09959a092a7608b$var$eh(l) : (l = $e09959a092a7608b$var$Zf(c) ? $e09959a092a7608b$var$Xf : $e09959a092a7608b$var$H.current, l = $e09959a092a7608b$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e09959a092a7608b$var$Hi(b, g, d, l);
        $e09959a092a7608b$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $e09959a092a7608b$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e09959a092a7608b$var$Wf.current || $e09959a092a7608b$var$jh ? ("function" === typeof m && ($e09959a092a7608b$var$Di(b, c, m, d), k = b.memoizedState), (h = $e09959a092a7608b$var$jh || $e09959a092a7608b$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e09959a092a7608b$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e09959a092a7608b$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e09959a092a7608b$var$eh(k) : (k = $e09959a092a7608b$var$Zf(c) ? $e09959a092a7608b$var$Xf : $e09959a092a7608b$var$H.current, k = $e09959a092a7608b$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e09959a092a7608b$var$Hi(b, g, d, k);
        $e09959a092a7608b$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $e09959a092a7608b$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e09959a092a7608b$var$Wf.current || $e09959a092a7608b$var$jh ? ("function" === typeof y && ($e09959a092a7608b$var$Di(b, c, y, d), n = b.memoizedState), (l = $e09959a092a7608b$var$jh || $e09959a092a7608b$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e09959a092a7608b$var$jj(a, b, c, d, f, e);
}
function $e09959a092a7608b$var$jj(a, b, c, d, e, f) {
    $e09959a092a7608b$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e09959a092a7608b$var$dg(b, c, !1), $e09959a092a7608b$var$Zi(a, b, f);
    d = b.stateNode;
    $e09959a092a7608b$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e09959a092a7608b$var$Ug(b, a.child, null, f), b.child = $e09959a092a7608b$var$Ug(b, null, h, f)) : $e09959a092a7608b$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e09959a092a7608b$var$dg(b, c, !0);
    return b.child;
}
function $e09959a092a7608b$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e09959a092a7608b$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e09959a092a7608b$var$ag(a, b.context, !1);
    $e09959a092a7608b$var$yh(a, b.containerInfo);
}
function $e09959a092a7608b$var$lj(a, b, c, d, e) {
    $e09959a092a7608b$var$Ig();
    $e09959a092a7608b$var$Jg(e);
    b.flags |= 256;
    $e09959a092a7608b$var$Xi(a, b, c, d);
    return b.child;
}
var $e09959a092a7608b$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e09959a092a7608b$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e09959a092a7608b$var$oj(a, b, c) {
    var d = b.pendingProps, e = $e09959a092a7608b$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e09959a092a7608b$var$G($e09959a092a7608b$var$L, e & 1);
    if (null === a) {
        $e09959a092a7608b$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e09959a092a7608b$var$pj(g, d, 0, null), a = $e09959a092a7608b$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e09959a092a7608b$var$nj(c), b.memoizedState = $e09959a092a7608b$var$mj, a) : $e09959a092a7608b$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e09959a092a7608b$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e09959a092a7608b$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e09959a092a7608b$var$Pg(h, f) : (f = $e09959a092a7608b$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e09959a092a7608b$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e09959a092a7608b$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e09959a092a7608b$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e09959a092a7608b$var$qj(a, b) {
    b = $e09959a092a7608b$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e09959a092a7608b$var$sj(a, b, c, d) {
    null !== d && $e09959a092a7608b$var$Jg(d);
    $e09959a092a7608b$var$Ug(b, a.child, null, c);
    a = $e09959a092a7608b$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e09959a092a7608b$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e09959a092a7608b$var$Ki(Error($e09959a092a7608b$var$p(422))), $e09959a092a7608b$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e09959a092a7608b$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e09959a092a7608b$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e09959a092a7608b$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $e09959a092a7608b$var$nj(g);
        b.memoizedState = $e09959a092a7608b$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e09959a092a7608b$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e09959a092a7608b$var$p(419));
        d = $e09959a092a7608b$var$Ki(f, d, void 0);
        return $e09959a092a7608b$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e09959a092a7608b$var$dh || h) {
        d = $e09959a092a7608b$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e09959a092a7608b$var$ih(a, e), $e09959a092a7608b$var$gi(d, a, e, -1));
        }
        $e09959a092a7608b$var$tj();
        d = $e09959a092a7608b$var$Ki(Error($e09959a092a7608b$var$p(421)));
        return $e09959a092a7608b$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e09959a092a7608b$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e09959a092a7608b$var$yg = $e09959a092a7608b$var$Lf(e.nextSibling);
    $e09959a092a7608b$var$xg = b;
    $e09959a092a7608b$var$I = !0;
    $e09959a092a7608b$var$zg = null;
    null !== a && ($e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$rg, $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$sg, $e09959a092a7608b$var$og[$e09959a092a7608b$var$pg++] = $e09959a092a7608b$var$qg, $e09959a092a7608b$var$rg = a.id, $e09959a092a7608b$var$sg = a.overflow, $e09959a092a7608b$var$qg = b);
    b = $e09959a092a7608b$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e09959a092a7608b$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e09959a092a7608b$var$bh(a.return, b, c);
}
function $e09959a092a7608b$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e09959a092a7608b$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e09959a092a7608b$var$Xi(a, b, d.children, c);
    d = $e09959a092a7608b$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e09959a092a7608b$var$vj(a, c, b);
            else if (19 === a.tag) $e09959a092a7608b$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e09959a092a7608b$var$G($e09959a092a7608b$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e09959a092a7608b$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e09959a092a7608b$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e09959a092a7608b$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e09959a092a7608b$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $e09959a092a7608b$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e09959a092a7608b$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e09959a092a7608b$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e09959a092a7608b$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e09959a092a7608b$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e09959a092a7608b$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e09959a092a7608b$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e09959a092a7608b$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $e09959a092a7608b$var$kj(b);
            $e09959a092a7608b$var$Ig();
            break;
        case 5:
            $e09959a092a7608b$var$Ah(b);
            break;
        case 1:
            $e09959a092a7608b$var$Zf(b.type) && $e09959a092a7608b$var$cg(b);
            break;
        case 4:
            $e09959a092a7608b$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e09959a092a7608b$var$G($e09959a092a7608b$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e09959a092a7608b$var$G($e09959a092a7608b$var$L, $e09959a092a7608b$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e09959a092a7608b$var$oj(a, b, c);
                $e09959a092a7608b$var$G($e09959a092a7608b$var$L, $e09959a092a7608b$var$L.current & 1);
                a = $e09959a092a7608b$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e09959a092a7608b$var$G($e09959a092a7608b$var$L, $e09959a092a7608b$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e09959a092a7608b$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e09959a092a7608b$var$G($e09959a092a7608b$var$L, $e09959a092a7608b$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e09959a092a7608b$var$dj(a, b, c);
    }
    return $e09959a092a7608b$var$Zi(a, b, c);
}
var $e09959a092a7608b$var$zj, $e09959a092a7608b$var$Aj, $e09959a092a7608b$var$Bj, $e09959a092a7608b$var$Cj;
$e09959a092a7608b$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e09959a092a7608b$var$Aj = function() {};
$e09959a092a7608b$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e09959a092a7608b$var$xh($e09959a092a7608b$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e09959a092a7608b$var$Ya(a, e);
                d = $e09959a092a7608b$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e09959a092a7608b$var$A({}, e, {
                    value: void 0
                });
                d = $e09959a092a7608b$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e09959a092a7608b$var$gb(a, e);
                d = $e09959a092a7608b$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e09959a092a7608b$var$Bf);
        }
        $e09959a092a7608b$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e09959a092a7608b$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e09959a092a7608b$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e09959a092a7608b$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e09959a092a7608b$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e09959a092a7608b$var$Dj(a, b) {
    if (!$e09959a092a7608b$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e09959a092a7608b$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e09959a092a7608b$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $e09959a092a7608b$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e09959a092a7608b$var$S(b), null;
        case 1:
            return $e09959a092a7608b$var$Zf(b.type) && $e09959a092a7608b$var$$f(), $e09959a092a7608b$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e09959a092a7608b$var$zh();
            $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf);
            $e09959a092a7608b$var$E($e09959a092a7608b$var$H);
            $e09959a092a7608b$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e09959a092a7608b$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e09959a092a7608b$var$zg && ($e09959a092a7608b$var$Fj($e09959a092a7608b$var$zg), $e09959a092a7608b$var$zg = null));
            $e09959a092a7608b$var$Aj(a, b);
            $e09959a092a7608b$var$S(b);
            return null;
        case 5:
            $e09959a092a7608b$var$Bh(b);
            var e = $e09959a092a7608b$var$xh($e09959a092a7608b$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e09959a092a7608b$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e09959a092a7608b$var$p(166));
                    $e09959a092a7608b$var$S(b);
                    return null;
                }
                a = $e09959a092a7608b$var$xh($e09959a092a7608b$var$uh.current);
                if ($e09959a092a7608b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e09959a092a7608b$var$Of] = b;
                    d[$e09959a092a7608b$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e09959a092a7608b$var$D("cancel", d);
                            $e09959a092a7608b$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e09959a092a7608b$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e09959a092a7608b$var$lf.length; e++)$e09959a092a7608b$var$D($e09959a092a7608b$var$lf[e], d);
                            break;
                        case "source":
                            $e09959a092a7608b$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e09959a092a7608b$var$D("error", d);
                            $e09959a092a7608b$var$D("load", d);
                            break;
                        case "details":
                            $e09959a092a7608b$var$D("toggle", d);
                            break;
                        case "input":
                            $e09959a092a7608b$var$Za(d, f);
                            $e09959a092a7608b$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e09959a092a7608b$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e09959a092a7608b$var$hb(d, f), $e09959a092a7608b$var$D("invalid", d);
                    }
                    $e09959a092a7608b$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e09959a092a7608b$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e09959a092a7608b$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e09959a092a7608b$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e09959a092a7608b$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e09959a092a7608b$var$Va(d);
                            $e09959a092a7608b$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e09959a092a7608b$var$Va(d);
                            $e09959a092a7608b$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e09959a092a7608b$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e09959a092a7608b$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e09959a092a7608b$var$Of] = b;
                    a[$e09959a092a7608b$var$Pf] = d;
                    $e09959a092a7608b$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e09959a092a7608b$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e09959a092a7608b$var$D("cancel", a);
                                $e09959a092a7608b$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e09959a092a7608b$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e09959a092a7608b$var$lf.length; e++)$e09959a092a7608b$var$D($e09959a092a7608b$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e09959a092a7608b$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e09959a092a7608b$var$D("error", a);
                                $e09959a092a7608b$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e09959a092a7608b$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e09959a092a7608b$var$Za(a, d);
                                e = $e09959a092a7608b$var$Ya(a, d);
                                $e09959a092a7608b$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e09959a092a7608b$var$A({}, d, {
                                    value: void 0
                                });
                                $e09959a092a7608b$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e09959a092a7608b$var$hb(a, d);
                                e = $e09959a092a7608b$var$gb(a, d);
                                $e09959a092a7608b$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e09959a092a7608b$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e09959a092a7608b$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e09959a092a7608b$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e09959a092a7608b$var$ob(a, k) : "number" === typeof k && $e09959a092a7608b$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e09959a092a7608b$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e09959a092a7608b$var$D("scroll", a) : null != k && $e09959a092a7608b$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e09959a092a7608b$var$Va(a);
                                $e09959a092a7608b$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e09959a092a7608b$var$Va(a);
                                $e09959a092a7608b$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e09959a092a7608b$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e09959a092a7608b$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e09959a092a7608b$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e09959a092a7608b$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e09959a092a7608b$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e09959a092a7608b$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e09959a092a7608b$var$p(166));
                c = $e09959a092a7608b$var$xh($e09959a092a7608b$var$wh.current);
                $e09959a092a7608b$var$xh($e09959a092a7608b$var$uh.current);
                if ($e09959a092a7608b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e09959a092a7608b$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e09959a092a7608b$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e09959a092a7608b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e09959a092a7608b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e09959a092a7608b$var$Of] = b, b.stateNode = d;
            }
            $e09959a092a7608b$var$S(b);
            return null;
        case 13:
            $e09959a092a7608b$var$E($e09959a092a7608b$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e09959a092a7608b$var$I && null !== $e09959a092a7608b$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e09959a092a7608b$var$Hg(), $e09959a092a7608b$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e09959a092a7608b$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e09959a092a7608b$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e09959a092a7608b$var$p(317));
                        f[$e09959a092a7608b$var$Of] = b;
                    } else $e09959a092a7608b$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e09959a092a7608b$var$S(b);
                    f = !1;
                } else null !== $e09959a092a7608b$var$zg && ($e09959a092a7608b$var$Fj($e09959a092a7608b$var$zg), $e09959a092a7608b$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e09959a092a7608b$var$L.current & 1) ? 0 === $e09959a092a7608b$var$T && ($e09959a092a7608b$var$T = 3) : $e09959a092a7608b$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e09959a092a7608b$var$S(b);
            return null;
        case 4:
            return $e09959a092a7608b$var$zh(), $e09959a092a7608b$var$Aj(a, b), null === a && $e09959a092a7608b$var$sf(b.stateNode.containerInfo), $e09959a092a7608b$var$S(b), null;
        case 10:
            return $e09959a092a7608b$var$ah(b.type._context), $e09959a092a7608b$var$S(b), null;
        case 17:
            return $e09959a092a7608b$var$Zf(b.type) && $e09959a092a7608b$var$$f(), $e09959a092a7608b$var$S(b), null;
        case 19:
            $e09959a092a7608b$var$E($e09959a092a7608b$var$L);
            f = b.memoizedState;
            if (null === f) return $e09959a092a7608b$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e09959a092a7608b$var$Dj(f, !1);
                else {
                    if (0 !== $e09959a092a7608b$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e09959a092a7608b$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e09959a092a7608b$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e09959a092a7608b$var$G($e09959a092a7608b$var$L, $e09959a092a7608b$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e09959a092a7608b$var$B() > $e09959a092a7608b$var$Gj && (b.flags |= 128, d = !0, $e09959a092a7608b$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e09959a092a7608b$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e09959a092a7608b$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e09959a092a7608b$var$I) return $e09959a092a7608b$var$S(b), null;
                    } else 2 * $e09959a092a7608b$var$B() - f.renderingStartTime > $e09959a092a7608b$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $e09959a092a7608b$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e09959a092a7608b$var$B(), b.sibling = null, c = $e09959a092a7608b$var$L.current, $e09959a092a7608b$var$G($e09959a092a7608b$var$L, d ? c & 1 | 2 : c & 1), b;
            $e09959a092a7608b$var$S(b);
            return null;
        case 22:
        case 23:
            return $e09959a092a7608b$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e09959a092a7608b$var$fj & 1073741824) && ($e09959a092a7608b$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e09959a092a7608b$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e09959a092a7608b$var$p(156, b.tag));
}
function $e09959a092a7608b$var$Ij(a, b) {
    $e09959a092a7608b$var$wg(b);
    switch(b.tag){
        case 1:
            return $e09959a092a7608b$var$Zf(b.type) && $e09959a092a7608b$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e09959a092a7608b$var$zh(), $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf), $e09959a092a7608b$var$E($e09959a092a7608b$var$H), $e09959a092a7608b$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e09959a092a7608b$var$Bh(b), null;
        case 13:
            $e09959a092a7608b$var$E($e09959a092a7608b$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e09959a092a7608b$var$p(340));
                $e09959a092a7608b$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e09959a092a7608b$var$E($e09959a092a7608b$var$L), null;
        case 4:
            return $e09959a092a7608b$var$zh(), null;
        case 10:
            return $e09959a092a7608b$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $e09959a092a7608b$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e09959a092a7608b$var$Jj = !1, $e09959a092a7608b$var$U = !1, $e09959a092a7608b$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $e09959a092a7608b$var$V = null;
function $e09959a092a7608b$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e09959a092a7608b$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e09959a092a7608b$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e09959a092a7608b$var$W(a, b, d);
    }
}
var $e09959a092a7608b$var$Nj = !1;
function $e09959a092a7608b$var$Oj(a, b) {
    $e09959a092a7608b$var$Cf = $e09959a092a7608b$var$dd;
    a = $e09959a092a7608b$var$Me();
    if ($e09959a092a7608b$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e09959a092a7608b$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e09959a092a7608b$var$dd = !1;
    for($e09959a092a7608b$var$V = b; null !== $e09959a092a7608b$var$V;)if (b = $e09959a092a7608b$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e09959a092a7608b$var$V = a;
    else for(; null !== $e09959a092a7608b$var$V;){
        b = $e09959a092a7608b$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e09959a092a7608b$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e09959a092a7608b$var$p(163));
            }
        } catch (F) {
            $e09959a092a7608b$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e09959a092a7608b$var$V = a;
            break;
        }
        $e09959a092a7608b$var$V = b.return;
    }
    n = $e09959a092a7608b$var$Nj;
    $e09959a092a7608b$var$Nj = !1;
    return n;
}
function $e09959a092a7608b$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e09959a092a7608b$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e09959a092a7608b$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e09959a092a7608b$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e09959a092a7608b$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e09959a092a7608b$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e09959a092a7608b$var$Of], delete b[$e09959a092a7608b$var$Pf], delete b[$e09959a092a7608b$var$of], delete b[$e09959a092a7608b$var$Qf], delete b[$e09959a092a7608b$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e09959a092a7608b$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e09959a092a7608b$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e09959a092a7608b$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e09959a092a7608b$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e09959a092a7608b$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e09959a092a7608b$var$Vj(a, b, c), a = a.sibling; null !== a;)$e09959a092a7608b$var$Vj(a, b, c), a = a.sibling;
}
function $e09959a092a7608b$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e09959a092a7608b$var$Wj(a, b, c), a = a.sibling; null !== a;)$e09959a092a7608b$var$Wj(a, b, c), a = a.sibling;
}
var $e09959a092a7608b$var$X = null, $e09959a092a7608b$var$Xj = !1;
function $e09959a092a7608b$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$e09959a092a7608b$var$Zj(a, b, c), c = c.sibling;
}
function $e09959a092a7608b$var$Zj(a, b, c) {
    if ($e09959a092a7608b$var$lc && "function" === typeof $e09959a092a7608b$var$lc.onCommitFiberUnmount) try {
        $e09959a092a7608b$var$lc.onCommitFiberUnmount($e09959a092a7608b$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e09959a092a7608b$var$U || $e09959a092a7608b$var$Lj(c, b);
        case 6:
            var d = $e09959a092a7608b$var$X, e = $e09959a092a7608b$var$Xj;
            $e09959a092a7608b$var$X = null;
            $e09959a092a7608b$var$Yj(a, b, c);
            $e09959a092a7608b$var$X = d;
            $e09959a092a7608b$var$Xj = e;
            null !== $e09959a092a7608b$var$X && ($e09959a092a7608b$var$Xj ? (a = $e09959a092a7608b$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e09959a092a7608b$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e09959a092a7608b$var$X && ($e09959a092a7608b$var$Xj ? (a = $e09959a092a7608b$var$X, c = c.stateNode, 8 === a.nodeType ? $e09959a092a7608b$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e09959a092a7608b$var$Kf(a, c), $e09959a092a7608b$var$bd(a)) : $e09959a092a7608b$var$Kf($e09959a092a7608b$var$X, c.stateNode));
            break;
        case 4:
            d = $e09959a092a7608b$var$X;
            e = $e09959a092a7608b$var$Xj;
            $e09959a092a7608b$var$X = c.stateNode.containerInfo;
            $e09959a092a7608b$var$Xj = !0;
            $e09959a092a7608b$var$Yj(a, b, c);
            $e09959a092a7608b$var$X = d;
            $e09959a092a7608b$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e09959a092a7608b$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e09959a092a7608b$var$Mj(c, b, g) : 0 !== (f & 4) && $e09959a092a7608b$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e09959a092a7608b$var$Yj(a, b, c);
            break;
        case 1:
            if (!$e09959a092a7608b$var$U && ($e09959a092a7608b$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e09959a092a7608b$var$W(c, b, h);
            }
            $e09959a092a7608b$var$Yj(a, b, c);
            break;
        case 21:
            $e09959a092a7608b$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e09959a092a7608b$var$U = (d = $e09959a092a7608b$var$U) || null !== c.memoizedState, $e09959a092a7608b$var$Yj(a, b, c), $e09959a092a7608b$var$U = d) : $e09959a092a7608b$var$Yj(a, b, c);
            break;
        default:
            $e09959a092a7608b$var$Yj(a, b, c);
    }
}
function $e09959a092a7608b$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e09959a092a7608b$var$Kj);
        b.forEach(function(b) {
            var d = $e09959a092a7608b$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e09959a092a7608b$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e09959a092a7608b$var$X = h.stateNode;
                        $e09959a092a7608b$var$Xj = !1;
                        break a;
                    case 3:
                        $e09959a092a7608b$var$X = h.stateNode.containerInfo;
                        $e09959a092a7608b$var$Xj = !0;
                        break a;
                    case 4:
                        $e09959a092a7608b$var$X = h.stateNode.containerInfo;
                        $e09959a092a7608b$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e09959a092a7608b$var$X) throw Error($e09959a092a7608b$var$p(160));
            $e09959a092a7608b$var$Zj(f, g, e);
            $e09959a092a7608b$var$X = null;
            $e09959a092a7608b$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e09959a092a7608b$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e09959a092a7608b$var$dk(b, a), b = b.sibling;
}
function $e09959a092a7608b$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            if (d & 4) {
                try {
                    $e09959a092a7608b$var$Pj(3, a, a.return), $e09959a092a7608b$var$Qj(3, a);
                } catch (t) {
                    $e09959a092a7608b$var$W(a, a.return, t);
                }
                try {
                    $e09959a092a7608b$var$Pj(5, a, a.return);
                } catch (t) {
                    $e09959a092a7608b$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            d & 512 && null !== c && $e09959a092a7608b$var$Lj(c, c.return);
            break;
        case 5:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            d & 512 && null !== c && $e09959a092a7608b$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e09959a092a7608b$var$ob(e, "");
                } catch (t) {
                    $e09959a092a7608b$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e09959a092a7608b$var$ab(e, f);
                    $e09959a092a7608b$var$vb(h, g);
                    var l = $e09959a092a7608b$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e09959a092a7608b$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e09959a092a7608b$var$nb(e, q) : "children" === m ? $e09959a092a7608b$var$ob(e, q) : $e09959a092a7608b$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e09959a092a7608b$var$bb(e, f);
                            break;
                        case "textarea":
                            $e09959a092a7608b$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e09959a092a7608b$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e09959a092a7608b$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e09959a092a7608b$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e09959a092a7608b$var$Pf] = f;
                } catch (t) {
                    $e09959a092a7608b$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e09959a092a7608b$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e09959a092a7608b$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e09959a092a7608b$var$bd(b.containerInfo);
            } catch (t) {
                $e09959a092a7608b$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            break;
        case 13:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e09959a092a7608b$var$fk = $e09959a092a7608b$var$B()));
            d & 4 && $e09959a092a7608b$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e09959a092a7608b$var$U = (l = $e09959a092a7608b$var$U) || m, $e09959a092a7608b$var$ck(b, a), $e09959a092a7608b$var$U = l) : $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e09959a092a7608b$var$V = a, m = a.child; null !== m;){
                    for(q = $e09959a092a7608b$var$V = m; null !== $e09959a092a7608b$var$V;){
                        r = $e09959a092a7608b$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e09959a092a7608b$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $e09959a092a7608b$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e09959a092a7608b$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e09959a092a7608b$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e09959a092a7608b$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e09959a092a7608b$var$V = y) : $e09959a092a7608b$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e09959a092a7608b$var$rb("display", g));
                            } catch (t) {
                                $e09959a092a7608b$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e09959a092a7608b$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e09959a092a7608b$var$ck(b, a);
            $e09959a092a7608b$var$ek(a);
            d & 4 && $e09959a092a7608b$var$ak(a);
            break;
        case 21:
            break;
        default:
            $e09959a092a7608b$var$ck(b, a), $e09959a092a7608b$var$ek(a);
    }
}
function $e09959a092a7608b$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e09959a092a7608b$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e09959a092a7608b$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e09959a092a7608b$var$ob(e, ""), d.flags &= -33);
                    var f = $e09959a092a7608b$var$Uj(a);
                    $e09959a092a7608b$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e09959a092a7608b$var$Uj(a);
                    $e09959a092a7608b$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($e09959a092a7608b$var$p(161));
            }
        } catch (k) {
            $e09959a092a7608b$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e09959a092a7608b$var$hk(a, b, c) {
    $e09959a092a7608b$var$V = a;
    $e09959a092a7608b$var$ik(a, b, c);
}
function $e09959a092a7608b$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e09959a092a7608b$var$V;){
        var e = $e09959a092a7608b$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e09959a092a7608b$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e09959a092a7608b$var$U;
                h = $e09959a092a7608b$var$Jj;
                var l = $e09959a092a7608b$var$U;
                $e09959a092a7608b$var$Jj = g;
                if (($e09959a092a7608b$var$U = k) && !l) for($e09959a092a7608b$var$V = e; null !== $e09959a092a7608b$var$V;)g = $e09959a092a7608b$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e09959a092a7608b$var$jk(e) : null !== k ? (k.return = g, $e09959a092a7608b$var$V = k) : $e09959a092a7608b$var$jk(e);
                for(; null !== f;)$e09959a092a7608b$var$V = f, $e09959a092a7608b$var$ik(f, b, c), f = f.sibling;
                $e09959a092a7608b$var$V = e;
                $e09959a092a7608b$var$Jj = h;
                $e09959a092a7608b$var$U = l;
            }
            $e09959a092a7608b$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e09959a092a7608b$var$V = f) : $e09959a092a7608b$var$kk(a, b, c);
    }
}
function $e09959a092a7608b$var$kk(a) {
    for(; null !== $e09959a092a7608b$var$V;){
        var b = $e09959a092a7608b$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e09959a092a7608b$var$U || $e09959a092a7608b$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e09959a092a7608b$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e09959a092a7608b$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e09959a092a7608b$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e09959a092a7608b$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e09959a092a7608b$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e09959a092a7608b$var$p(163));
                }
                $e09959a092a7608b$var$U || b.flags & 512 && $e09959a092a7608b$var$Rj(b);
            } catch (r) {
                $e09959a092a7608b$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e09959a092a7608b$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e09959a092a7608b$var$V = c;
            break;
        }
        $e09959a092a7608b$var$V = b.return;
    }
}
function $e09959a092a7608b$var$gk(a) {
    for(; null !== $e09959a092a7608b$var$V;){
        var b = $e09959a092a7608b$var$V;
        if (b === a) {
            $e09959a092a7608b$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e09959a092a7608b$var$V = c;
            break;
        }
        $e09959a092a7608b$var$V = b.return;
    }
}
function $e09959a092a7608b$var$jk(a) {
    for(; null !== $e09959a092a7608b$var$V;){
        var b = $e09959a092a7608b$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e09959a092a7608b$var$Qj(4, b);
                    } catch (k) {
                        $e09959a092a7608b$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e09959a092a7608b$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e09959a092a7608b$var$Rj(b);
                    } catch (k) {
                        $e09959a092a7608b$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e09959a092a7608b$var$Rj(b);
                    } catch (k) {
                        $e09959a092a7608b$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e09959a092a7608b$var$W(b, b.return, k);
        }
        if (b === a) {
            $e09959a092a7608b$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e09959a092a7608b$var$V = h;
            break;
        }
        $e09959a092a7608b$var$V = b.return;
    }
}
var $e09959a092a7608b$var$lk = Math.ceil, $e09959a092a7608b$var$mk = $e09959a092a7608b$var$ua.ReactCurrentDispatcher, $e09959a092a7608b$var$nk = $e09959a092a7608b$var$ua.ReactCurrentOwner, $e09959a092a7608b$var$ok = $e09959a092a7608b$var$ua.ReactCurrentBatchConfig, $e09959a092a7608b$var$K = 0, $e09959a092a7608b$var$Q = null, $e09959a092a7608b$var$Y = null, $e09959a092a7608b$var$Z = 0, $e09959a092a7608b$var$fj = 0, $e09959a092a7608b$var$ej = $e09959a092a7608b$var$Uf(0), $e09959a092a7608b$var$T = 0, $e09959a092a7608b$var$pk = null, $e09959a092a7608b$var$rh = 0, $e09959a092a7608b$var$qk = 0, $e09959a092a7608b$var$rk = 0, $e09959a092a7608b$var$sk = null, $e09959a092a7608b$var$tk = null, $e09959a092a7608b$var$fk = 0, $e09959a092a7608b$var$Gj = Infinity, $e09959a092a7608b$var$uk = null, $e09959a092a7608b$var$Oi = !1, $e09959a092a7608b$var$Pi = null, $e09959a092a7608b$var$Ri = null, $e09959a092a7608b$var$vk = !1, $e09959a092a7608b$var$wk = null, $e09959a092a7608b$var$xk = 0, $e09959a092a7608b$var$yk = 0, $e09959a092a7608b$var$zk = null, $e09959a092a7608b$var$Ak = -1, $e09959a092a7608b$var$Bk = 0;
function $e09959a092a7608b$var$R() {
    return 0 !== ($e09959a092a7608b$var$K & 6) ? $e09959a092a7608b$var$B() : -1 !== $e09959a092a7608b$var$Ak ? $e09959a092a7608b$var$Ak : $e09959a092a7608b$var$Ak = $e09959a092a7608b$var$B();
}
function $e09959a092a7608b$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e09959a092a7608b$var$K & 2) && 0 !== $e09959a092a7608b$var$Z) return $e09959a092a7608b$var$Z & -$e09959a092a7608b$var$Z;
    if (null !== $e09959a092a7608b$var$Kg.transition) return 0 === $e09959a092a7608b$var$Bk && ($e09959a092a7608b$var$Bk = $e09959a092a7608b$var$yc()), $e09959a092a7608b$var$Bk;
    a = $e09959a092a7608b$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e09959a092a7608b$var$jd(a.type);
    return a;
}
function $e09959a092a7608b$var$gi(a, b, c, d) {
    if (50 < $e09959a092a7608b$var$yk) throw $e09959a092a7608b$var$yk = 0, $e09959a092a7608b$var$zk = null, Error($e09959a092a7608b$var$p(185));
    $e09959a092a7608b$var$Ac(a, c, d);
    if (0 === ($e09959a092a7608b$var$K & 2) || a !== $e09959a092a7608b$var$Q) a === $e09959a092a7608b$var$Q && (0 === ($e09959a092a7608b$var$K & 2) && ($e09959a092a7608b$var$qk |= c), 4 === $e09959a092a7608b$var$T && $e09959a092a7608b$var$Ck(a, $e09959a092a7608b$var$Z)), $e09959a092a7608b$var$Dk(a, d), 1 === c && 0 === $e09959a092a7608b$var$K && 0 === (b.mode & 1) && ($e09959a092a7608b$var$Gj = $e09959a092a7608b$var$B() + 500, $e09959a092a7608b$var$fg && $e09959a092a7608b$var$jg());
}
function $e09959a092a7608b$var$Dk(a, b) {
    var c = a.callbackNode;
    $e09959a092a7608b$var$wc(a, b);
    var d = $e09959a092a7608b$var$uc(a, a === $e09959a092a7608b$var$Q ? $e09959a092a7608b$var$Z : 0);
    if (0 === d) null !== c && $e09959a092a7608b$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e09959a092a7608b$var$bc(c);
        if (1 === b) 0 === a.tag ? $e09959a092a7608b$var$ig($e09959a092a7608b$var$Ek.bind(null, a)) : $e09959a092a7608b$var$hg($e09959a092a7608b$var$Ek.bind(null, a)), $e09959a092a7608b$var$Jf(function() {
            0 === ($e09959a092a7608b$var$K & 6) && $e09959a092a7608b$var$jg();
        }), c = null;
        else {
            switch($e09959a092a7608b$var$Dc(d)){
                case 1:
                    c = $e09959a092a7608b$var$fc;
                    break;
                case 4:
                    c = $e09959a092a7608b$var$gc;
                    break;
                case 16:
                    c = $e09959a092a7608b$var$hc;
                    break;
                case 536870912:
                    c = $e09959a092a7608b$var$jc;
                    break;
                default:
                    c = $e09959a092a7608b$var$hc;
            }
            c = $e09959a092a7608b$var$Fk(c, $e09959a092a7608b$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e09959a092a7608b$var$Gk(a, b) {
    $e09959a092a7608b$var$Ak = -1;
    $e09959a092a7608b$var$Bk = 0;
    if (0 !== ($e09959a092a7608b$var$K & 6)) throw Error($e09959a092a7608b$var$p(327));
    var c = a.callbackNode;
    if ($e09959a092a7608b$var$Hk() && a.callbackNode !== c) return null;
    var d = $e09959a092a7608b$var$uc(a, a === $e09959a092a7608b$var$Q ? $e09959a092a7608b$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e09959a092a7608b$var$Ik(a, d);
    else {
        b = d;
        var e = $e09959a092a7608b$var$K;
        $e09959a092a7608b$var$K |= 2;
        var f = $e09959a092a7608b$var$Jk();
        if ($e09959a092a7608b$var$Q !== a || $e09959a092a7608b$var$Z !== b) $e09959a092a7608b$var$uk = null, $e09959a092a7608b$var$Gj = $e09959a092a7608b$var$B() + 500, $e09959a092a7608b$var$Kk(a, b);
        for(;;)try {
            $e09959a092a7608b$var$Lk();
            break;
        } catch (h) {
            $e09959a092a7608b$var$Mk(a, h);
        }
        $e09959a092a7608b$var$$g();
        $e09959a092a7608b$var$mk.current = f;
        $e09959a092a7608b$var$K = e;
        null !== $e09959a092a7608b$var$Y ? b = 0 : ($e09959a092a7608b$var$Q = null, $e09959a092a7608b$var$Z = 0, b = $e09959a092a7608b$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e09959a092a7608b$var$xc(a), 0 !== e && (d = e, b = $e09959a092a7608b$var$Nk(a, e)));
        if (1 === b) throw c = $e09959a092a7608b$var$pk, $e09959a092a7608b$var$Kk(a, 0), $e09959a092a7608b$var$Ck(a, d), $e09959a092a7608b$var$Dk(a, $e09959a092a7608b$var$B()), c;
        if (6 === b) $e09959a092a7608b$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e09959a092a7608b$var$Ok(e) && (b = $e09959a092a7608b$var$Ik(a, d), 2 === b && (f = $e09959a092a7608b$var$xc(a), 0 !== f && (d = f, b = $e09959a092a7608b$var$Nk(a, f))), 1 === b)) throw c = $e09959a092a7608b$var$pk, $e09959a092a7608b$var$Kk(a, 0), $e09959a092a7608b$var$Ck(a, d), $e09959a092a7608b$var$Dk(a, $e09959a092a7608b$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e09959a092a7608b$var$p(345));
                case 2:
                    $e09959a092a7608b$var$Pk(a, $e09959a092a7608b$var$tk, $e09959a092a7608b$var$uk);
                    break;
                case 3:
                    $e09959a092a7608b$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $e09959a092a7608b$var$fk + 500 - $e09959a092a7608b$var$B(), 10 < b)) {
                        if (0 !== $e09959a092a7608b$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e09959a092a7608b$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e09959a092a7608b$var$Ff($e09959a092a7608b$var$Pk.bind(null, a, $e09959a092a7608b$var$tk, $e09959a092a7608b$var$uk), b);
                        break;
                    }
                    $e09959a092a7608b$var$Pk(a, $e09959a092a7608b$var$tk, $e09959a092a7608b$var$uk);
                    break;
                case 4:
                    $e09959a092a7608b$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e09959a092a7608b$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e09959a092a7608b$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e09959a092a7608b$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e09959a092a7608b$var$Ff($e09959a092a7608b$var$Pk.bind(null, a, $e09959a092a7608b$var$tk, $e09959a092a7608b$var$uk), d);
                        break;
                    }
                    $e09959a092a7608b$var$Pk(a, $e09959a092a7608b$var$tk, $e09959a092a7608b$var$uk);
                    break;
                case 5:
                    $e09959a092a7608b$var$Pk(a, $e09959a092a7608b$var$tk, $e09959a092a7608b$var$uk);
                    break;
                default:
                    throw Error($e09959a092a7608b$var$p(329));
            }
        }
    }
    $e09959a092a7608b$var$Dk(a, $e09959a092a7608b$var$B());
    return a.callbackNode === c ? $e09959a092a7608b$var$Gk.bind(null, a) : null;
}
function $e09959a092a7608b$var$Nk(a, b) {
    var c = $e09959a092a7608b$var$sk;
    a.current.memoizedState.isDehydrated && ($e09959a092a7608b$var$Kk(a, b).flags |= 256);
    a = $e09959a092a7608b$var$Ik(a, b);
    2 !== a && (b = $e09959a092a7608b$var$tk, $e09959a092a7608b$var$tk = c, null !== b && $e09959a092a7608b$var$Fj(b));
    return a;
}
function $e09959a092a7608b$var$Fj(a) {
    null === $e09959a092a7608b$var$tk ? $e09959a092a7608b$var$tk = a : $e09959a092a7608b$var$tk.push.apply($e09959a092a7608b$var$tk, a);
}
function $e09959a092a7608b$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e09959a092a7608b$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e09959a092a7608b$var$Ck(a, b) {
    b &= ~$e09959a092a7608b$var$rk;
    b &= ~$e09959a092a7608b$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e09959a092a7608b$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e09959a092a7608b$var$Ek(a) {
    if (0 !== ($e09959a092a7608b$var$K & 6)) throw Error($e09959a092a7608b$var$p(327));
    $e09959a092a7608b$var$Hk();
    var b = $e09959a092a7608b$var$uc(a, 0);
    if (0 === (b & 1)) return $e09959a092a7608b$var$Dk(a, $e09959a092a7608b$var$B()), null;
    var c = $e09959a092a7608b$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e09959a092a7608b$var$xc(a);
        0 !== d && (b = d, c = $e09959a092a7608b$var$Nk(a, d));
    }
    if (1 === c) throw c = $e09959a092a7608b$var$pk, $e09959a092a7608b$var$Kk(a, 0), $e09959a092a7608b$var$Ck(a, b), $e09959a092a7608b$var$Dk(a, $e09959a092a7608b$var$B()), c;
    if (6 === c) throw Error($e09959a092a7608b$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e09959a092a7608b$var$Pk(a, $e09959a092a7608b$var$tk, $e09959a092a7608b$var$uk);
    $e09959a092a7608b$var$Dk(a, $e09959a092a7608b$var$B());
    return null;
}
function $e09959a092a7608b$var$Qk(a, b) {
    var c = $e09959a092a7608b$var$K;
    $e09959a092a7608b$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e09959a092a7608b$var$K = c, 0 === $e09959a092a7608b$var$K && ($e09959a092a7608b$var$Gj = $e09959a092a7608b$var$B() + 500, $e09959a092a7608b$var$fg && $e09959a092a7608b$var$jg());
    }
}
function $e09959a092a7608b$var$Rk(a) {
    null !== $e09959a092a7608b$var$wk && 0 === $e09959a092a7608b$var$wk.tag && 0 === ($e09959a092a7608b$var$K & 6) && $e09959a092a7608b$var$Hk();
    var b = $e09959a092a7608b$var$K;
    $e09959a092a7608b$var$K |= 1;
    var c = $e09959a092a7608b$var$ok.transition, d = $e09959a092a7608b$var$C;
    try {
        if ($e09959a092a7608b$var$ok.transition = null, $e09959a092a7608b$var$C = 1, a) return a();
    } finally{
        $e09959a092a7608b$var$C = d, $e09959a092a7608b$var$ok.transition = c, $e09959a092a7608b$var$K = b, 0 === ($e09959a092a7608b$var$K & 6) && $e09959a092a7608b$var$jg();
    }
}
function $e09959a092a7608b$var$Hj() {
    $e09959a092a7608b$var$fj = $e09959a092a7608b$var$ej.current;
    $e09959a092a7608b$var$E($e09959a092a7608b$var$ej);
}
function $e09959a092a7608b$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e09959a092a7608b$var$Gf(c));
    if (null !== $e09959a092a7608b$var$Y) for(c = $e09959a092a7608b$var$Y.return; null !== c;){
        var d = c;
        $e09959a092a7608b$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e09959a092a7608b$var$$f();
                break;
            case 3:
                $e09959a092a7608b$var$zh();
                $e09959a092a7608b$var$E($e09959a092a7608b$var$Wf);
                $e09959a092a7608b$var$E($e09959a092a7608b$var$H);
                $e09959a092a7608b$var$Eh();
                break;
            case 5:
                $e09959a092a7608b$var$Bh(d);
                break;
            case 4:
                $e09959a092a7608b$var$zh();
                break;
            case 13:
                $e09959a092a7608b$var$E($e09959a092a7608b$var$L);
                break;
            case 19:
                $e09959a092a7608b$var$E($e09959a092a7608b$var$L);
                break;
            case 10:
                $e09959a092a7608b$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $e09959a092a7608b$var$Hj();
        }
        c = c.return;
    }
    $e09959a092a7608b$var$Q = a;
    $e09959a092a7608b$var$Y = a = $e09959a092a7608b$var$Pg(a.current, null);
    $e09959a092a7608b$var$Z = $e09959a092a7608b$var$fj = b;
    $e09959a092a7608b$var$T = 0;
    $e09959a092a7608b$var$pk = null;
    $e09959a092a7608b$var$rk = $e09959a092a7608b$var$qk = $e09959a092a7608b$var$rh = 0;
    $e09959a092a7608b$var$tk = $e09959a092a7608b$var$sk = null;
    if (null !== $e09959a092a7608b$var$fh) {
        for(b = 0; b < $e09959a092a7608b$var$fh.length; b++)if (c = $e09959a092a7608b$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e09959a092a7608b$var$fh = null;
    }
    return a;
}
function $e09959a092a7608b$var$Mk(a, b) {
    do {
        var c = $e09959a092a7608b$var$Y;
        try {
            $e09959a092a7608b$var$$g();
            $e09959a092a7608b$var$Fh.current = $e09959a092a7608b$var$Rh;
            if ($e09959a092a7608b$var$Ih) {
                for(var d = $e09959a092a7608b$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e09959a092a7608b$var$Ih = !1;
            }
            $e09959a092a7608b$var$Hh = 0;
            $e09959a092a7608b$var$O = $e09959a092a7608b$var$N = $e09959a092a7608b$var$M = null;
            $e09959a092a7608b$var$Jh = !1;
            $e09959a092a7608b$var$Kh = 0;
            $e09959a092a7608b$var$nk.current = null;
            if (null === c || null === c.return) {
                $e09959a092a7608b$var$T = 1;
                $e09959a092a7608b$var$pk = b;
                $e09959a092a7608b$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e09959a092a7608b$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e09959a092a7608b$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e09959a092a7608b$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $e09959a092a7608b$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e09959a092a7608b$var$Si(f, l, b);
                            $e09959a092a7608b$var$tj();
                            break a;
                        }
                        k = Error($e09959a092a7608b$var$p(426));
                    }
                } else if ($e09959a092a7608b$var$I && h.mode & 1) {
                    var J = $e09959a092a7608b$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e09959a092a7608b$var$Vi(J, g, h, f, b);
                        $e09959a092a7608b$var$Jg($e09959a092a7608b$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $e09959a092a7608b$var$Ji(k, h);
                4 !== $e09959a092a7608b$var$T && ($e09959a092a7608b$var$T = 2);
                null === $e09959a092a7608b$var$sk ? $e09959a092a7608b$var$sk = [
                    f
                ] : $e09959a092a7608b$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e09959a092a7608b$var$Ni(f, k, b);
                            $e09959a092a7608b$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e09959a092a7608b$var$Ri || !$e09959a092a7608b$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e09959a092a7608b$var$Qi(f, h, b);
                                $e09959a092a7608b$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e09959a092a7608b$var$Sk(c);
        } catch (na) {
            b = na;
            $e09959a092a7608b$var$Y === c && null !== c && ($e09959a092a7608b$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e09959a092a7608b$var$Jk() {
    var a = $e09959a092a7608b$var$mk.current;
    $e09959a092a7608b$var$mk.current = $e09959a092a7608b$var$Rh;
    return null === a ? $e09959a092a7608b$var$Rh : a;
}
function $e09959a092a7608b$var$tj() {
    if (0 === $e09959a092a7608b$var$T || 3 === $e09959a092a7608b$var$T || 2 === $e09959a092a7608b$var$T) $e09959a092a7608b$var$T = 4;
    null === $e09959a092a7608b$var$Q || 0 === ($e09959a092a7608b$var$rh & 268435455) && 0 === ($e09959a092a7608b$var$qk & 268435455) || $e09959a092a7608b$var$Ck($e09959a092a7608b$var$Q, $e09959a092a7608b$var$Z);
}
function $e09959a092a7608b$var$Ik(a, b) {
    var c = $e09959a092a7608b$var$K;
    $e09959a092a7608b$var$K |= 2;
    var d = $e09959a092a7608b$var$Jk();
    if ($e09959a092a7608b$var$Q !== a || $e09959a092a7608b$var$Z !== b) $e09959a092a7608b$var$uk = null, $e09959a092a7608b$var$Kk(a, b);
    for(;;)try {
        $e09959a092a7608b$var$Tk();
        break;
    } catch (e) {
        $e09959a092a7608b$var$Mk(a, e);
    }
    $e09959a092a7608b$var$$g();
    $e09959a092a7608b$var$K = c;
    $e09959a092a7608b$var$mk.current = d;
    if (null !== $e09959a092a7608b$var$Y) throw Error($e09959a092a7608b$var$p(261));
    $e09959a092a7608b$var$Q = null;
    $e09959a092a7608b$var$Z = 0;
    return $e09959a092a7608b$var$T;
}
function $e09959a092a7608b$var$Tk() {
    for(; null !== $e09959a092a7608b$var$Y;)$e09959a092a7608b$var$Uk($e09959a092a7608b$var$Y);
}
function $e09959a092a7608b$var$Lk() {
    for(; null !== $e09959a092a7608b$var$Y && !$e09959a092a7608b$var$cc();)$e09959a092a7608b$var$Uk($e09959a092a7608b$var$Y);
}
function $e09959a092a7608b$var$Uk(a) {
    var b = $e09959a092a7608b$var$Vk(a.alternate, a, $e09959a092a7608b$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e09959a092a7608b$var$Sk(a) : $e09959a092a7608b$var$Y = b;
    $e09959a092a7608b$var$nk.current = null;
}
function $e09959a092a7608b$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e09959a092a7608b$var$Ej(c, b, $e09959a092a7608b$var$fj), null !== c) {
                $e09959a092a7608b$var$Y = c;
                return;
            }
        } else {
            c = $e09959a092a7608b$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e09959a092a7608b$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e09959a092a7608b$var$T = 6;
                $e09959a092a7608b$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e09959a092a7608b$var$Y = b;
            return;
        }
        $e09959a092a7608b$var$Y = b = a;
    }while (null !== b);
    0 === $e09959a092a7608b$var$T && ($e09959a092a7608b$var$T = 5);
}
function $e09959a092a7608b$var$Pk(a, b, c) {
    var d = $e09959a092a7608b$var$C, e = $e09959a092a7608b$var$ok.transition;
    try {
        $e09959a092a7608b$var$ok.transition = null, $e09959a092a7608b$var$C = 1, $e09959a092a7608b$var$Wk(a, b, c, d);
    } finally{
        $e09959a092a7608b$var$ok.transition = e, $e09959a092a7608b$var$C = d;
    }
    return null;
}
function $e09959a092a7608b$var$Wk(a, b, c, d) {
    do $e09959a092a7608b$var$Hk();
    while (null !== $e09959a092a7608b$var$wk);
    if (0 !== ($e09959a092a7608b$var$K & 6)) throw Error($e09959a092a7608b$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e09959a092a7608b$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e09959a092a7608b$var$Bc(a, f);
    a === $e09959a092a7608b$var$Q && ($e09959a092a7608b$var$Y = $e09959a092a7608b$var$Q = null, $e09959a092a7608b$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e09959a092a7608b$var$vk || ($e09959a092a7608b$var$vk = !0, $e09959a092a7608b$var$Fk($e09959a092a7608b$var$hc, function() {
        $e09959a092a7608b$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e09959a092a7608b$var$ok.transition;
        $e09959a092a7608b$var$ok.transition = null;
        var g = $e09959a092a7608b$var$C;
        $e09959a092a7608b$var$C = 1;
        var h = $e09959a092a7608b$var$K;
        $e09959a092a7608b$var$K |= 4;
        $e09959a092a7608b$var$nk.current = null;
        $e09959a092a7608b$var$Oj(a, c);
        $e09959a092a7608b$var$dk(c, a);
        $e09959a092a7608b$var$Oe($e09959a092a7608b$var$Df);
        $e09959a092a7608b$var$dd = !!$e09959a092a7608b$var$Cf;
        $e09959a092a7608b$var$Df = $e09959a092a7608b$var$Cf = null;
        a.current = c;
        $e09959a092a7608b$var$hk(c, a, e);
        $e09959a092a7608b$var$dc();
        $e09959a092a7608b$var$K = h;
        $e09959a092a7608b$var$C = g;
        $e09959a092a7608b$var$ok.transition = f;
    } else a.current = c;
    $e09959a092a7608b$var$vk && ($e09959a092a7608b$var$vk = !1, $e09959a092a7608b$var$wk = a, $e09959a092a7608b$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($e09959a092a7608b$var$Ri = null);
    $e09959a092a7608b$var$mc(c.stateNode, d);
    $e09959a092a7608b$var$Dk(a, $e09959a092a7608b$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e09959a092a7608b$var$Oi) throw $e09959a092a7608b$var$Oi = !1, a = $e09959a092a7608b$var$Pi, $e09959a092a7608b$var$Pi = null, a;
    0 !== ($e09959a092a7608b$var$xk & 1) && 0 !== a.tag && $e09959a092a7608b$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e09959a092a7608b$var$zk ? $e09959a092a7608b$var$yk++ : ($e09959a092a7608b$var$yk = 0, $e09959a092a7608b$var$zk = a) : $e09959a092a7608b$var$yk = 0;
    $e09959a092a7608b$var$jg();
    return null;
}
function $e09959a092a7608b$var$Hk() {
    if (null !== $e09959a092a7608b$var$wk) {
        var a = $e09959a092a7608b$var$Dc($e09959a092a7608b$var$xk), b = $e09959a092a7608b$var$ok.transition, c = $e09959a092a7608b$var$C;
        try {
            $e09959a092a7608b$var$ok.transition = null;
            $e09959a092a7608b$var$C = 16 > a ? 16 : a;
            if (null === $e09959a092a7608b$var$wk) var d = !1;
            else {
                a = $e09959a092a7608b$var$wk;
                $e09959a092a7608b$var$wk = null;
                $e09959a092a7608b$var$xk = 0;
                if (0 !== ($e09959a092a7608b$var$K & 6)) throw Error($e09959a092a7608b$var$p(331));
                var e = $e09959a092a7608b$var$K;
                $e09959a092a7608b$var$K |= 4;
                for($e09959a092a7608b$var$V = a.current; null !== $e09959a092a7608b$var$V;){
                    var f = $e09959a092a7608b$var$V, g = f.child;
                    if (0 !== ($e09959a092a7608b$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e09959a092a7608b$var$V = l; null !== $e09959a092a7608b$var$V;){
                                    var m = $e09959a092a7608b$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e09959a092a7608b$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e09959a092a7608b$var$V = q;
                                    else for(; null !== $e09959a092a7608b$var$V;){
                                        m = $e09959a092a7608b$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e09959a092a7608b$var$Sj(m);
                                        if (m === l) {
                                            $e09959a092a7608b$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e09959a092a7608b$var$V = r;
                                            break;
                                        }
                                        $e09959a092a7608b$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e09959a092a7608b$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e09959a092a7608b$var$V = g;
                    else b: for(; null !== $e09959a092a7608b$var$V;){
                        f = $e09959a092a7608b$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e09959a092a7608b$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e09959a092a7608b$var$V = x;
                            break b;
                        }
                        $e09959a092a7608b$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e09959a092a7608b$var$V = w; null !== $e09959a092a7608b$var$V;){
                    g = $e09959a092a7608b$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e09959a092a7608b$var$V = u;
                    else b: for(g = w; null !== $e09959a092a7608b$var$V;){
                        h = $e09959a092a7608b$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e09959a092a7608b$var$Qj(9, h);
                            }
                        } catch (na) {
                            $e09959a092a7608b$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e09959a092a7608b$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e09959a092a7608b$var$V = F;
                            break b;
                        }
                        $e09959a092a7608b$var$V = h.return;
                    }
                }
                $e09959a092a7608b$var$K = e;
                $e09959a092a7608b$var$jg();
                if ($e09959a092a7608b$var$lc && "function" === typeof $e09959a092a7608b$var$lc.onPostCommitFiberRoot) try {
                    $e09959a092a7608b$var$lc.onPostCommitFiberRoot($e09959a092a7608b$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e09959a092a7608b$var$C = c, $e09959a092a7608b$var$ok.transition = b;
        }
    }
    return !1;
}
function $e09959a092a7608b$var$Xk(a, b, c) {
    b = $e09959a092a7608b$var$Ji(c, b);
    b = $e09959a092a7608b$var$Ni(a, b, 1);
    a = $e09959a092a7608b$var$nh(a, b, 1);
    b = $e09959a092a7608b$var$R();
    null !== a && ($e09959a092a7608b$var$Ac(a, 1, b), $e09959a092a7608b$var$Dk(a, b));
}
function $e09959a092a7608b$var$W(a, b, c) {
    if (3 === a.tag) $e09959a092a7608b$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e09959a092a7608b$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e09959a092a7608b$var$Ri || !$e09959a092a7608b$var$Ri.has(d))) {
                a = $e09959a092a7608b$var$Ji(c, a);
                a = $e09959a092a7608b$var$Qi(b, a, 1);
                b = $e09959a092a7608b$var$nh(b, a, 1);
                a = $e09959a092a7608b$var$R();
                null !== b && ($e09959a092a7608b$var$Ac(b, 1, a), $e09959a092a7608b$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e09959a092a7608b$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e09959a092a7608b$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $e09959a092a7608b$var$Q === a && ($e09959a092a7608b$var$Z & c) === c && (4 === $e09959a092a7608b$var$T || 3 === $e09959a092a7608b$var$T && ($e09959a092a7608b$var$Z & 130023424) === $e09959a092a7608b$var$Z && 500 > $e09959a092a7608b$var$B() - $e09959a092a7608b$var$fk ? $e09959a092a7608b$var$Kk(a, 0) : $e09959a092a7608b$var$rk |= c);
    $e09959a092a7608b$var$Dk(a, b);
}
function $e09959a092a7608b$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e09959a092a7608b$var$sc, $e09959a092a7608b$var$sc <<= 1, 0 === ($e09959a092a7608b$var$sc & 130023424) && ($e09959a092a7608b$var$sc = 4194304)));
    var c = $e09959a092a7608b$var$R();
    a = $e09959a092a7608b$var$ih(a, b);
    null !== a && ($e09959a092a7608b$var$Ac(a, b, c), $e09959a092a7608b$var$Dk(a, c));
}
function $e09959a092a7608b$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e09959a092a7608b$var$Yk(a, c);
}
function $e09959a092a7608b$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e09959a092a7608b$var$p(314));
    }
    null !== d && d.delete(b);
    $e09959a092a7608b$var$Yk(a, c);
}
var $e09959a092a7608b$var$Vk;
$e09959a092a7608b$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e09959a092a7608b$var$Wf.current) $e09959a092a7608b$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e09959a092a7608b$var$dh = !1, $e09959a092a7608b$var$yj(a, b, c);
            $e09959a092a7608b$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e09959a092a7608b$var$dh = !1, $e09959a092a7608b$var$I && 0 !== (b.flags & 1048576) && $e09959a092a7608b$var$ug(b, $e09959a092a7608b$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e09959a092a7608b$var$ij(a, b);
            a = b.pendingProps;
            var e = $e09959a092a7608b$var$Yf(b, $e09959a092a7608b$var$H.current);
            $e09959a092a7608b$var$ch(b, c);
            e = $e09959a092a7608b$var$Nh(null, b, d, a, e, c);
            var f = $e09959a092a7608b$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e09959a092a7608b$var$Zf(d) ? (f = !0, $e09959a092a7608b$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e09959a092a7608b$var$kh(b), e.updater = $e09959a092a7608b$var$Ei, b.stateNode = e, e._reactInternals = b, $e09959a092a7608b$var$Ii(b, d, a, c), b = $e09959a092a7608b$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $e09959a092a7608b$var$I && f && $e09959a092a7608b$var$vg(b), $e09959a092a7608b$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e09959a092a7608b$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e09959a092a7608b$var$Zk(d);
                a = $e09959a092a7608b$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $e09959a092a7608b$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e09959a092a7608b$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e09959a092a7608b$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e09959a092a7608b$var$$i(null, b, d, $e09959a092a7608b$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($e09959a092a7608b$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e09959a092a7608b$var$Ci(d, e), $e09959a092a7608b$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e09959a092a7608b$var$Ci(d, e), $e09959a092a7608b$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $e09959a092a7608b$var$kj(b);
                if (null === a) throw Error($e09959a092a7608b$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e09959a092a7608b$var$lh(a, b);
                $e09959a092a7608b$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e09959a092a7608b$var$Ji(Error($e09959a092a7608b$var$p(423)), b);
                        b = $e09959a092a7608b$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e09959a092a7608b$var$Ji(Error($e09959a092a7608b$var$p(424)), b);
                        b = $e09959a092a7608b$var$lj(a, b, d, c, e);
                        break a;
                    } else for($e09959a092a7608b$var$yg = $e09959a092a7608b$var$Lf(b.stateNode.containerInfo.firstChild), $e09959a092a7608b$var$xg = b, $e09959a092a7608b$var$I = !0, $e09959a092a7608b$var$zg = null, c = $e09959a092a7608b$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e09959a092a7608b$var$Ig();
                    if (d === e) {
                        b = $e09959a092a7608b$var$Zi(a, b, c);
                        break a;
                    }
                    $e09959a092a7608b$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e09959a092a7608b$var$Ah(b), null === a && $e09959a092a7608b$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e09959a092a7608b$var$Ef(d, e) ? g = null : null !== f && $e09959a092a7608b$var$Ef(d, f) && (b.flags |= 32), $e09959a092a7608b$var$gj(a, b), $e09959a092a7608b$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $e09959a092a7608b$var$Eg(b), null;
        case 13:
            return $e09959a092a7608b$var$oj(a, b, c);
        case 4:
            return $e09959a092a7608b$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e09959a092a7608b$var$Ug(b, null, d, c) : $e09959a092a7608b$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e09959a092a7608b$var$Ci(d, e), $e09959a092a7608b$var$Yi(a, b, d, e, c);
        case 7:
            return $e09959a092a7608b$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e09959a092a7608b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e09959a092a7608b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e09959a092a7608b$var$G($e09959a092a7608b$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e09959a092a7608b$var$He(f.value, g)) {
                        if (f.children === e.children && !$e09959a092a7608b$var$Wf.current) {
                            b = $e09959a092a7608b$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e09959a092a7608b$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e09959a092a7608b$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e09959a092a7608b$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e09959a092a7608b$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e09959a092a7608b$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e09959a092a7608b$var$ch(b, c), e = $e09959a092a7608b$var$eh(e), d = d(e), b.flags |= 1, $e09959a092a7608b$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e09959a092a7608b$var$Ci(d, b.pendingProps), e = $e09959a092a7608b$var$Ci(d.type, e), $e09959a092a7608b$var$$i(a, b, d, e, c);
        case 15:
            return $e09959a092a7608b$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e09959a092a7608b$var$Ci(d, e), $e09959a092a7608b$var$ij(a, b), b.tag = 1, $e09959a092a7608b$var$Zf(d) ? (a = !0, $e09959a092a7608b$var$cg(b)) : a = !1, $e09959a092a7608b$var$ch(b, c), $e09959a092a7608b$var$Gi(b, d, e), $e09959a092a7608b$var$Ii(b, d, e, c), $e09959a092a7608b$var$jj(null, b, d, !0, a, c);
        case 19:
            return $e09959a092a7608b$var$xj(a, b, c);
        case 22:
            return $e09959a092a7608b$var$dj(a, b, c);
    }
    throw Error($e09959a092a7608b$var$p(156, b.tag));
};
function $e09959a092a7608b$var$Fk(a, b) {
    return $e09959a092a7608b$var$ac(a, b);
}
function $e09959a092a7608b$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e09959a092a7608b$var$Bg(a, b, c, d) {
    return new $e09959a092a7608b$var$$k(a, b, c, d);
}
function $e09959a092a7608b$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e09959a092a7608b$var$Zk(a) {
    if ("function" === typeof a) return $e09959a092a7608b$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e09959a092a7608b$var$Da) return 11;
        if (a === $e09959a092a7608b$var$Ga) return 14;
    }
    return 2;
}
function $e09959a092a7608b$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $e09959a092a7608b$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e09959a092a7608b$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e09959a092a7608b$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e09959a092a7608b$var$ya:
            return $e09959a092a7608b$var$Tg(c.children, e, f, b);
        case $e09959a092a7608b$var$za:
            g = 8;
            e |= 8;
            break;
        case $e09959a092a7608b$var$Aa:
            return a = $e09959a092a7608b$var$Bg(12, c, b, e | 2), a.elementType = $e09959a092a7608b$var$Aa, a.lanes = f, a;
        case $e09959a092a7608b$var$Ea:
            return a = $e09959a092a7608b$var$Bg(13, c, b, e), a.elementType = $e09959a092a7608b$var$Ea, a.lanes = f, a;
        case $e09959a092a7608b$var$Fa:
            return a = $e09959a092a7608b$var$Bg(19, c, b, e), a.elementType = $e09959a092a7608b$var$Fa, a.lanes = f, a;
        case $e09959a092a7608b$var$Ia:
            return $e09959a092a7608b$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e09959a092a7608b$var$Ba:
                    g = 10;
                    break a;
                case $e09959a092a7608b$var$Ca:
                    g = 9;
                    break a;
                case $e09959a092a7608b$var$Da:
                    g = 11;
                    break a;
                case $e09959a092a7608b$var$Ga:
                    g = 14;
                    break a;
                case $e09959a092a7608b$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e09959a092a7608b$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e09959a092a7608b$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e09959a092a7608b$var$Tg(a, b, c, d) {
    a = $e09959a092a7608b$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e09959a092a7608b$var$pj(a, b, c, d) {
    a = $e09959a092a7608b$var$Bg(22, a, d, b);
    a.elementType = $e09959a092a7608b$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e09959a092a7608b$var$Qg(a, b, c) {
    a = $e09959a092a7608b$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e09959a092a7608b$var$Sg(a, b, c) {
    b = $e09959a092a7608b$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e09959a092a7608b$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e09959a092a7608b$var$zc(0);
    this.expirationTimes = $e09959a092a7608b$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e09959a092a7608b$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e09959a092a7608b$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $e09959a092a7608b$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e09959a092a7608b$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e09959a092a7608b$var$kh(f);
    return a;
}
function $e09959a092a7608b$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e09959a092a7608b$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e09959a092a7608b$var$dl(a) {
    if (!a) return $e09959a092a7608b$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e09959a092a7608b$var$Vb(a) !== a || 1 !== a.tag) throw Error($e09959a092a7608b$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e09959a092a7608b$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e09959a092a7608b$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e09959a092a7608b$var$Zf(c)) return $e09959a092a7608b$var$bg(a, c, b);
    }
    return b;
}
function $e09959a092a7608b$var$el(a, b, c, d, e, f, g, h, k) {
    a = $e09959a092a7608b$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $e09959a092a7608b$var$dl(null);
    c = a.current;
    d = $e09959a092a7608b$var$R();
    e = $e09959a092a7608b$var$yi(c);
    f = $e09959a092a7608b$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e09959a092a7608b$var$nh(c, f, e);
    a.current.lanes = e;
    $e09959a092a7608b$var$Ac(a, e, d);
    $e09959a092a7608b$var$Dk(a, d);
    return a;
}
function $e09959a092a7608b$var$fl(a, b, c, d) {
    var e = b.current, f = $e09959a092a7608b$var$R(), g = $e09959a092a7608b$var$yi(e);
    c = $e09959a092a7608b$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e09959a092a7608b$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e09959a092a7608b$var$nh(e, b, g);
    null !== a && ($e09959a092a7608b$var$gi(a, e, g, f), $e09959a092a7608b$var$oh(a, e, g));
    return g;
}
function $e09959a092a7608b$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e09959a092a7608b$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e09959a092a7608b$var$il(a, b) {
    $e09959a092a7608b$var$hl(a, b);
    (a = a.alternate) && $e09959a092a7608b$var$hl(a, b);
}
function $e09959a092a7608b$var$jl() {
    return null;
}
var $e09959a092a7608b$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e09959a092a7608b$var$ll(a) {
    this._internalRoot = a;
}
$e09959a092a7608b$var$ml.prototype.render = $e09959a092a7608b$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e09959a092a7608b$var$p(409));
    $e09959a092a7608b$var$fl(a, b, null, null);
};
$e09959a092a7608b$var$ml.prototype.unmount = $e09959a092a7608b$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e09959a092a7608b$var$Rk(function() {
            $e09959a092a7608b$var$fl(null, a, null, null);
        });
        b[$e09959a092a7608b$var$uf] = null;
    }
};
function $e09959a092a7608b$var$ml(a) {
    this._internalRoot = a;
}
$e09959a092a7608b$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e09959a092a7608b$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e09959a092a7608b$var$Qc.length && 0 !== b && b < $e09959a092a7608b$var$Qc[c].priority; c++);
        $e09959a092a7608b$var$Qc.splice(c, 0, a);
        0 === c && $e09959a092a7608b$var$Vc(a);
    }
};
function $e09959a092a7608b$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e09959a092a7608b$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e09959a092a7608b$var$pl() {}
function $e09959a092a7608b$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e09959a092a7608b$var$gl(g);
                f.call(a);
            };
        }
        var g = $e09959a092a7608b$var$el(b, d, a, 0, null, !1, !1, "", $e09959a092a7608b$var$pl);
        a._reactRootContainer = g;
        a[$e09959a092a7608b$var$uf] = g.current;
        $e09959a092a7608b$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e09959a092a7608b$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e09959a092a7608b$var$gl(k);
            h.call(a);
        };
    }
    var k = $e09959a092a7608b$var$bl(a, 0, !1, null, null, !1, !1, "", $e09959a092a7608b$var$pl);
    a._reactRootContainer = k;
    a[$e09959a092a7608b$var$uf] = k.current;
    $e09959a092a7608b$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e09959a092a7608b$var$Rk(function() {
        $e09959a092a7608b$var$fl(b, k, c, d);
    });
    return k;
}
function $e09959a092a7608b$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e09959a092a7608b$var$gl(g);
                h.call(a);
            };
        }
        $e09959a092a7608b$var$fl(b, g, a, e);
    } else g = $e09959a092a7608b$var$ql(c, b, a, e, d);
    return $e09959a092a7608b$var$gl(g);
}
$e09959a092a7608b$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e09959a092a7608b$var$tc(b.pendingLanes);
                0 !== c && ($e09959a092a7608b$var$Cc(b, c | 1), $e09959a092a7608b$var$Dk(b, $e09959a092a7608b$var$B()), 0 === ($e09959a092a7608b$var$K & 6) && ($e09959a092a7608b$var$Gj = $e09959a092a7608b$var$B() + 500, $e09959a092a7608b$var$jg()));
            }
            break;
        case 13:
            $e09959a092a7608b$var$Rk(function() {
                var b = $e09959a092a7608b$var$ih(a, 1);
                if (null !== b) {
                    var c = $e09959a092a7608b$var$R();
                    $e09959a092a7608b$var$gi(b, a, 1, c);
                }
            }), $e09959a092a7608b$var$il(a, 1);
    }
};
$e09959a092a7608b$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e09959a092a7608b$var$ih(a, 134217728);
        if (null !== b) {
            var c = $e09959a092a7608b$var$R();
            $e09959a092a7608b$var$gi(b, a, 134217728, c);
        }
        $e09959a092a7608b$var$il(a, 134217728);
    }
};
$e09959a092a7608b$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e09959a092a7608b$var$yi(a), c = $e09959a092a7608b$var$ih(a, b);
        if (null !== c) {
            var d = $e09959a092a7608b$var$R();
            $e09959a092a7608b$var$gi(c, a, b, d);
        }
        $e09959a092a7608b$var$il(a, b);
    }
};
$e09959a092a7608b$var$Hc = function() {
    return $e09959a092a7608b$var$C;
};
$e09959a092a7608b$var$Ic = function(a, b) {
    var c = $e09959a092a7608b$var$C;
    try {
        return $e09959a092a7608b$var$C = a, b();
    } finally{
        $e09959a092a7608b$var$C = c;
    }
};
$e09959a092a7608b$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e09959a092a7608b$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e09959a092a7608b$var$Db(d);
                        if (!e) throw Error($e09959a092a7608b$var$p(90));
                        $e09959a092a7608b$var$Wa(d);
                        $e09959a092a7608b$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e09959a092a7608b$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e09959a092a7608b$var$fb(a, !!c.multiple, b, !1);
    }
};
$e09959a092a7608b$var$Gb = $e09959a092a7608b$var$Qk;
$e09959a092a7608b$var$Hb = $e09959a092a7608b$var$Rk;
var $e09959a092a7608b$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $e09959a092a7608b$var$Cb,
        $e09959a092a7608b$var$ue,
        $e09959a092a7608b$var$Db,
        $e09959a092a7608b$var$Eb,
        $e09959a092a7608b$var$Fb,
        $e09959a092a7608b$var$Qk
    ]
}, $e09959a092a7608b$var$tl = {
    findFiberByHostInstance: $e09959a092a7608b$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $e09959a092a7608b$var$ul = {
    bundleType: $e09959a092a7608b$var$tl.bundleType,
    version: $e09959a092a7608b$var$tl.version,
    rendererPackageName: $e09959a092a7608b$var$tl.rendererPackageName,
    rendererConfig: $e09959a092a7608b$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e09959a092a7608b$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e09959a092a7608b$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e09959a092a7608b$var$tl.findFiberByHostInstance || $e09959a092a7608b$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e09959a092a7608b$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e09959a092a7608b$var$vl.isDisabled && $e09959a092a7608b$var$vl.supportsFiber) try {
        $e09959a092a7608b$var$kc = $e09959a092a7608b$var$vl.inject($e09959a092a7608b$var$ul), $e09959a092a7608b$var$lc = $e09959a092a7608b$var$vl;
    } catch (a) {}
}
$e09959a092a7608b$export$ae55be85d98224ed = $e09959a092a7608b$var$sl;
$e09959a092a7608b$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e09959a092a7608b$var$nl(b)) throw Error($e09959a092a7608b$var$p(200));
    return $e09959a092a7608b$var$cl(a, b, null, c);
};
$e09959a092a7608b$export$882461b6382ed46c = function(a, b) {
    if (!$e09959a092a7608b$var$nl(a)) throw Error($e09959a092a7608b$var$p(299));
    var c = !1, d = "", e = $e09959a092a7608b$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e09959a092a7608b$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$e09959a092a7608b$var$uf] = b.current;
    $e09959a092a7608b$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e09959a092a7608b$var$ll(b);
};
$e09959a092a7608b$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e09959a092a7608b$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e09959a092a7608b$var$p(268, a));
    }
    a = $e09959a092a7608b$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e09959a092a7608b$export$cd75ccfd720a3cd4 = function(a) {
    return $e09959a092a7608b$var$Rk(a);
};
$e09959a092a7608b$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e09959a092a7608b$var$ol(b)) throw Error($e09959a092a7608b$var$p(200));
    return $e09959a092a7608b$var$rl(null, a, b, !0, c);
};
$e09959a092a7608b$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e09959a092a7608b$var$nl(a)) throw Error($e09959a092a7608b$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e09959a092a7608b$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e09959a092a7608b$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e09959a092a7608b$var$uf] = b.current;
    $e09959a092a7608b$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e09959a092a7608b$var$ml(b);
};
$e09959a092a7608b$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e09959a092a7608b$var$ol(b)) throw Error($e09959a092a7608b$var$p(200));
    return $e09959a092a7608b$var$rl(null, a, b, !1, c);
};
$e09959a092a7608b$export$502457920280e6be = function(a) {
    if (!$e09959a092a7608b$var$ol(a)) throw Error($e09959a092a7608b$var$p(40));
    return a._reactRootContainer ? ($e09959a092a7608b$var$Rk(function() {
        $e09959a092a7608b$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e09959a092a7608b$var$uf] = null;
        });
    }), !0) : !1;
};
$e09959a092a7608b$export$c78a37762a8d58e1 = $e09959a092a7608b$var$Qk;
$e09959a092a7608b$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e09959a092a7608b$var$ol(c)) throw Error($e09959a092a7608b$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e09959a092a7608b$var$p(38));
    return $e09959a092a7608b$var$rl(a, b, c, !1, d);
};
$e09959a092a7608b$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("7DCtq", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fcjP7"));

});
parcelRegister("fcjP7", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $b1075a8380758f91$export$c4744153514ff05d, (v) => $b1075a8380758f91$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $b1075a8380758f91$export$3e506c1ccc9cc1a7, (v) => $b1075a8380758f91$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $b1075a8380758f91$export$e26fe2ed2fa76875, (v) => $b1075a8380758f91$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $b1075a8380758f91$export$502329bbf4b505b1, (v) => $b1075a8380758f91$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $b1075a8380758f91$export$6e3807111c4874c4, (v) => $b1075a8380758f91$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $b1075a8380758f91$export$c27134553091fb3a, (v) => $b1075a8380758f91$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $b1075a8380758f91$export$33ee1acdc04fd2a2, (v) => $b1075a8380758f91$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $b1075a8380758f91$export$b00a404bbd5edef2, (v) => $b1075a8380758f91$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $b1075a8380758f91$export$8352ce38b91d0c62, (v) => $b1075a8380758f91$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $b1075a8380758f91$export$d66a1c1c77bd778b, (v) => $b1075a8380758f91$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $b1075a8380758f91$export$d3dfb8e4810cb555, (v) => $b1075a8380758f91$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $b1075a8380758f91$export$839f9183b0465a69, (v) => $b1075a8380758f91$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $b1075a8380758f91$export$72fdf0e06517287b, (v) => $b1075a8380758f91$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $b1075a8380758f91$export$4b844e58a3e414b4, (v) => $b1075a8380758f91$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $b1075a8380758f91$export$816d2913ae6b83b1, (v) => $b1075a8380758f91$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $b1075a8380758f91$export$61bcfe829111a1d0, (v) => $b1075a8380758f91$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $b1075a8380758f91$export$7ee8c9beb337bc3f, (v) => $b1075a8380758f91$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $b1075a8380758f91$export$b5836b71941fa3ed, (v) => $b1075a8380758f91$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $b1075a8380758f91$export$cf845f2c119da08a, (v) => $b1075a8380758f91$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b1075a8380758f91$export$c4744153514ff05d;
var $b1075a8380758f91$export$3e506c1ccc9cc1a7;
var $b1075a8380758f91$export$e26fe2ed2fa76875;
var $b1075a8380758f91$export$502329bbf4b505b1;
var $b1075a8380758f91$export$6e3807111c4874c4;
var $b1075a8380758f91$export$c27134553091fb3a;
var $b1075a8380758f91$export$33ee1acdc04fd2a2;
var $b1075a8380758f91$export$b00a404bbd5edef2;
var $b1075a8380758f91$export$8352ce38b91d0c62;
var $b1075a8380758f91$export$d66a1c1c77bd778b;
var $b1075a8380758f91$export$d3dfb8e4810cb555;
var $b1075a8380758f91$export$839f9183b0465a69;
var $b1075a8380758f91$export$72fdf0e06517287b;
var $b1075a8380758f91$export$4b844e58a3e414b4;
var $b1075a8380758f91$export$816d2913ae6b83b1;
var $b1075a8380758f91$export$61bcfe829111a1d0;
var $b1075a8380758f91$export$7ee8c9beb337bc3f;
var $b1075a8380758f91$export$b5836b71941fa3ed;
var $b1075a8380758f91$export$cf845f2c119da08a;
'use strict';
function $b1075a8380758f91$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $b1075a8380758f91$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $b1075a8380758f91$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $b1075a8380758f91$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $b1075a8380758f91$var$g(C, c)) n < e && 0 > $b1075a8380758f91$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $b1075a8380758f91$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $b1075a8380758f91$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $b1075a8380758f91$var$l = performance;
    $b1075a8380758f91$export$c4744153514ff05d = function() {
        return $b1075a8380758f91$var$l.now();
    };
} else {
    var $b1075a8380758f91$var$p = Date, $b1075a8380758f91$var$q = $b1075a8380758f91$var$p.now();
    $b1075a8380758f91$export$c4744153514ff05d = function() {
        return $b1075a8380758f91$var$p.now() - $b1075a8380758f91$var$q;
    };
}
var $b1075a8380758f91$var$r = [], $b1075a8380758f91$var$t = [], $b1075a8380758f91$var$u = 1, $b1075a8380758f91$var$v = null, $b1075a8380758f91$var$y = 3, $b1075a8380758f91$var$z = !1, $b1075a8380758f91$var$A = !1, $b1075a8380758f91$var$B = !1, $b1075a8380758f91$var$D = "function" === typeof setTimeout ? setTimeout : null, $b1075a8380758f91$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $b1075a8380758f91$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $b1075a8380758f91$var$G(a) {
    for(var b = $b1075a8380758f91$var$h($b1075a8380758f91$var$t); null !== b;){
        if (null === b.callback) $b1075a8380758f91$var$k($b1075a8380758f91$var$t);
        else if (b.startTime <= a) $b1075a8380758f91$var$k($b1075a8380758f91$var$t), b.sortIndex = b.expirationTime, $b1075a8380758f91$var$f($b1075a8380758f91$var$r, b);
        else break;
        b = $b1075a8380758f91$var$h($b1075a8380758f91$var$t);
    }
}
function $b1075a8380758f91$var$H(a) {
    $b1075a8380758f91$var$B = !1;
    $b1075a8380758f91$var$G(a);
    if (!$b1075a8380758f91$var$A) {
        if (null !== $b1075a8380758f91$var$h($b1075a8380758f91$var$r)) $b1075a8380758f91$var$A = !0, $b1075a8380758f91$var$I($b1075a8380758f91$var$J);
        else {
            var b = $b1075a8380758f91$var$h($b1075a8380758f91$var$t);
            null !== b && $b1075a8380758f91$var$K($b1075a8380758f91$var$H, b.startTime - a);
        }
    }
}
function $b1075a8380758f91$var$J(a, b) {
    $b1075a8380758f91$var$A = !1;
    $b1075a8380758f91$var$B && ($b1075a8380758f91$var$B = !1, $b1075a8380758f91$var$E($b1075a8380758f91$var$L), $b1075a8380758f91$var$L = -1);
    $b1075a8380758f91$var$z = !0;
    var c = $b1075a8380758f91$var$y;
    try {
        $b1075a8380758f91$var$G(b);
        for($b1075a8380758f91$var$v = $b1075a8380758f91$var$h($b1075a8380758f91$var$r); null !== $b1075a8380758f91$var$v && (!($b1075a8380758f91$var$v.expirationTime > b) || a && !$b1075a8380758f91$var$M());){
            var d = $b1075a8380758f91$var$v.callback;
            if ("function" === typeof d) {
                $b1075a8380758f91$var$v.callback = null;
                $b1075a8380758f91$var$y = $b1075a8380758f91$var$v.priorityLevel;
                var e = d($b1075a8380758f91$var$v.expirationTime <= b);
                b = $b1075a8380758f91$export$c4744153514ff05d();
                "function" === typeof e ? $b1075a8380758f91$var$v.callback = e : $b1075a8380758f91$var$v === $b1075a8380758f91$var$h($b1075a8380758f91$var$r) && $b1075a8380758f91$var$k($b1075a8380758f91$var$r);
                $b1075a8380758f91$var$G(b);
            } else $b1075a8380758f91$var$k($b1075a8380758f91$var$r);
            $b1075a8380758f91$var$v = $b1075a8380758f91$var$h($b1075a8380758f91$var$r);
        }
        if (null !== $b1075a8380758f91$var$v) var w = !0;
        else {
            var m = $b1075a8380758f91$var$h($b1075a8380758f91$var$t);
            null !== m && $b1075a8380758f91$var$K($b1075a8380758f91$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $b1075a8380758f91$var$v = null, $b1075a8380758f91$var$y = c, $b1075a8380758f91$var$z = !1;
    }
}
var $b1075a8380758f91$var$N = !1, $b1075a8380758f91$var$O = null, $b1075a8380758f91$var$L = -1, $b1075a8380758f91$var$P = 5, $b1075a8380758f91$var$Q = -1;
function $b1075a8380758f91$var$M() {
    return $b1075a8380758f91$export$c4744153514ff05d() - $b1075a8380758f91$var$Q < $b1075a8380758f91$var$P ? !1 : !0;
}
function $b1075a8380758f91$var$R() {
    if (null !== $b1075a8380758f91$var$O) {
        var a = $b1075a8380758f91$export$c4744153514ff05d();
        $b1075a8380758f91$var$Q = a;
        var b = !0;
        try {
            b = $b1075a8380758f91$var$O(!0, a);
        } finally{
            b ? $b1075a8380758f91$var$S() : ($b1075a8380758f91$var$N = !1, $b1075a8380758f91$var$O = null);
        }
    } else $b1075a8380758f91$var$N = !1;
}
var $b1075a8380758f91$var$S;
if ("function" === typeof $b1075a8380758f91$var$F) $b1075a8380758f91$var$S = function() {
    $b1075a8380758f91$var$F($b1075a8380758f91$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $b1075a8380758f91$var$T = new MessageChannel, $b1075a8380758f91$var$U = $b1075a8380758f91$var$T.port2;
    $b1075a8380758f91$var$T.port1.onmessage = $b1075a8380758f91$var$R;
    $b1075a8380758f91$var$S = function() {
        $b1075a8380758f91$var$U.postMessage(null);
    };
} else $b1075a8380758f91$var$S = function() {
    $b1075a8380758f91$var$D($b1075a8380758f91$var$R, 0);
};
function $b1075a8380758f91$var$I(a) {
    $b1075a8380758f91$var$O = a;
    $b1075a8380758f91$var$N || ($b1075a8380758f91$var$N = !0, $b1075a8380758f91$var$S());
}
function $b1075a8380758f91$var$K(a, b) {
    $b1075a8380758f91$var$L = $b1075a8380758f91$var$D(function() {
        a($b1075a8380758f91$export$c4744153514ff05d());
    }, b);
}
$b1075a8380758f91$export$3e506c1ccc9cc1a7 = 5;
$b1075a8380758f91$export$e26fe2ed2fa76875 = 1;
$b1075a8380758f91$export$502329bbf4b505b1 = 4;
$b1075a8380758f91$export$6e3807111c4874c4 = 3;
$b1075a8380758f91$export$c27134553091fb3a = null;
$b1075a8380758f91$export$33ee1acdc04fd2a2 = 2;
$b1075a8380758f91$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$b1075a8380758f91$export$8352ce38b91d0c62 = function() {
    $b1075a8380758f91$var$A || $b1075a8380758f91$var$z || ($b1075a8380758f91$var$A = !0, $b1075a8380758f91$var$I($b1075a8380758f91$var$J));
};
$b1075a8380758f91$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $b1075a8380758f91$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$b1075a8380758f91$export$d3dfb8e4810cb555 = function() {
    return $b1075a8380758f91$var$y;
};
$b1075a8380758f91$export$839f9183b0465a69 = function() {
    return $b1075a8380758f91$var$h($b1075a8380758f91$var$r);
};
$b1075a8380758f91$export$72fdf0e06517287b = function(a) {
    switch($b1075a8380758f91$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $b1075a8380758f91$var$y;
    }
    var c = $b1075a8380758f91$var$y;
    $b1075a8380758f91$var$y = b;
    try {
        return a();
    } finally{
        $b1075a8380758f91$var$y = c;
    }
};
$b1075a8380758f91$export$4b844e58a3e414b4 = function() {};
$b1075a8380758f91$export$816d2913ae6b83b1 = function() {};
$b1075a8380758f91$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $b1075a8380758f91$var$y;
    $b1075a8380758f91$var$y = a;
    try {
        return b();
    } finally{
        $b1075a8380758f91$var$y = c;
    }
};
$b1075a8380758f91$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $b1075a8380758f91$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $b1075a8380758f91$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $b1075a8380758f91$var$f($b1075a8380758f91$var$t, a), null === $b1075a8380758f91$var$h($b1075a8380758f91$var$r) && a === $b1075a8380758f91$var$h($b1075a8380758f91$var$t) && ($b1075a8380758f91$var$B ? ($b1075a8380758f91$var$E($b1075a8380758f91$var$L), $b1075a8380758f91$var$L = -1) : $b1075a8380758f91$var$B = !0, $b1075a8380758f91$var$K($b1075a8380758f91$var$H, c - d))) : (a.sortIndex = e, $b1075a8380758f91$var$f($b1075a8380758f91$var$r, a), $b1075a8380758f91$var$A || $b1075a8380758f91$var$z || ($b1075a8380758f91$var$A = !0, $b1075a8380758f91$var$I($b1075a8380758f91$var$J)));
    return a;
};
$b1075a8380758f91$export$b5836b71941fa3ed = $b1075a8380758f91$var$M;
$b1075a8380758f91$export$cf845f2c119da08a = function(a) {
    var b = $b1075a8380758f91$var$y;
    return function() {
        var c = $b1075a8380758f91$var$y;
        $b1075a8380758f91$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $b1075a8380758f91$var$y = c;
        }
    };
};

});



var $d00e5d22a0b5e103$exports = {};
'use strict';

$d00e5d22a0b5e103$exports = (parcelRequire("b8reE"));



var $8tsvq = parcelRequire("8tsvq");
var $416246511aeb39de$exports = {};

$parcel$export($416246511aeb39de$exports, "createRoot", () => $416246511aeb39de$export$882461b6382ed46c, (v) => $416246511aeb39de$export$882461b6382ed46c = v);
$parcel$export($416246511aeb39de$exports, "hydrateRoot", () => $416246511aeb39de$export$757ceba2d55c277e, (v) => $416246511aeb39de$export$757ceba2d55c277e = v);
var $416246511aeb39de$export$882461b6382ed46c;
var $416246511aeb39de$export$757ceba2d55c277e;
'use strict';
var $a2d184922ae7f92f$exports = {};
'use strict';
function $a2d184922ae7f92f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a2d184922ae7f92f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a2d184922ae7f92f$var$checkDCE();

$a2d184922ae7f92f$exports = (parcelRequire("jhxbP"));


var $416246511aeb39de$var$i;
$416246511aeb39de$export$882461b6382ed46c = $a2d184922ae7f92f$exports.createRoot;
$416246511aeb39de$export$757ceba2d55c277e = $a2d184922ae7f92f$exports.hydrateRoot;




parcelRequire("8tsvq");
/**
 * React Router DOM v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8tsvq = parcelRequire("8tsvq");

/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $cec6b334748d9a6c$var$_extends() {
    $cec6b334748d9a6c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cec6b334748d9a6c$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $cec6b334748d9a6c$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($cec6b334748d9a6c$export$e19cd5f9376f8cee || ($cec6b334748d9a6c$export$e19cd5f9376f8cee = {}));
const $cec6b334748d9a6c$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $cec6b334748d9a6c$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $cec6b334748d9a6c$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $cec6b334748d9a6c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $cec6b334748d9a6c$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $cec6b334748d9a6c$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $cec6b334748d9a6c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $cec6b334748d9a6c$export$fe53371bee54353d(to);
    }
    return $cec6b334748d9a6c$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $cec6b334748d9a6c$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $cec6b334748d9a6c$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $cec6b334748d9a6c$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $cec6b334748d9a6c$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $cec6b334748d9a6c$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $cec6b334748d9a6c$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $cec6b334748d9a6c$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $cec6b334748d9a6c$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $cec6b334748d9a6c$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $cec6b334748d9a6c$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $cec6b334748d9a6c$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $cec6b334748d9a6c$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $cec6b334748d9a6c$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $cec6b334748d9a6c$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $cec6b334748d9a6c$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $cec6b334748d9a6c$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($cec6b334748d9a6c$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push;
        let location = $cec6b334748d9a6c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $cec6b334748d9a6c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace;
        let location = $cec6b334748d9a6c$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $cec6b334748d9a6c$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $cec6b334748d9a6c$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $cec6b334748d9a6c$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($cec6b334748d9a6c$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($cec6b334748d9a6c$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $cec6b334748d9a6c$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($cec6b334748d9a6c$var$ResultType || ($cec6b334748d9a6c$var$ResultType = {}));
const $cec6b334748d9a6c$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $cec6b334748d9a6c$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $cec6b334748d9a6c$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $cec6b334748d9a6c$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $cec6b334748d9a6c$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($cec6b334748d9a6c$var$isIndexRoute(route)) {
            let indexRoute = $cec6b334748d9a6c$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $cec6b334748d9a6c$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $cec6b334748d9a6c$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $cec6b334748d9a6c$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $cec6b334748d9a6c$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $cec6b334748d9a6c$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $cec6b334748d9a6c$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $cec6b334748d9a6c$var$flattenRoutes(routes);
    $cec6b334748d9a6c$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $cec6b334748d9a6c$export$30d21fd6d7295f52(pathname);
        matches = $cec6b334748d9a6c$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $cec6b334748d9a6c$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $cec6b334748d9a6c$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $cec6b334748d9a6c$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $cec6b334748d9a6c$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $cec6b334748d9a6c$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $cec6b334748d9a6c$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $cec6b334748d9a6c$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $cec6b334748d9a6c$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $cec6b334748d9a6c$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $cec6b334748d9a6c$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $cec6b334748d9a6c$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $cec6b334748d9a6c$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $cec6b334748d9a6c$var$paramRe = /^:[\w-]+$/;
const $cec6b334748d9a6c$var$dynamicSegmentValue = 3;
const $cec6b334748d9a6c$var$indexRouteValue = 2;
const $cec6b334748d9a6c$var$emptySegmentValue = 1;
const $cec6b334748d9a6c$var$staticSegmentValue = 10;
const $cec6b334748d9a6c$var$splatPenalty = -2;
const $cec6b334748d9a6c$var$isSplat = (s)=>s === "*";
function $cec6b334748d9a6c$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($cec6b334748d9a6c$var$isSplat)) initialScore += $cec6b334748d9a6c$var$splatPenalty;
    if (index) initialScore += $cec6b334748d9a6c$var$indexRouteValue;
    return segments.filter((s)=>!$cec6b334748d9a6c$var$isSplat(s)).reduce((score, segment)=>score + ($cec6b334748d9a6c$var$paramRe.test(segment) ? $cec6b334748d9a6c$var$dynamicSegmentValue : segment === "" ? $cec6b334748d9a6c$var$emptySegmentValue : $cec6b334748d9a6c$var$staticSegmentValue), initialScore);
}
function $cec6b334748d9a6c$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $cec6b334748d9a6c$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $cec6b334748d9a6c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $cec6b334748d9a6c$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $cec6b334748d9a6c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $cec6b334748d9a6c$export$a5c6d149b50c1d86($cec6b334748d9a6c$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $cec6b334748d9a6c$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $cec6b334748d9a6c$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $cec6b334748d9a6c$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $cec6b334748d9a6c$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $cec6b334748d9a6c$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $cec6b334748d9a6c$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $cec6b334748d9a6c$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $cec6b334748d9a6c$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $cec6b334748d9a6c$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $cec6b334748d9a6c$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $cec6b334748d9a6c$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $cec6b334748d9a6c$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $cec6b334748d9a6c$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $cec6b334748d9a6c$var$normalizeSearch(search),
        hash: $cec6b334748d9a6c$var$normalizeHash(hash)
    };
}
function $cec6b334748d9a6c$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $cec6b334748d9a6c$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $cec6b334748d9a6c$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $cec6b334748d9a6c$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $cec6b334748d9a6c$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $cec6b334748d9a6c$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $cec6b334748d9a6c$export$8ccf933b0513f8d0(toArg);
    else {
        to = $cec6b334748d9a6c$var$_extends({}, toArg);
        $cec6b334748d9a6c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $cec6b334748d9a6c$var$getInvalidPathError("?", "pathname", "search", to));
        $cec6b334748d9a6c$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $cec6b334748d9a6c$var$getInvalidPathError("#", "pathname", "hash", to));
        $cec6b334748d9a6c$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $cec6b334748d9a6c$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $cec6b334748d9a6c$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $cec6b334748d9a6c$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $cec6b334748d9a6c$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $cec6b334748d9a6c$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $cec6b334748d9a6c$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $cec6b334748d9a6c$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $cec6b334748d9a6c$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $cec6b334748d9a6c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $cec6b334748d9a6c$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $cec6b334748d9a6c$export$4051a07651545597(data, init) {
    return new $cec6b334748d9a6c$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $cec6b334748d9a6c$export$42a99a7a4bc0e76a extends Error {
}
class $cec6b334748d9a6c$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $cec6b334748d9a6c$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $cec6b334748d9a6c$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $cec6b334748d9a6c$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $cec6b334748d9a6c$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $cec6b334748d9a6c$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $cec6b334748d9a6c$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $cec6b334748d9a6c$var$unwrapTrackedPromise(value) {
    if (!$cec6b334748d9a6c$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $cec6b334748d9a6c$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $cec6b334748d9a6c$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $cec6b334748d9a6c$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $cec6b334748d9a6c$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $cec6b334748d9a6c$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $cec6b334748d9a6c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $cec6b334748d9a6c$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $cec6b334748d9a6c$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $cec6b334748d9a6c$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $cec6b334748d9a6c$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $cec6b334748d9a6c$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $cec6b334748d9a6c$var$validMutationMethods = new Set($cec6b334748d9a6c$var$validMutationMethodsArr);
const $cec6b334748d9a6c$var$validRequestMethodsArr = [
    "get",
    ...$cec6b334748d9a6c$var$validMutationMethodsArr
];
const $cec6b334748d9a6c$var$validRequestMethods = new Set($cec6b334748d9a6c$var$validRequestMethodsArr);
const $cec6b334748d9a6c$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $cec6b334748d9a6c$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $cec6b334748d9a6c$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $cec6b334748d9a6c$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $cec6b334748d9a6c$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $cec6b334748d9a6c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $cec6b334748d9a6c$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $cec6b334748d9a6c$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $cec6b334748d9a6c$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $cec6b334748d9a6c$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $cec6b334748d9a6c$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $cec6b334748d9a6c$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $cec6b334748d9a6c$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $cec6b334748d9a6c$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $cec6b334748d9a6c$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $cec6b334748d9a6c$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $cec6b334748d9a6c$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$cec6b334748d9a6c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$cec6b334748d9a6c$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $cec6b334748d9a6c$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $cec6b334748d9a6c$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $cec6b334748d9a6c$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $cec6b334748d9a6c$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$cec6b334748d9a6c$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $cec6b334748d9a6c$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $cec6b334748d9a6c$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $cec6b334748d9a6c$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $cec6b334748d9a6c$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $cec6b334748d9a6c$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($cec6b334748d9a6c$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $cec6b334748d9a6c$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $cec6b334748d9a6c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $cec6b334748d9a6c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $cec6b334748d9a6c$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $cec6b334748d9a6c$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $cec6b334748d9a6c$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $cec6b334748d9a6c$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $cec6b334748d9a6c$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $cec6b334748d9a6c$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $cec6b334748d9a6c$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $cec6b334748d9a6c$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $cec6b334748d9a6c$var$findNearestBoundary(matches).route.id,
            {
                type: $cec6b334748d9a6c$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $cec6b334748d9a6c$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($cec6b334748d9a6c$var$isErrorResult(result) && $cec6b334748d9a6c$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $cec6b334748d9a6c$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $cec6b334748d9a6c$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $cec6b334748d9a6c$var$_extends({
            matches: updatedMatches || matches
        }, $cec6b334748d9a6c$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $cec6b334748d9a6c$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $cec6b334748d9a6c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $cec6b334748d9a6c$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $cec6b334748d9a6c$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $cec6b334748d9a6c$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $cec6b334748d9a6c$var$ResultType.error,
            error: $cec6b334748d9a6c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($cec6b334748d9a6c$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $cec6b334748d9a6c$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($cec6b334748d9a6c$var$isDeferredResult(result)) throw $cec6b334748d9a6c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($cec6b334748d9a6c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $cec6b334748d9a6c$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $cec6b334748d9a6c$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $cec6b334748d9a6c$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($cec6b334748d9a6c$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $cec6b334748d9a6c$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $cec6b334748d9a6c$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $cec6b334748d9a6c$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $cec6b334748d9a6c$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $cec6b334748d9a6c$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $cec6b334748d9a6c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $cec6b334748d9a6c$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $cec6b334748d9a6c$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $cec6b334748d9a6c$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $cec6b334748d9a6c$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $cec6b334748d9a6c$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $cec6b334748d9a6c$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $cec6b334748d9a6c$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $cec6b334748d9a6c$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $cec6b334748d9a6c$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $cec6b334748d9a6c$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $cec6b334748d9a6c$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $cec6b334748d9a6c$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $cec6b334748d9a6c$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $cec6b334748d9a6c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $cec6b334748d9a6c$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($cec6b334748d9a6c$var$isRedirectResult(actionResult) || $cec6b334748d9a6c$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $cec6b334748d9a6c$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($cec6b334748d9a6c$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $cec6b334748d9a6c$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $cec6b334748d9a6c$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($cec6b334748d9a6c$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($cec6b334748d9a6c$var$isDeferredResult(actionResult)) throw $cec6b334748d9a6c$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $cec6b334748d9a6c$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $cec6b334748d9a6c$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $cec6b334748d9a6c$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $cec6b334748d9a6c$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $cec6b334748d9a6c$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $cec6b334748d9a6c$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $cec6b334748d9a6c$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $cec6b334748d9a6c$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $cec6b334748d9a6c$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $cec6b334748d9a6c$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $cec6b334748d9a6c$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $cec6b334748d9a6c$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $cec6b334748d9a6c$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $cec6b334748d9a6c$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $cec6b334748d9a6c$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $cec6b334748d9a6c$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($cec6b334748d9a6c$var$isDeferredResult(result)) result = await $cec6b334748d9a6c$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $cec6b334748d9a6c$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($cec6b334748d9a6c$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $cec6b334748d9a6c$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($cec6b334748d9a6c$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $cec6b334748d9a6c$export$3e9cee6b33872309(!$cec6b334748d9a6c$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $cec6b334748d9a6c$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $cec6b334748d9a6c$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $cec6b334748d9a6c$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $cec6b334748d9a6c$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($cec6b334748d9a6c$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $cec6b334748d9a6c$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $cec6b334748d9a6c$export$e19cd5f9376f8cee.Replace : $cec6b334748d9a6c$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $cec6b334748d9a6c$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($cec6b334748d9a6c$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $cec6b334748d9a6c$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $cec6b334748d9a6c$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $cec6b334748d9a6c$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $cec6b334748d9a6c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $cec6b334748d9a6c$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($cec6b334748d9a6c$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $cec6b334748d9a6c$var$ResultType.redirect,
                response: $cec6b334748d9a6c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $cec6b334748d9a6c$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $cec6b334748d9a6c$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $cec6b334748d9a6c$var$ResultType.error,
                    error: $cec6b334748d9a6c$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $cec6b334748d9a6c$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $cec6b334748d9a6c$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $cec6b334748d9a6c$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $cec6b334748d9a6c$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $cec6b334748d9a6c$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $cec6b334748d9a6c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $cec6b334748d9a6c$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $cec6b334748d9a6c$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $cec6b334748d9a6c$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $cec6b334748d9a6c$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $cec6b334748d9a6c$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $cec6b334748d9a6c$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $cec6b334748d9a6c$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $cec6b334748d9a6c$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$cec6b334748d9a6c$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $cec6b334748d9a6c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $cec6b334748d9a6c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $cec6b334748d9a6c$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $cec6b334748d9a6c$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $cec6b334748d9a6c$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $cec6b334748d9a6c$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $cec6b334748d9a6c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $cec6b334748d9a6c$export$4d0306f8f6a4585b = Symbol("deferred");
function $cec6b334748d9a6c$export$3336b097a6fbc59a(routes, opts) {
    $cec6b334748d9a6c$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $cec6b334748d9a6c$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $cec6b334748d9a6c$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $cec6b334748d9a6c$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $cec6b334748d9a6c$var$createLocation("", $cec6b334748d9a6c$export$fe53371bee54353d(url), null, "default");
        let matches = $cec6b334748d9a6c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$cec6b334748d9a6c$var$isValidMethod(method) && method !== "HEAD") {
            let error = $cec6b334748d9a6c$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $cec6b334748d9a6c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $cec6b334748d9a6c$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $cec6b334748d9a6c$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($cec6b334748d9a6c$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $cec6b334748d9a6c$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $cec6b334748d9a6c$var$createLocation("", $cec6b334748d9a6c$export$fe53371bee54353d(url), null, "default");
        let matches = $cec6b334748d9a6c$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$cec6b334748d9a6c$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $cec6b334748d9a6c$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $cec6b334748d9a6c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $cec6b334748d9a6c$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $cec6b334748d9a6c$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $cec6b334748d9a6c$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($cec6b334748d9a6c$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$cec6b334748d9a6c$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $cec6b334748d9a6c$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($cec6b334748d9a6c$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $cec6b334748d9a6c$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $cec6b334748d9a6c$var$isResponse(result) ? result : $cec6b334748d9a6c$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($cec6b334748d9a6c$var$isDataStrategyResult(e) && $cec6b334748d9a6c$var$isResponse(e.result)) {
                if (e.type === $cec6b334748d9a6c$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($cec6b334748d9a6c$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $cec6b334748d9a6c$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $cec6b334748d9a6c$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $cec6b334748d9a6c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($cec6b334748d9a6c$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($cec6b334748d9a6c$var$isDeferredResult(result)) {
            let error = $cec6b334748d9a6c$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $cec6b334748d9a6c$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($cec6b334748d9a6c$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($cec6b334748d9a6c$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $cec6b334748d9a6c$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $cec6b334748d9a6c$var$_extends({}, context, {
                statusCode: $cec6b334748d9a6c$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $cec6b334748d9a6c$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $cec6b334748d9a6c$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $cec6b334748d9a6c$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? $cec6b334748d9a6c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $cec6b334748d9a6c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $cec6b334748d9a6c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $cec6b334748d9a6c$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $cec6b334748d9a6c$var$callDataStrategyImpl(dataStrategy || $cec6b334748d9a6c$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($cec6b334748d9a6c$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $cec6b334748d9a6c$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($cec6b334748d9a6c$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $cec6b334748d9a6c$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $cec6b334748d9a6c$export$fec11da027c70692(routes, context, error) {
    let newContext = $cec6b334748d9a6c$var$_extends({}, context, {
        statusCode: $cec6b334748d9a6c$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $cec6b334748d9a6c$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $cec6b334748d9a6c$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $cec6b334748d9a6c$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $cec6b334748d9a6c$export$cae722b0cc860f13(to ? to : ".", $cec6b334748d9a6c$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $cec6b334748d9a6c$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $cec6b334748d9a6c$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $cec6b334748d9a6c$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $cec6b334748d9a6c$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $cec6b334748d9a6c$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$cec6b334748d9a6c$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$cec6b334748d9a6c$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $cec6b334748d9a6c$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $cec6b334748d9a6c$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $cec6b334748d9a6c$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$cec6b334748d9a6c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$cec6b334748d9a6c$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $cec6b334748d9a6c$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $cec6b334748d9a6c$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $cec6b334748d9a6c$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $cec6b334748d9a6c$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $cec6b334748d9a6c$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($cec6b334748d9a6c$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $cec6b334748d9a6c$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $cec6b334748d9a6c$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $cec6b334748d9a6c$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $cec6b334748d9a6c$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $cec6b334748d9a6c$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $cec6b334748d9a6c$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $cec6b334748d9a6c$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $cec6b334748d9a6c$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($cec6b334748d9a6c$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $cec6b334748d9a6c$var$shouldRevalidateLoader(match, $cec6b334748d9a6c$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $cec6b334748d9a6c$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $cec6b334748d9a6c$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $cec6b334748d9a6c$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $cec6b334748d9a6c$var$shouldRevalidateLoader(fetcherMatch, $cec6b334748d9a6c$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $cec6b334748d9a6c$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $cec6b334748d9a6c$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $cec6b334748d9a6c$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $cec6b334748d9a6c$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $cec6b334748d9a6c$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $cec6b334748d9a6c$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$cec6b334748d9a6c$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $cec6b334748d9a6c$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $cec6b334748d9a6c$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$cec6b334748d9a6c$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $cec6b334748d9a6c$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $cec6b334748d9a6c$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $cec6b334748d9a6c$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$cec6b334748d9a6c$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $cec6b334748d9a6c$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $cec6b334748d9a6c$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $cec6b334748d9a6c$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $cec6b334748d9a6c$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $cec6b334748d9a6c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $cec6b334748d9a6c$var$ResultType.data,
                result: undefined
            });
        };
        return $cec6b334748d9a6c$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $cec6b334748d9a6c$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $cec6b334748d9a6c$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $cec6b334748d9a6c$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $cec6b334748d9a6c$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $cec6b334748d9a6c$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $cec6b334748d9a6c$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $cec6b334748d9a6c$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($cec6b334748d9a6c$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $cec6b334748d9a6c$var$ResultType.error,
                error: e
            };
        }
        if (type === $cec6b334748d9a6c$var$ResultType.error) return {
            type: $cec6b334748d9a6c$var$ResultType.error,
            error: new $cec6b334748d9a6c$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $cec6b334748d9a6c$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $cec6b334748d9a6c$var$ResultType.error) {
        if ($cec6b334748d9a6c$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $cec6b334748d9a6c$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $cec6b334748d9a6c$var$ResultType.error,
                error: new $cec6b334748d9a6c$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $cec6b334748d9a6c$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $cec6b334748d9a6c$var$ResultType.error,
            error: result,
            statusCode: $cec6b334748d9a6c$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($cec6b334748d9a6c$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $cec6b334748d9a6c$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($cec6b334748d9a6c$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $cec6b334748d9a6c$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $cec6b334748d9a6c$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $cec6b334748d9a6c$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $cec6b334748d9a6c$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$cec6b334748d9a6c$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $cec6b334748d9a6c$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $cec6b334748d9a6c$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($cec6b334748d9a6c$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $cec6b334748d9a6c$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $cec6b334748d9a6c$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($cec6b334748d9a6c$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $cec6b334748d9a6c$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $cec6b334748d9a6c$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $cec6b334748d9a6c$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $cec6b334748d9a6c$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $cec6b334748d9a6c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $cec6b334748d9a6c$export$3e9cee6b33872309(!$cec6b334748d9a6c$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($cec6b334748d9a6c$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $cec6b334748d9a6c$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $cec6b334748d9a6c$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($cec6b334748d9a6c$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $cec6b334748d9a6c$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $cec6b334748d9a6c$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $cec6b334748d9a6c$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($cec6b334748d9a6c$var$isErrorResult(result)) {
            let boundaryMatch = $cec6b334748d9a6c$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $cec6b334748d9a6c$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($cec6b334748d9a6c$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $cec6b334748d9a6c$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($cec6b334748d9a6c$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $cec6b334748d9a6c$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $cec6b334748d9a6c$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $cec6b334748d9a6c$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $cec6b334748d9a6c$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $cec6b334748d9a6c$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $cec6b334748d9a6c$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $cec6b334748d9a6c$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $cec6b334748d9a6c$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $cec6b334748d9a6c$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $cec6b334748d9a6c$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $cec6b334748d9a6c$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($cec6b334748d9a6c$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $cec6b334748d9a6c$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(path) : path;
    return $cec6b334748d9a6c$export$fe53371bee54353d($cec6b334748d9a6c$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $cec6b334748d9a6c$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $cec6b334748d9a6c$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $cec6b334748d9a6c$var$ResultType.data || result.type === $cec6b334748d9a6c$var$ResultType.error);
}
function $cec6b334748d9a6c$var$isRedirectDataStrategyResultResult(result) {
    return $cec6b334748d9a6c$var$isResponse(result.result) && $cec6b334748d9a6c$var$redirectStatusCodes.has(result.result.status);
}
function $cec6b334748d9a6c$var$isDeferredResult(result) {
    return result.type === $cec6b334748d9a6c$var$ResultType.deferred;
}
function $cec6b334748d9a6c$var$isErrorResult(result) {
    return result.type === $cec6b334748d9a6c$var$ResultType.error;
}
function $cec6b334748d9a6c$var$isRedirectResult(result) {
    return (result && result.type) === $cec6b334748d9a6c$var$ResultType.redirect;
}
function $cec6b334748d9a6c$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $cec6b334748d9a6c$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $cec6b334748d9a6c$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $cec6b334748d9a6c$var$isRedirectResponse(result) {
    if (!$cec6b334748d9a6c$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $cec6b334748d9a6c$var$isValidMethod(method) {
    return $cec6b334748d9a6c$var$validRequestMethods.has(method.toLowerCase());
}
function $cec6b334748d9a6c$var$isMutationMethod(method) {
    return $cec6b334748d9a6c$var$validMutationMethods.has(method.toLowerCase());
}
async function $cec6b334748d9a6c$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$cec6b334748d9a6c$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($cec6b334748d9a6c$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $cec6b334748d9a6c$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $cec6b334748d9a6c$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($cec6b334748d9a6c$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $cec6b334748d9a6c$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $cec6b334748d9a6c$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $cec6b334748d9a6c$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $cec6b334748d9a6c$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $cec6b334748d9a6c$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $cec6b334748d9a6c$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $cec6b334748d9a6c$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $cec6b334748d9a6c$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $cec6b334748d9a6c$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $cec6b334748d9a6c$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $cec6b334748d9a6c$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $cec6b334748d9a6c$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $cec6b334748d9a6c$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $cec6b334748d9a6c$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $cec6b334748d9a6c$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $cec6b334748d9a6c$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $cec6b334748d9a6c$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $cec6b334748d9a6c$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($cec6b334748d9a6c$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $cec6b334748d9a6c$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($cec6b334748d9a6c$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $cec6b334748d9a6c$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8tsvq = parcelRequire("8tsvq");

function $5bc57f835864eb51$var$_extends() {
    $5bc57f835864eb51$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5bc57f835864eb51$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $5bc57f835864eb51$export$3add0d5dce533e2e = /*#__PURE__*/ $8tsvq.createContext(null);
const $5bc57f835864eb51$export$145dfa71566a64dc = /*#__PURE__*/ $8tsvq.createContext(null);
const $5bc57f835864eb51$var$AwaitContext = /*#__PURE__*/ $8tsvq.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $5bc57f835864eb51$export$26749e8557646306 = /*#__PURE__*/ $8tsvq.createContext(null);
const $5bc57f835864eb51$export$c7914228fb69b0f5 = /*#__PURE__*/ $8tsvq.createContext(null);
const $5bc57f835864eb51$export$9072aa6dd1f93057 = /*#__PURE__*/ $8tsvq.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $5bc57f835864eb51$var$RouteErrorContext = /*#__PURE__*/ $8tsvq.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $5bc57f835864eb51$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $5bc57f835864eb51$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $cec6b334748d9a6c$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $5bc57f835864eb51$export$9c954a9d03d32f4a() {
    return $8tsvq.useContext($5bc57f835864eb51$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $5bc57f835864eb51$export$45d76561a5302f2b() {
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return $8tsvq.useContext($5bc57f835864eb51$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $5bc57f835864eb51$export$1b3f31771c5d07c() {
    return $8tsvq.useContext($5bc57f835864eb51$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $5bc57f835864eb51$export$6c330e8992e8a295(pattern) {
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $5bc57f835864eb51$export$45d76561a5302f2b();
    return $8tsvq.useMemo(()=>(0, $cec6b334748d9a6c$export$81336c211d5ff295)(pattern, (0, $cec6b334748d9a6c$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $5bc57f835864eb51$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $5bc57f835864eb51$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8tsvq.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $5bc57f835864eb51$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $5bc57f835864eb51$var$useNavigateStable() : $5bc57f835864eb51$var$useNavigateUnstable();
}
function $5bc57f835864eb51$var$useNavigateUnstable() {
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let dataRouterContext = $8tsvq.useContext($5bc57f835864eb51$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306);
    let { matches: matches } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5bc57f835864eb51$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $cec6b334748d9a6c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $8tsvq.useRef(false);
    $5bc57f835864eb51$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8tsvq.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $cec6b334748d9a6c$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $cec6b334748d9a6c$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $5bc57f835864eb51$var$OutletContext = /*#__PURE__*/ $8tsvq.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $5bc57f835864eb51$export$4138103a3ae699cc() {
    return $8tsvq.useContext($5bc57f835864eb51$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $5bc57f835864eb51$export$a3be3530d8e40d0b(context) {
    let outlet = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $5bc57f835864eb51$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $5bc57f835864eb51$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306);
    let { matches: matches } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5bc57f835864eb51$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $cec6b334748d9a6c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $8tsvq.useMemo(()=>(0, $cec6b334748d9a6c$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $5bc57f835864eb51$export$5d3fca4a98652595(routes, locationArg) {
    return $5bc57f835864eb51$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $5bc57f835864eb51$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306);
    let { matches: parentMatches } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $5bc57f835864eb51$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $cec6b334748d9a6c$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $cec6b334748d9a6c$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $5bc57f835864eb51$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $cec6b334748d9a6c$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $cec6b334748d9a6c$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $5bc57f835864eb51$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $cec6b334748d9a6c$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $5bc57f835864eb51$var$DefaultErrorComponent() {
    let error = $5bc57f835864eb51$export$ed527bf60f6e05f2();
    let message = (0, $cec6b334748d9a6c$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8tsvq.createElement($8tsvq.Fragment, null, /*#__PURE__*/ $8tsvq.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8tsvq.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8tsvq.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $5bc57f835864eb51$var$defaultErrorElement = /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$DefaultErrorComponent, null);
class $5bc57f835864eb51$var$RenderErrorBoundary extends $8tsvq.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $5bc57f835864eb51$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8tsvq.useContext($5bc57f835864eb51$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $5bc57f835864eb51$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $5bc57f835864eb51$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $5bc57f835864eb51$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8tsvq.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $5bc57f835864eb51$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($5bc57f835864eb51$var$DataRouterHook || {});
var $5bc57f835864eb51$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($5bc57f835864eb51$var$DataRouterStateHook || {});
function $5bc57f835864eb51$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $5bc57f835864eb51$var$useDataRouterContext(hookName) {
    let ctx = $8tsvq.useContext($5bc57f835864eb51$export$3add0d5dce533e2e);
    !ctx && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return ctx;
}
function $5bc57f835864eb51$var$useDataRouterState(hookName) {
    let state = $8tsvq.useContext($5bc57f835864eb51$export$145dfa71566a64dc);
    !state && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return state;
}
function $5bc57f835864eb51$var$useRouteContext(hookName) {
    let route = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    !route && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $5bc57f835864eb51$var$useCurrentRouteId(hookName) {
    let route = $5bc57f835864eb51$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $5bc57f835864eb51$export$5fc8298006ad9e58() {
    return $5bc57f835864eb51$var$useCurrentRouteId($5bc57f835864eb51$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $5bc57f835864eb51$export$d0fd4b7106de2769() {
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $5bc57f835864eb51$export$600dc272ed516c15() {
    let dataRouterContext = $5bc57f835864eb51$var$useDataRouterContext($5bc57f835864eb51$var$DataRouterHook.UseRevalidator);
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseRevalidator);
    return $8tsvq.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $5bc57f835864eb51$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseMatches);
    return $8tsvq.useMemo(()=>matches.map((m)=>(0, $cec6b334748d9a6c$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $5bc57f835864eb51$export$1448a5050d252c4d() {
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseLoaderData);
    let routeId = $5bc57f835864eb51$var$useCurrentRouteId($5bc57f835864eb51$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $5bc57f835864eb51$export$fd5d37484eab868d(routeId) {
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $5bc57f835864eb51$export$fdc00f3f26066d5e() {
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseActionData);
    let routeId = $5bc57f835864eb51$var$useCurrentRouteId($5bc57f835864eb51$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $5bc57f835864eb51$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8tsvq.useContext($5bc57f835864eb51$var$RouteErrorContext);
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseRouteError);
    let routeId = $5bc57f835864eb51$var$useCurrentRouteId($5bc57f835864eb51$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $5bc57f835864eb51$export$78a72ddb39bdd145() {
    let value = $8tsvq.useContext($5bc57f835864eb51$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $5bc57f835864eb51$export$17f53340677d5831() {
    let value = $8tsvq.useContext($5bc57f835864eb51$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $5bc57f835864eb51$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $5bc57f835864eb51$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $5bc57f835864eb51$var$useDataRouterContext($5bc57f835864eb51$var$DataRouterHook.UseBlocker);
    let state = $5bc57f835864eb51$var$useDataRouterState($5bc57f835864eb51$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8tsvq.useState("");
    let blockerFunction = $8tsvq.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $5bc57f835864eb51$var$_extends({}, currentLocation, {
                pathname: (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $5bc57f835864eb51$var$_extends({}, nextLocation, {
                pathname: (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8tsvq.useEffect(()=>{
        let key = String(++$5bc57f835864eb51$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8tsvq.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $cec6b334748d9a6c$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $5bc57f835864eb51$var$useNavigateStable() {
    let { router: router } = $5bc57f835864eb51$var$useDataRouterContext($5bc57f835864eb51$var$DataRouterHook.UseNavigateStable);
    let id = $5bc57f835864eb51$var$useCurrentRouteId($5bc57f835864eb51$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8tsvq.useRef(false);
    $5bc57f835864eb51$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8tsvq.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $5bc57f835864eb51$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $5bc57f835864eb51$var$alreadyWarned$1 = {};
function $5bc57f835864eb51$var$warningOnce(key, cond, message) {
    if (!cond && !$5bc57f835864eb51$var$alreadyWarned$1[key]) $5bc57f835864eb51$var$alreadyWarned$1[key] = true;
}
const $5bc57f835864eb51$var$alreadyWarned = {};
function $5bc57f835864eb51$var$warnOnce(key, message) {}
const $5bc57f835864eb51$var$logDeprecation = (flag, msg, link)=>$5bc57f835864eb51$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $5bc57f835864eb51$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $5bc57f835864eb51$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $5bc57f835864eb51$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $5bc57f835864eb51$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $5bc57f835864eb51$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $5bc57f835864eb51$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $5bc57f835864eb51$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $5bc57f835864eb51$var$START_TRANSITION = "startTransition";
const $5bc57f835864eb51$var$startTransitionImpl = $8tsvq[$5bc57f835864eb51$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $5bc57f835864eb51$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8tsvq.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8tsvq.useCallback((newState)=>{
        if (v7_startTransition && $5bc57f835864eb51$var$startTransitionImpl) $5bc57f835864eb51$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8tsvq.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8tsvq.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8tsvq.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8tsvq.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $8tsvq.useEffect(()=>$5bc57f835864eb51$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8tsvq.createElement($8tsvq.Fragment, null, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $5bc57f835864eb51$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $5bc57f835864eb51$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $5bc57f835864eb51$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8tsvq.useRef();
    if (historyRef.current == null) historyRef.current = (0, $cec6b334748d9a6c$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8tsvq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8tsvq.useCallback((newState)=>{
        v7_startTransition && $5bc57f835864eb51$var$startTransitionImpl ? $5bc57f835864eb51$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8tsvq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8tsvq.useEffect(()=>$5bc57f835864eb51$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $5bc57f835864eb51$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $8tsvq.useContext($5bc57f835864eb51$export$26749e8557646306);
    let { matches: matches } = $8tsvq.useContext($5bc57f835864eb51$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5bc57f835864eb51$export$45d76561a5302f2b();
    let navigate = $5bc57f835864eb51$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $cec6b334748d9a6c$export$cae722b0cc860f13)(to, (0, $cec6b334748d9a6c$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8tsvq.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $5bc57f835864eb51$export$910ae8079b2c2852(props) {
    return $5bc57f835864eb51$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $5bc57f835864eb51$export$e7b0ac011bb776c6(_props) {
    (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $5bc57f835864eb51$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $cec6b334748d9a6c$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$5bc57f835864eb51$export$9c954a9d03d32f4a() && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8tsvq.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $5bc57f835864eb51$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $cec6b334748d9a6c$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8tsvq.useMemo(()=>{
        let trailingPathname = (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $5bc57f835864eb51$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $5bc57f835864eb51$export$5d3fca4a98652595($5bc57f835864eb51$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $5bc57f835864eb51$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$ResolveAwait, null, children));
}
var $5bc57f835864eb51$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($5bc57f835864eb51$var$AwaitRenderStatus || {});
const $5bc57f835864eb51$var$neverSettledPromise = new Promise(()=>{});
class $5bc57f835864eb51$var$AwaitErrorBoundary extends $8tsvq.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $5bc57f835864eb51$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $5bc57f835864eb51$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $5bc57f835864eb51$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $5bc57f835864eb51$var$AwaitRenderStatus.error : "_data" in promise ? $5bc57f835864eb51$var$AwaitRenderStatus.success : $5bc57f835864eb51$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $5bc57f835864eb51$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $5bc57f835864eb51$var$AwaitRenderStatus.error && promise._error instanceof (0, $cec6b334748d9a6c$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $5bc57f835864eb51$var$neverSettledPromise;
        if (status === $5bc57f835864eb51$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $5bc57f835864eb51$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $5bc57f835864eb51$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8tsvq.createElement($5bc57f835864eb51$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $5bc57f835864eb51$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $5bc57f835864eb51$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8tsvq.createElement($8tsvq.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $5bc57f835864eb51$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8tsvq.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8tsvq.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8tsvq.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $5bc57f835864eb51$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $5bc57f835864eb51$export$e7b0ac011bb776c6) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $5bc57f835864eb51$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $5bc57f835864eb51$export$daf73786167a7f72(matches) {
    return $5bc57f835864eb51$var$_renderMatches(matches);
}
function $5bc57f835864eb51$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8tsvq.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $8tsvq.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8tsvq.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $5bc57f835864eb51$export$f30f7e456d254e83(routes, opts) {
    return (0, $cec6b334748d9a6c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $5bc57f835864eb51$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $cec6b334748d9a6c$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $5bc57f835864eb51$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $63c245eaedba316b$var$_extends() {
    $63c245eaedba316b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $63c245eaedba316b$var$_extends.apply(this, arguments);
}
function $63c245eaedba316b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $63c245eaedba316b$var$defaultMethod = "get";
const $63c245eaedba316b$var$defaultEncType = "application/x-www-form-urlencoded";
function $63c245eaedba316b$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $63c245eaedba316b$var$isButtonElement(object) {
    return $63c245eaedba316b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $63c245eaedba316b$var$isFormElement(object) {
    return $63c245eaedba316b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $63c245eaedba316b$var$isInputElement(object) {
    return $63c245eaedba316b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $63c245eaedba316b$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $63c245eaedba316b$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$63c245eaedba316b$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $63c245eaedba316b$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $63c245eaedba316b$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $63c245eaedba316b$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $63c245eaedba316b$var$_formDataSupportsSubmitter = null;
function $63c245eaedba316b$var$isFormDataSubmitterSupported() {
    if ($63c245eaedba316b$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $63c245eaedba316b$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $63c245eaedba316b$var$_formDataSupportsSubmitter = true;
    }
    return $63c245eaedba316b$var$_formDataSupportsSubmitter;
}
const $63c245eaedba316b$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $63c245eaedba316b$var$getFormEncType(encType) {
    if (encType != null && !$63c245eaedba316b$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $63c245eaedba316b$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($63c245eaedba316b$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $63c245eaedba316b$var$defaultMethod;
        encType = $63c245eaedba316b$var$getFormEncType(target.getAttribute("enctype")) || $63c245eaedba316b$var$defaultEncType;
        formData = new FormData(target);
    } else if ($63c245eaedba316b$var$isButtonElement(target) || $63c245eaedba316b$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $63c245eaedba316b$var$defaultMethod;
        encType = $63c245eaedba316b$var$getFormEncType(target.getAttribute("formenctype")) || $63c245eaedba316b$var$getFormEncType(form.getAttribute("enctype")) || $63c245eaedba316b$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$63c245eaedba316b$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($63c245eaedba316b$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $63c245eaedba316b$var$defaultMethod;
        action = null;
        encType = $63c245eaedba316b$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $63c245eaedba316b$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $63c245eaedba316b$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $63c245eaedba316b$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $63c245eaedba316b$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $63c245eaedba316b$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $63c245eaedba316b$export$1f3f55432a00e06d(routes, opts) {
    return (0, $cec6b334748d9a6c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $63c245eaedba316b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $cec6b334748d9a6c$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $63c245eaedba316b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5bc57f835864eb51$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $63c245eaedba316b$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $cec6b334748d9a6c$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $63c245eaedba316b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $cec6b334748d9a6c$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $63c245eaedba316b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5bc57f835864eb51$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $63c245eaedba316b$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $63c245eaedba316b$var$_extends({}, state, {
        errors: $63c245eaedba316b$var$deserializeErrors(state.errors)
    });
    return state;
}
function $63c245eaedba316b$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $cec6b334748d9a6c$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $63c245eaedba316b$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8tsvq.createContext({
    isTransitioning: false
});
const $63c245eaedba316b$export$148fd98d095596d4 = /*#__PURE__*/ $8tsvq.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $63c245eaedba316b$var$START_TRANSITION = "startTransition";
const $63c245eaedba316b$var$startTransitionImpl = $8tsvq[$63c245eaedba316b$var$START_TRANSITION];
const $63c245eaedba316b$var$FLUSH_SYNC = "flushSync";
const $63c245eaedba316b$var$flushSyncImpl = $a2d184922ae7f92f$exports[$63c245eaedba316b$var$FLUSH_SYNC];
const $63c245eaedba316b$var$USE_ID = "useId";
const $63c245eaedba316b$var$useIdImpl = $8tsvq[$63c245eaedba316b$var$USE_ID];
function $63c245eaedba316b$var$startTransitionSafe(cb) {
    if ($63c245eaedba316b$var$startTransitionImpl) $63c245eaedba316b$var$startTransitionImpl(cb);
    else cb();
}
function $63c245eaedba316b$var$flushSyncSafe(cb) {
    if ($63c245eaedba316b$var$flushSyncImpl) $63c245eaedba316b$var$flushSyncImpl(cb);
    else cb();
}
class $63c245eaedba316b$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $63c245eaedba316b$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8tsvq.useState(router.state);
    let [pendingState, setPendingState] = $8tsvq.useState();
    let [vtContext, setVtContext] = $8tsvq.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8tsvq.useState();
    let [transition, setTransition] = $8tsvq.useState();
    let [interruption, setInterruption] = $8tsvq.useState();
    let fetcherData = $8tsvq.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8tsvq.useCallback((cb)=>{
        if (v7_startTransition) $63c245eaedba316b$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8tsvq.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $63c245eaedba316b$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $63c245eaedba316b$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $63c245eaedba316b$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $63c245eaedba316b$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $63c245eaedba316b$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8tsvq.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8tsvq.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $63c245eaedba316b$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8tsvq.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8tsvq.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8tsvq.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8tsvq.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8tsvq.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8tsvq.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $8tsvq.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $8tsvq.useEffect(()=>(0, $5bc57f835864eb51$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8tsvq.createElement($8tsvq.Fragment, null, /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $8tsvq.createElement($63c245eaedba316b$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8tsvq.createElement($63c245eaedba316b$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8tsvq.createElement($63c245eaedba316b$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $63c245eaedba316b$var$MemoizedDataRoutes = /*#__PURE__*/ $8tsvq.memo($63c245eaedba316b$var$DataRoutes);
function $63c245eaedba316b$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $5bc57f835864eb51$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $63c245eaedba316b$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8tsvq.useRef();
    if (historyRef.current == null) historyRef.current = (0, $cec6b334748d9a6c$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8tsvq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8tsvq.useCallback((newState)=>{
        v7_startTransition && $63c245eaedba316b$var$startTransitionImpl ? $63c245eaedba316b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8tsvq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8tsvq.useEffect(()=>(0, $5bc57f835864eb51$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $63c245eaedba316b$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8tsvq.useRef();
    if (historyRef.current == null) historyRef.current = (0, $cec6b334748d9a6c$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8tsvq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8tsvq.useCallback((newState)=>{
        v7_startTransition && $63c245eaedba316b$var$startTransitionImpl ? $63c245eaedba316b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8tsvq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8tsvq.useEffect(()=>(0, $5bc57f835864eb51$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $63c245eaedba316b$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8tsvq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8tsvq.useCallback((newState)=>{
        v7_startTransition && $63c245eaedba316b$var$startTransitionImpl ? $63c245eaedba316b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8tsvq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8tsvq.useEffect(()=>(0, $5bc57f835864eb51$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8tsvq.createElement((0, $5bc57f835864eb51$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $63c245eaedba316b$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $63c245eaedba316b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $63c245eaedba316b$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8tsvq.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $63c245eaedba316b$var$_objectWithoutPropertiesLoose(_ref7, $63c245eaedba316b$var$_excluded);
    let { basename: basename } = $8tsvq.useContext((0, $5bc57f835864eb51$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $63c245eaedba316b$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($63c245eaedba316b$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $5bc57f835864eb51$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $63c245eaedba316b$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8tsvq.createElement("a", $63c245eaedba316b$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $63c245eaedba316b$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8tsvq.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $63c245eaedba316b$var$_objectWithoutPropertiesLoose(_ref8, $63c245eaedba316b$var$_excluded2);
    let path = (0, $5bc57f835864eb51$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    let routerState = $8tsvq.useContext((0, $5bc57f835864eb51$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $8tsvq.useContext((0, $5bc57f835864eb51$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $63c245eaedba316b$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8tsvq.createElement($63c245eaedba316b$export$a6c7ac8248d6e38a, $63c245eaedba316b$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $63c245eaedba316b$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8tsvq.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $63c245eaedba316b$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $63c245eaedba316b$var$_objectWithoutPropertiesLoose(_ref9, $63c245eaedba316b$var$_excluded3);
    let submit = $63c245eaedba316b$export$47c85c6e3a081d3();
    let formAction = $63c245eaedba316b$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $8tsvq.createElement("form", $63c245eaedba316b$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $63c245eaedba316b$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $63c245eaedba316b$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $63c245eaedba316b$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($63c245eaedba316b$var$DataRouterHook || ($63c245eaedba316b$var$DataRouterHook = {}));
var $63c245eaedba316b$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($63c245eaedba316b$var$DataRouterStateHook || ($63c245eaedba316b$var$DataRouterStateHook = {}));
// Internal hooks
function $63c245eaedba316b$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $63c245eaedba316b$var$useDataRouterContext(hookName) {
    let ctx = $8tsvq.useContext((0, $5bc57f835864eb51$export$3add0d5dce533e2e));
    !ctx && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return ctx;
}
function $63c245eaedba316b$var$useDataRouterState(hookName) {
    let state = $8tsvq.useContext((0, $5bc57f835864eb51$export$145dfa71566a64dc));
    !state && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $63c245eaedba316b$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $5bc57f835864eb51$export$9770f232ac06a008)();
    let location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    let path = (0, $5bc57f835864eb51$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $8tsvq.useCallback((event)=>{
        if ($63c245eaedba316b$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $cec6b334748d9a6c$export$fe53371bee54353d)(location) === (0, $cec6b334748d9a6c$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $63c245eaedba316b$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8tsvq.useRef($63c245eaedba316b$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8tsvq.useRef(false);
    let location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    let searchParams = $8tsvq.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $63c245eaedba316b$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $5bc57f835864eb51$export$9770f232ac06a008)();
    let setSearchParams = $8tsvq.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $63c245eaedba316b$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $63c245eaedba316b$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $63c245eaedba316b$var$fetcherId = 0;
let $63c245eaedba316b$var$getUniqueFetcherId = ()=>"__" + String(++$63c245eaedba316b$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $63c245eaedba316b$export$47c85c6e3a081d3() {
    let { router: router } = $63c245eaedba316b$var$useDataRouterContext($63c245eaedba316b$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8tsvq.useContext((0, $5bc57f835864eb51$export$26749e8557646306));
    let currentRouteId = (0, $5bc57f835864eb51$export$5fc8298006ad9e58)();
    return $8tsvq.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $63c245eaedba316b$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $63c245eaedba316b$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $63c245eaedba316b$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $63c245eaedba316b$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8tsvq.useContext((0, $5bc57f835864eb51$export$26749e8557646306));
    let routeContext = $8tsvq.useContext((0, $5bc57f835864eb51$export$9072aa6dd1f93057));
    !routeContext && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $63c245eaedba316b$var$_extends({}, (0, $5bc57f835864eb51$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $cec6b334748d9a6c$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $cec6b334748d9a6c$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $63c245eaedba316b$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $63c245eaedba316b$var$useDataRouterContext($63c245eaedba316b$var$DataRouterHook.UseFetcher);
    let state = $63c245eaedba316b$var$useDataRouterState($63c245eaedba316b$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8tsvq.useContext($63c245eaedba316b$export$148fd98d095596d4);
    let route = $8tsvq.useContext((0, $5bc57f835864eb51$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    !route && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $63c245eaedba316b$var$useIdImpl ? $63c245eaedba316b$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8tsvq.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($63c245eaedba316b$var$getUniqueFetcherId());
    // Registration/cleanup
    $8tsvq.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8tsvq.useCallback((href, opts)=>{
        !routeId && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $63c245eaedba316b$export$47c85c6e3a081d3();
    let submit = $8tsvq.useCallback((target, opts)=>{
        submitImpl(target, $63c245eaedba316b$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8tsvq.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8tsvq.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8tsvq.createElement($63c245eaedba316b$export$a7fed597f4b8afd8, $63c245eaedba316b$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $cec6b334748d9a6c$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8tsvq.useMemo(()=>$63c245eaedba316b$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $63c245eaedba316b$export$fa996778a3a31087() {
    let state = $63c245eaedba316b$var$useDataRouterState($63c245eaedba316b$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $63c245eaedba316b$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $63c245eaedba316b$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $63c245eaedba316b$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $63c245eaedba316b$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $63c245eaedba316b$var$useDataRouterContext($63c245eaedba316b$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $63c245eaedba316b$var$useDataRouterState($63c245eaedba316b$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8tsvq.useContext((0, $5bc57f835864eb51$export$26749e8557646306));
    let location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    let matches = (0, $5bc57f835864eb51$export$2378eb7f5ff86053)();
    let navigation = (0, $5bc57f835864eb51$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $8tsvq.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $63c245eaedba316b$var$usePageHide($8tsvq.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $63c245eaedba316b$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $63c245eaedba316b$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($63c245eaedba316b$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8tsvq.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $63c245eaedba316b$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $63c245eaedba316b$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8tsvq.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($63c245eaedba316b$var$_extends({}, location, {
                    pathname: (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($63c245eaedba316b$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8tsvq.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $63c245eaedba316b$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8tsvq.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $63c245eaedba316b$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8tsvq.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $63c245eaedba316b$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $5bc57f835864eb51$export$b273b3273281a049)(when);
    $8tsvq.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8tsvq.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $63c245eaedba316b$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8tsvq.useContext($63c245eaedba316b$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $cec6b334748d9a6c$export$3e9cee6b33872309)(false);
    let { basename: basename } = $63c245eaedba316b$var$useDataRouterContext($63c245eaedba316b$var$DataRouterHook.useViewTransitionState);
    let path = (0, $5bc57f835864eb51$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $cec6b334748d9a6c$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $cec6b334748d9a6c$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $cec6b334748d9a6c$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $8tsvq = parcelRequire("8tsvq");

const $43609086a6b3b5b3$var$Navigation = ()=>{
    const location = (0, $5bc57f835864eb51$export$45d76561a5302f2b)();
    const [isMenuOpen, setIsMenuOpen] = (0, $8tsvq.useState)(false);
    const isActive = (path)=>location.pathname === path;
    const toggleMenu = ()=>{
        setIsMenuOpen(!isMenuOpen);
    };
    const closeMenu = ()=>{
        setIsMenuOpen(false);
    };
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("nav", {
        className: "navigation",
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
                className: "navigation-hamburger",
                onClick: toggleMenu,
                "aria-label": "Toggle navigation menu",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                    className: "hamburger-label",
                    children: isMenuOpen ? 'Close menu' : 'Open menu'
                })
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: `navigation-overlay ${isMenuOpen ? 'navigation-overlay--open' : ''}`,
                onClick: closeMenu
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("ul", {
                className: `navigation-list ${isMenuOpen ? 'navigation-list--open' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $63c245eaedba316b$export$a6c7ac8248d6e38a), {
                            to: "/",
                            className: `navigation-link ${isActive('/') ? 'navigation-link--active' : ''}`,
                            onClick: closeMenu,
                            children: "Home"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $63c245eaedba316b$export$a6c7ac8248d6e38a), {
                            to: "/faqs",
                            className: `navigation-link ${isActive('/faqs') ? 'navigation-link--active' : ''}`,
                            onClick: closeMenu,
                            children: "FAQs"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $63c245eaedba316b$export$a6c7ac8248d6e38a), {
                            to: "/weekend-schedule",
                            className: `navigation-link ${isActive('/weekend-schedule') ? 'navigation-link--active' : ''}`,
                            onClick: closeMenu,
                            children: "Weekend schedule"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $63c245eaedba316b$export$a6c7ac8248d6e38a), {
                            to: "/travel-and-accommodation",
                            className: `navigation-link ${isActive('/travel-and-accommodation') ? 'navigation-link--active' : ''}`,
                            onClick: closeMenu,
                            children: "Travel & Accommodation"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $63c245eaedba316b$export$a6c7ac8248d6e38a), {
                            to: "/wedding-party",
                            className: `navigation-link ${isActive('/wedding-party') ? 'navigation-link--active' : ''}`,
                            onClick: closeMenu,
                            children: "The wedding party"
                        })
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $63c245eaedba316b$export$a6c7ac8248d6e38a), {
                            to: "/gifts",
                            className: `navigation-link ${isActive('/gifts') ? 'navigation-link--active' : ''}`,
                            onClick: closeMenu,
                            children: "Gifts"
                        })
                    })
                ]
            })
        ]
    });
};
var $43609086a6b3b5b3$export$2e2bcd8739ae039 = $43609086a6b3b5b3$var$Navigation;



parcelRequire("8tsvq");
const $609bd98e3ae67327$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("footer", {
        className: "site-footer",
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: "footer-strip"
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: "site-footer-inner",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "footer-columns",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            className: "footer-column",
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                                    className: "footer-title",
                                    children: "Pub Quiz"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                    className: "subheader",
                                    children: "Friday 9th October 7:30pm"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("address", {
                                    className: "footer-address",
                                    children: [
                                        "The Stroud Hotel",
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("br", {}),
                                        "Station Road",
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("br", {}),
                                        "Stroud",
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("br", {}),
                                        "GL5 3AP"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                            className: "footer-column",
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                                    className: "footer-title",
                                    children: "Ceremony & Reception"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                    className: "subheader",
                                    children: "Saturday 10th October - from noon"
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("address", {
                                    className: "footer-address",
                                    children: [
                                        "Copsegrove Farm",
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("br", {}),
                                        "Back Lane",
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("br", {}),
                                        "Bisley",
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("br", {}),
                                        "Stroud",
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("br", {}),
                                        "GL6 7BG"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $609bd98e3ae67327$export$2e2bcd8739ae039 = $609bd98e3ae67327$var$Footer;




parcelRequire("8tsvq");
const $43024c67236658df$export$4fdeb2766d52d240 = ({ imageUrl: imageUrl = 'https://images.squarespace-cdn.com/content/v1/67bee5a0a1150b7d4babf028/f0210efc-9b07-42a1-a03f-e4346ed0948f/238761-v2-672pxh%402x.jpg?format=2500w', headerContent: headerContent })=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        className: "image-header-large",
        style: {
            height: '500px',
            backgroundImage: `url(${imageUrl})`,
            backgroundPosition: 'center bottom',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: "image-header-overlay",
                style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    zIndex: 1
                }
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: "image-header-content",
                style: {
                    position: 'relative',
                    zIndex: 2,
                    textAlign: 'center',
                    color: 'white'
                },
                children: headerContent
            })
        ]
    });
};



parcelRequire("8tsvq");
const $582703c248b479fb$var$HeaderContent = ()=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
            className: "block-content block-content-header",
            children: [
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        className: "subheader paragraph-bordered",
                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                            children: "The ultimate co-op campaign"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("h1", {
                    children: [
                        "Erin ",
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("small", {
                            children: "&"
                        }),
                        " Luka"
                    ]
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                    className: "subheader",
                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                        children: "10 / 10 / 2026"
                    })
                })
            ]
        })
    });
};
var $582703c248b479fb$export$2e2bcd8739ae039 = $582703c248b479fb$var$HeaderContent;


var $5eb8d1c489a3f960$exports = {};
$5eb8d1c489a3f960$exports = import.meta.resolve("1Q1fc");


var $912f3a67d15ecd35$exports = {};
$912f3a67d15ecd35$exports = import.meta.resolve("9arpm");


const $781388f0543f1959$var$HomePage = ()=>{
    const imageUrl = (0, (/*@__PURE__*/$parcel$interopDefault($5eb8d1c489a3f960$exports)));
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $43024c67236658df$export$4fdeb2766d52d240), {
                headerContent: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $582703c248b479fb$export$2e2bcd8739ae039), {}),
                imageUrl: imageUrl
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
                className: "block-content block-content-longtext",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        children: "Join the Quest"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                href: "/weekend-schedule",
                                children: "Check out the full schedule here,"
                            }),
                            " including details of the ceremony day."
                        ]
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                        children: [
                            "We've also created a ",
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                href: "/faqs",
                                children: "FAQs page"
                            }),
                            " to answer common questions."
                        ]
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "We can't wait to celebrate with you!"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($912f3a67d15ecd35$exports))),
                        alt: "Erin and Luka",
                        style: {
                            width: '400px',
                            margin: '0 auto 1rem',
                            borderRadius: '8px'
                        }
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        className: "paragraph-display",
                        children: "Erin & Luka x"
                    })
                ]
            })
        ]
    });
};
var $781388f0543f1959$export$2e2bcd8739ae039 = $781388f0543f1959$var$HomePage;




var $8tsvq = parcelRequire("8tsvq");

parcelRequire("8tsvq");
const $07da3d8704e766dd$export$15784c9f808e4a72 = ({ imageUrl: imageUrl = '', headerContent: headerContent })=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
            className: "image-header",
            style: {
                backgroundImage: `url(${imageUrl})`
            },
            children: [
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                    className: "image-header-overlay"
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                    className: "image-header-content",
                    children: headerContent
                })
            ]
        })
    });
};


var $a846e2a468f18bc0$exports = {};
$a846e2a468f18bc0$exports = import.meta.resolve("fiuDY");



const $910b92dea6c4c2fb$var$FAQs = ()=>{
    const [openId, setOpenId] = (0, $8tsvq.useState)(null);
    const guestFaqs = [
        {
            id: 'plus-one',
            question: 'Can I bring a plus-one?',
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                children: "The barn can only hold so many people, so only those named on the invite are able to attend."
            })
        },
        {
            id: 'children',
            question: 'Are children allowed?',
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                children: "We love kids, however as the venue is tight for space, and a working farm, we\u2019ve had to prioritise \u201Cbabe in arm\u201D situations."
            })
        },
        {
            id: 'dress-code',
            question: 'What is the dress code?',
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "Honestly, we're flexible!"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                        children: [
                            "If you\u2019re looking for an excuse to get dressed to the nines, (",
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("em", {
                                children: "that thing in the back of your wardrobe"
                            }),
                            "), please crack on. But the most important thing to us is that you\u2019re there to have fun and you\u2019re comfy."
                        ]
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "The bride isn\u2019t wearing white, so have at it - the wedding party is in dark red and dark green."
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "Those of you who are inclined to wear heels - this is a working farm, there\u2019s some gravel and cobblestones, we\u2019d suggest a chunky heel or a wedge, or bring trainers for the dancing."
                    })
                ]
            })
        },
        {
            id: 'photos',
            question: 'Is it okay to take pictures?',
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "During the party - yes, absolutely. We will create and share a Google Photos album for everyone to upload their pictures."
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "For the ceremony, we\u2019ve paid the wonderful Jess Brown to capture the moment so please pop your phone in your pocket and enjoy the show."
                    })
                ]
            })
        }
    ];
    const logisticsFaqs = [
        {
            id: 'arrival-time',
            question: 'When should I arrive?',
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                children: "Arrive from noon for a 1pm start - we will have fizz on arrival, and drinks and canap\xe9s after the ceremony."
            })
        },
        {
            id: 'parking',
            question: 'What is the parking situation?',
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "There\u2019s a whole field of parking available to you! If you want to drive up, rest assured there\u2019s somewhere safe to leave the car."
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "The field is on the right hand side and clearly marked as you approach the venue. Cars can be left overnight and collected on Sunday morning."
                    })
                ]
            })
        },
        {
            id: 'transportation',
            question: 'Can you recommend a taxi company?',
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                children: [
                    "We strongly recommend you pre-book a taxi back from the venue. Our venue have recommended ",
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                        href: "https://www.prestigestroudprivatehire.com/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Prestige Stroud Taxi"
                    }),
                    " and ",
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                        href: "https://www.wonkyswheels.co.uk/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Wonky\u2019s Wheels"
                    }),
                    ". If you would like us to help you buddy up with people staying near you to share a cab, please let us know where you\u2019re staying and we\u2019ll put you in touch."
                ]
            })
        },
        {
            id: 'ending',
            question: 'What time will the reception end?',
            answer: "We\u2019re kicking you out at 11.30pm!"
        },
        {
            id: 'venue',
            question: 'How can I learn more about your venue?',
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "Copsegrove is a magical place, and is much more than just a wedding venue."
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                        children: [
                            "You can find out more about the farm and their activities ",
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                href: "https://www.copsegrovefarm.com/",
                                target: "_blank",
                                children: "on their website."
                            })
                        ]
                    })
                ]
            })
        }
    ];
    const foodFaqs = [
        {
            id: 'dietary',
            question: 'What should I do if I have dietary restrictions?',
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                children: [
                    "Please make sure you\u2019ve told us on ",
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                        href: "https://forms.fillout.com/t/seeCp5rqzmus",
                        target: "_blank",
                        children: "your RSVP"
                    }),
                    "! Ian is amazing and can cook for pretty much any situation. If in doubt, reach out and confirm we have it."
                ]
            })
        },
        {
            id: 'open-bar',
            question: 'Will there be an open bar?',
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d00e5d22a0b5e103$exports.Fragment), {
                children: "We\u2019ve stocked the bar so don\u2019t worry about needing to bring cash for that. If you have any complaints, compliments or comments about the wine, please address those to the Mother of the Bride."
            })
        },
        {
            id: 'registry',
            question: 'Where are you registered?',
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                children: [
                    "We have everything we could possibly need and more, so we\u2019re not asking for gifts. We do have a ",
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                        href: "/gifts",
                        target: "_blank",
                        children: "couple of charities"
                    }),
                    " we love if you\u2019d like to give to them, but we just appreciate you coming to join us on the day!"
                ]
            })
        }
    ];
    const travelFaqs = [
        {
            id: 'where-stay',
            question: 'Where should I stay?',
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                children: [
                    "There are so many GREAT hotels and B&Bs nearby, the venue is situated between Stroud, Bisley and Circencester. Some favourites suggested by the venue:",
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                children: "The Painswick"
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                children: "Calcot and Spa"
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                children: "Burleigh Court Hotel"
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                children: "The Crown - Frampton Mansell"
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                children: "The Royal George - Birdlip"
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                children: "The Bell Sapperton"
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                children: "The Bear - Bisley"
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                children: "The Stroud Hotel"
                            })
                        ]
                    })
                ]
            })
        },
        {
            id: 'how-to-get',
            question: 'What is the best way to get to the venue?',
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                children: [
                    "It\u2019s by car only (unless you fancy a country walk in your gladrags). ",
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                        children: "whatthreewords"
                    }),
                    " location is: ",
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                        href: "https://what3words.com/copiers.informs.increment",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "///copiers.informs.increment"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("br", {}),
                    "If you\u2019re using Satnav, use \u201CBack Lane, Bisley, Stroud GL6 7BG\u201D to make sure you\u2019re heading to the right place. It\u2019s at the end of a very, very long lane, don\u2019t panic."
                ]
            })
        }
    ];
    const otherFaqs = [
        {
            id: 'cant-make-it',
            question: "What should I do if I can\u2019t make it?",
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                children: "Just let us know as soon as you can, life takes over sometimes and we completely get it."
            })
        },
        {
            id: 'hashtag',
            question: 'Is there a wedding hashtag?',
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                children: "Oh god no."
            })
        },
        {
            id: 'who-call',
            question: 'Whom should I call with questions?',
            answer: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                children: [
                    "Before the day? Either Erin or Luka",
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("br", {}),
                    "We will create a wedding WhatsApp group before the weekend for any last minute questions."
                ]
            })
        }
    ];
    const toggleAccordion = (id)=>{
        setOpenId(openId === id ? null : id);
    };
    const headerContent = /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h1", {
        children: "FAQs"
    });
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $07da3d8704e766dd$export$15784c9f808e4a72), {
                headerContent: headerContent,
                imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($a846e2a468f18bc0$exports)))
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("article", {
                className: "block-content block-content-longtext",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                    children: "Here are some frequently asked questions to help you prepare for our celebration."
                })
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
                className: "block-content block-content-faq",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        children: "Essential logistics & schedule"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                        className: "accordion",
                        children: logisticsFaqs.map((item)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                className: "accordion-item",
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("button", {
                                        className: `accordion-button ${openId === item.id ? 'accordion-button--open' : ''}`,
                                        onClick: ()=>toggleAccordion(item.id),
                                        "aria-expanded": openId === item.id,
                                        "aria-controls": `${item.id}-content`,
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                                className: "accordion-question",
                                                children: item.question
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                                className: "accordion-icon",
                                                children: "+"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                        id: `${item.id}-content`,
                                        className: `accordion-content ${openId === item.id ? 'accordion-content--open' : ''}`,
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                            className: "accordion-answer",
                                            children: item.answer
                                        })
                                    })
                                ]
                            }, item.id))
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        children: "Guest details"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                        className: "accordion",
                        children: guestFaqs.map((item)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                className: "accordion-item",
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("button", {
                                        className: `accordion-button ${openId === item.id ? 'accordion-button--open' : ''}`,
                                        onClick: ()=>toggleAccordion(item.id),
                                        "aria-expanded": openId === item.id,
                                        "aria-controls": `${item.id}-content`,
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                                className: "accordion-question",
                                                children: item.question
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                                className: "accordion-icon",
                                                children: "+"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                        id: `${item.id}-content`,
                                        className: `accordion-content ${openId === item.id ? 'accordion-content--open' : ''}`,
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                            className: "accordion-answer",
                                            children: item.answer
                                        })
                                    })
                                ]
                            }, item.id))
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        children: "Food & gifts"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                        className: "accordion",
                        children: foodFaqs.map((item)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                className: "accordion-item",
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("button", {
                                        className: `accordion-button ${openId === item.id ? 'accordion-button--open' : ''}`,
                                        onClick: ()=>toggleAccordion(item.id),
                                        "aria-expanded": openId === item.id,
                                        "aria-controls": `${item.id}-content`,
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                                className: "accordion-question",
                                                children: item.question
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                                className: "accordion-icon",
                                                children: "+"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                        id: `${item.id}-content`,
                                        className: `accordion-content ${openId === item.id ? 'accordion-content--open' : ''}`,
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                            className: "accordion-answer",
                                            children: item.answer
                                        })
                                    })
                                ]
                            }, item.id))
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        children: "Travel & Local information"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                        className: "accordion",
                        children: travelFaqs.map((item)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                className: "accordion-item",
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("button", {
                                        className: `accordion-button ${openId === item.id ? 'accordion-button--open' : ''}`,
                                        onClick: ()=>toggleAccordion(item.id),
                                        "aria-expanded": openId === item.id,
                                        "aria-controls": `${item.id}-content`,
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                                className: "accordion-question",
                                                children: item.question
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                                className: "accordion-icon",
                                                children: "+"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                        id: `${item.id}-content`,
                                        className: `accordion-content ${openId === item.id ? 'accordion-content--open' : ''}`,
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                            className: "accordion-answer",
                                            children: item.answer
                                        })
                                    })
                                ]
                            }, item.id))
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        children: "Other important questions"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                        className: "accordion",
                        children: otherFaqs.map((item)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                className: "accordion-item",
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("button", {
                                        className: `accordion-button ${openId === item.id ? 'accordion-button--open' : ''}`,
                                        onClick: ()=>toggleAccordion(item.id),
                                        "aria-expanded": openId === item.id,
                                        "aria-controls": `${item.id}-content`,
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                                className: "accordion-question",
                                                children: item.question
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                                className: "accordion-icon",
                                                children: "+"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                        id: `${item.id}-content`,
                                        className: `accordion-content ${openId === item.id ? 'accordion-content--open' : ''}`,
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                            className: "accordion-answer",
                                            children: item.answer
                                        })
                                    })
                                ]
                            }, item.id))
                    })
                ]
            })
        ]
    });
};
var $910b92dea6c4c2fb$export$2e2bcd8739ae039 = $910b92dea6c4c2fb$var$FAQs;


var $e551535613513678$exports = {};
/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */ // These values are established by empiricism with tests (tradeoff: performance VS precision)
var $e551535613513678$var$NEWTON_ITERATIONS = 4;
var $e551535613513678$var$NEWTON_MIN_SLOPE = 0.001;
var $e551535613513678$var$SUBDIVISION_PRECISION = 0.0000001;
var $e551535613513678$var$SUBDIVISION_MAX_ITERATIONS = 10;
var $e551535613513678$var$kSplineTableSize = 11;
var $e551535613513678$var$kSampleStepSize = 1.0 / ($e551535613513678$var$kSplineTableSize - 1.0);
var $e551535613513678$var$float32ArraySupported = typeof Float32Array === 'function';
function $e551535613513678$var$A(aA1, aA2) {
    return 1.0 - 3.0 * aA2 + 3.0 * aA1;
}
function $e551535613513678$var$B(aA1, aA2) {
    return 3.0 * aA2 - 6.0 * aA1;
}
function $e551535613513678$var$C(aA1) {
    return 3.0 * aA1;
}
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function $e551535613513678$var$calcBezier(aT, aA1, aA2) {
    return (($e551535613513678$var$A(aA1, aA2) * aT + $e551535613513678$var$B(aA1, aA2)) * aT + $e551535613513678$var$C(aA1)) * aT;
}
// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function $e551535613513678$var$getSlope(aT, aA1, aA2) {
    return 3.0 * $e551535613513678$var$A(aA1, aA2) * aT * aT + 2.0 * $e551535613513678$var$B(aA1, aA2) * aT + $e551535613513678$var$C(aA1);
}
function $e551535613513678$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX, currentT, i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $e551535613513678$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $e551535613513678$var$SUBDIVISION_PRECISION && ++i < $e551535613513678$var$SUBDIVISION_MAX_ITERATIONS);
    return currentT;
}
function $e551535613513678$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(var i = 0; i < $e551535613513678$var$NEWTON_ITERATIONS; ++i){
        var currentSlope = $e551535613513678$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        var currentX = $e551535613513678$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
function $e551535613513678$var$LinearEasing(x) {
    return x;
}
$e551535613513678$exports = function bezier(mX1, mY1, mX2, mY2) {
    if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) throw new Error('bezier x values must be in [0, 1] range');
    if (mX1 === mY1 && mX2 === mY2) return $e551535613513678$var$LinearEasing;
    // Precompute samples table
    var sampleValues = $e551535613513678$var$float32ArraySupported ? new Float32Array($e551535613513678$var$kSplineTableSize) : new Array($e551535613513678$var$kSplineTableSize);
    for(var i = 0; i < $e551535613513678$var$kSplineTableSize; ++i)sampleValues[i] = $e551535613513678$var$calcBezier(i * $e551535613513678$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = $e551535613513678$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $e551535613513678$var$kSampleStepSize;
        --currentSample;
        // Interpolate to provide an initial guess for t
        var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        var guessForT = intervalStart + dist * $e551535613513678$var$kSampleStepSize;
        var initialSlope = $e551535613513678$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $e551535613513678$var$NEWTON_MIN_SLOPE) return $e551535613513678$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $e551535613513678$var$binarySubdivide(aX, intervalStart, intervalStart + $e551535613513678$var$kSampleStepSize, mX1, mX2);
    }
    return function BezierEasing(x) {
        // Because JavaScript number are imprecise, we should guarantee the extremes are right.
        if (x === 0) return 0;
        if (x === 1) return 1;
        return $e551535613513678$var$calcBezier(getTForX(x), mY1, mY2);
    };
};


var $a4d75d360527989b$export$6288b6b9c90bc00 = function Limits(properties) {
    this.startX = properties.startX;
    this.startY = properties.startY;
    this.endX = properties.endX;
    this.endY = properties.endY; // Used to calculate the progress of the element
    this.totalX = this.endX - this.startX;
    this.totalY = this.endY - this.startY; // Used to scale translate effects
    this.startMultiplierX = properties.startMultiplierX || 1;
    this.endMultiplierX = properties.endMultiplierX || 1;
    this.startMultiplierY = properties.startMultiplierY || 1;
    this.endMultiplierY = properties.endMultiplierY || 1;
};
function $a4d75d360527989b$var$_extends() {
    $a4d75d360527989b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a4d75d360527989b$var$_extends.apply(this, arguments);
}
var $a4d75d360527989b$export$7b7b3d2b003b3688;
(function(ValidCSSEffects) {
    ValidCSSEffects["speed"] = "speed";
    ValidCSSEffects["translateX"] = "translateX";
    ValidCSSEffects["translateY"] = "translateY";
    ValidCSSEffects["rotate"] = "rotate";
    ValidCSSEffects["rotateX"] = "rotateX";
    ValidCSSEffects["rotateY"] = "rotateY";
    ValidCSSEffects["rotateZ"] = "rotateZ";
    ValidCSSEffects["scale"] = "scale";
    ValidCSSEffects["scaleX"] = "scaleX";
    ValidCSSEffects["scaleY"] = "scaleY";
    ValidCSSEffects["scaleZ"] = "scaleZ";
    ValidCSSEffects["opacity"] = "opacity";
})($a4d75d360527989b$export$7b7b3d2b003b3688 || ($a4d75d360527989b$export$7b7b3d2b003b3688 = {}));
var $a4d75d360527989b$export$dd3b792fda2f69f8;
(function(Units) {
    Units["px"] = "px";
    Units["%"] = "%";
    Units["vh"] = "vh";
    Units["vw"] = "vw";
})($a4d75d360527989b$export$dd3b792fda2f69f8 || ($a4d75d360527989b$export$dd3b792fda2f69f8 = {}));
var $a4d75d360527989b$export$332f35e53ed8d596;
(function(RotationUnits) {
    RotationUnits["deg"] = "deg";
    RotationUnits["turn"] = "turn";
    RotationUnits["rad"] = "rad";
})($a4d75d360527989b$export$332f35e53ed8d596 || ($a4d75d360527989b$export$332f35e53ed8d596 = {}));
var $a4d75d360527989b$export$32e4f0f42a51ae8;
(function(ScaleUnits) {
    ScaleUnits[""] = "";
})($a4d75d360527989b$export$32e4f0f42a51ae8 || ($a4d75d360527989b$export$32e4f0f42a51ae8 = {}));
var $a4d75d360527989b$export$8cb8b2cea11e53d2;
(function(ScrollAxis) {
    ScrollAxis["vertical"] = "vertical";
    ScrollAxis["horizontal"] = "horizontal";
})($a4d75d360527989b$export$8cb8b2cea11e53d2 || ($a4d75d360527989b$export$8cb8b2cea11e53d2 = {}));
var $a4d75d360527989b$export$9c2f1147791ff2d8;
(function(EasingPreset) {
    EasingPreset["ease"] = "ease";
    EasingPreset["easeIn"] = "easeIn";
    EasingPreset["easeOut"] = "easeOut";
    EasingPreset["easeInOut"] = "easeInOut";
    EasingPreset["easeInQuad"] = "easeInQuad";
    EasingPreset["easeInCubic"] = "easeInCubic";
    EasingPreset["easeInQuart"] = "easeInQuart";
    EasingPreset["easeInQuint"] = "easeInQuint";
    EasingPreset["easeInSine"] = "easeInSine";
    EasingPreset["easeInExpo"] = "easeInExpo";
    EasingPreset["easeInCirc"] = "easeInCirc";
    EasingPreset["easeOutQuad"] = "easeOutQuad";
    EasingPreset["easeOutCubic"] = "easeOutCubic";
    EasingPreset["easeOutQuart"] = "easeOutQuart";
    EasingPreset["easeOutQuint"] = "easeOutQuint";
    EasingPreset["easeOutSine"] = "easeOutSine";
    EasingPreset["easeOutExpo"] = "easeOutExpo";
    EasingPreset["easeOutCirc"] = "easeOutCirc";
    EasingPreset["easeInOutQuad"] = "easeInOutQuad";
    EasingPreset["easeInOutCubic"] = "easeInOutCubic";
    EasingPreset["easeInOutQuart"] = "easeInOutQuart";
    EasingPreset["easeInOutQuint"] = "easeInOutQuint";
    EasingPreset["easeInOutSine"] = "easeInOutSine";
    EasingPreset["easeInOutExpo"] = "easeInOutExpo";
    EasingPreset["easeInOutCirc"] = "easeInOutCirc";
    EasingPreset["easeInBack"] = "easeInBack";
    EasingPreset["easeOutBack"] = "easeOutBack";
    EasingPreset["easeInOutBack"] = "easeInOutBack";
})($a4d75d360527989b$export$9c2f1147791ff2d8 || ($a4d75d360527989b$export$9c2f1147791ff2d8 = {}));
/**
 * Creates a unique id to distinguish parallax elements.
 */ var $a4d75d360527989b$var$id = 0;
function $a4d75d360527989b$export$7149c6ffc9994c32() {
    ++$a4d75d360527989b$var$id;
    return $a4d75d360527989b$var$id;
}
var $a4d75d360527989b$export$c79fc6492f3af13d = /*#__PURE__*/ function() {
    function Rect(options) {
        var rect = options.el.getBoundingClientRect(); // rect is based on viewport -- must adjust for relative scroll container
        if (options.view.scrollContainer) {
            var scrollRect = options.view.scrollContainer.getBoundingClientRect();
            rect = $a4d75d360527989b$var$_extends({}, rect, {
                top: rect.top - scrollRect.top,
                right: rect.right - scrollRect.left,
                bottom: rect.bottom - scrollRect.top,
                left: rect.left - scrollRect.left
            });
        }
        this.height = options.el.offsetHeight;
        this.width = options.el.offsetWidth;
        this.left = rect.left;
        this.right = rect.right;
        this.top = rect.top;
        this.bottom = rect.bottom;
        if (options.rootMargin) this._setRectWithRootMargin(options.rootMargin);
    }
    /**
   * Apply root margin to all properties
   */ var _proto = Rect.prototype;
    _proto._setRectWithRootMargin = function _setRectWithRootMargin(rootMargin) {
        var totalRootY = rootMargin.top + rootMargin.bottom;
        var totalRootX = rootMargin.left + rootMargin.right;
        this.top -= rootMargin.top;
        this.right += rootMargin.right;
        this.bottom += rootMargin.bottom;
        this.left -= rootMargin.left;
        this.height += totalRootY;
        this.width += totalRootX;
    };
    return Rect;
}();
var $a4d75d360527989b$var$VALID_UNITS = [
    $a4d75d360527989b$export$32e4f0f42a51ae8[''],
    $a4d75d360527989b$export$dd3b792fda2f69f8.px,
    $a4d75d360527989b$export$dd3b792fda2f69f8['%'],
    $a4d75d360527989b$export$dd3b792fda2f69f8['vh'],
    $a4d75d360527989b$export$dd3b792fda2f69f8['vw'],
    $a4d75d360527989b$export$332f35e53ed8d596.deg,
    $a4d75d360527989b$export$332f35e53ed8d596.turn,
    $a4d75d360527989b$export$332f35e53ed8d596.rad
];
/**
 * Determines the unit of a string and parses the value
 */ function $a4d75d360527989b$export$aaeb52f31f3429bc(str, defaultUnit) {
    if (defaultUnit === void 0) defaultUnit = $a4d75d360527989b$export$dd3b792fda2f69f8['%'];
    var out = {
        value: 0,
        unit: defaultUnit
    };
    if (typeof str === 'undefined') return out;
    var isValid = typeof str === 'number' || typeof str === 'string';
    if (!isValid) throw new Error('Invalid value provided. Must provide a value as a string or number');
    str = String(str);
    out.value = parseFloat(str); // @ts-ignore
    out.unit = str.match(/[\d.\-+]*\s*(.*)/)[1] || defaultUnit; // @ts-expect-error
    var isValidUnit = $a4d75d360527989b$var$VALID_UNITS.includes(out.unit);
    if (!isValidUnit) throw new Error('Invalid unit provided.');
    return out;
}
var $a4d75d360527989b$var$easingPresets = {
    ease: [
        0.25,
        0.1,
        0.25,
        1.0
    ],
    easeIn: [
        0.42,
        0.0,
        1.0,
        1.0
    ],
    easeOut: [
        0.0,
        0.0,
        0.58,
        1.0
    ],
    easeInOut: [
        0.42,
        0.0,
        0.58,
        1.0
    ],
    /* Ease IN curves */ easeInQuad: [
        0.55,
        0.085,
        0.68,
        0.53
    ],
    easeInCubic: [
        0.55,
        0.055,
        0.675,
        0.19
    ],
    easeInQuart: [
        0.895,
        0.03,
        0.685,
        0.22
    ],
    easeInQuint: [
        0.755,
        0.05,
        0.855,
        0.06
    ],
    easeInSine: [
        0.47,
        0.0,
        0.745,
        0.715
    ],
    easeInExpo: [
        0.95,
        0.05,
        0.795,
        0.035
    ],
    easeInCirc: [
        0.6,
        0.04,
        0.98,
        0.335
    ],
    /* Ease Out Curves */ easeOutQuad: [
        0.25,
        0.46,
        0.45,
        0.94
    ],
    easeOutCubic: [
        0.215,
        0.61,
        0.355,
        1.0
    ],
    easeOutQuart: [
        0.165,
        0.84,
        0.44,
        1.0
    ],
    easeOutQuint: [
        0.23,
        1.0,
        0.32,
        1.0
    ],
    easeOutSine: [
        0.39,
        0.575,
        0.565,
        1.0
    ],
    easeOutExpo: [
        0.19,
        1.0,
        0.22,
        1.0
    ],
    easeOutCirc: [
        0.075,
        0.82,
        0.165,
        1.0
    ],
    /* Ease IN Out Curves */ easeInOutQuad: [
        0.455,
        0.03,
        0.515,
        0.955
    ],
    easeInOutCubic: [
        0.645,
        0.045,
        0.355,
        1.0
    ],
    easeInOutQuart: [
        0.77,
        0.0,
        0.175,
        1.0
    ],
    easeInOutQuint: [
        0.86,
        0.0,
        0.07,
        1.0
    ],
    easeInOutSine: [
        0.445,
        0.05,
        0.55,
        0.95
    ],
    easeInOutExpo: [
        1.0,
        0.0,
        0.0,
        1.0
    ],
    easeInOutCirc: [
        0.785,
        0.135,
        0.15,
        0.86
    ],
    /* Ease Bounce Curves */ easeInBack: [
        0.6,
        -0.28,
        0.735,
        0.045
    ],
    easeOutBack: [
        0.175,
        0.885,
        0.32,
        1.275
    ],
    easeInOutBack: [
        0.68,
        -0.55,
        0.265,
        1.55
    ]
};
function $a4d75d360527989b$var$createEasingFunction(easing) {
    if (Array.isArray(easing)) return (0, (/*@__PURE__*/$parcel$interopDefault($e551535613513678$exports)))(easing[0], easing[1], easing[2], easing[3]);
    if (typeof easing === 'string' && typeof $a4d75d360527989b$var$easingPresets[easing] !== 'undefined') {
        var params = $a4d75d360527989b$var$easingPresets[easing];
        return (0, (/*@__PURE__*/$parcel$interopDefault($e551535613513678$exports)))(params[0], params[1], params[2], params[3]);
    }
    return;
}
var $a4d75d360527989b$var$PARALLAX_EFFECTS = /*#__PURE__*/ Object.values($a4d75d360527989b$export$7b7b3d2b003b3688);
var $a4d75d360527989b$var$MAP_EFFECT_TO_DEFAULT_UNIT = {
    speed: 'px',
    translateX: '%',
    translateY: '%',
    rotate: 'deg',
    rotateX: 'deg',
    rotateY: 'deg',
    rotateZ: 'deg',
    scale: '',
    scaleX: '',
    scaleY: '',
    scaleZ: '',
    opacity: ''
};
/**
 * Takes a parallax element effects and parses the properties to get the start and end values and units.
 */ function $a4d75d360527989b$export$9575fa683f69aade(props, scrollAxis) {
    var parsedEffects = {};
    $a4d75d360527989b$var$PARALLAX_EFFECTS.forEach(function(key) {
        var defaultValue = $a4d75d360527989b$var$MAP_EFFECT_TO_DEFAULT_UNIT[key]; // If the provided type is a number, this must be the speed prop
        // in which case we need to construct the proper translate config
        if (typeof (props == null ? void 0 : props[key]) === 'number') {
            var value = props == null ? void 0 : props[key];
            var startSpeed = (value || 0) * 10 + "px";
            var endSpeed = (value || 0) * -10 + "px";
            var startParsed = $a4d75d360527989b$export$aaeb52f31f3429bc(startSpeed);
            var endParsed = $a4d75d360527989b$export$aaeb52f31f3429bc(endSpeed);
            var speedConfig = {
                start: startParsed.value,
                end: endParsed.value,
                unit: startParsed.unit
            }; // Manually set translate y value
            if (scrollAxis === $a4d75d360527989b$export$8cb8b2cea11e53d2.vertical) parsedEffects.translateY = speedConfig;
             // Manually set translate y value
            if (scrollAxis === $a4d75d360527989b$export$8cb8b2cea11e53d2.horizontal) parsedEffects.translateX = speedConfig;
        } // The rest are standard effect being parsed
        if (Array.isArray(props == null ? void 0 : props[key])) {
            var _value = props == null ? void 0 : props[key];
            if (typeof _value[0] !== 'undefined' && typeof _value[1] !== 'undefined') {
                var _startParsed = $a4d75d360527989b$export$aaeb52f31f3429bc(_value == null ? void 0 : _value[0], defaultValue);
                var _endParsed = $a4d75d360527989b$export$aaeb52f31f3429bc(_value == null ? void 0 : _value[1], defaultValue);
                var easing = $a4d75d360527989b$var$createEasingFunction(_value == null ? void 0 : _value[2]);
                parsedEffects[key] = {
                    start: _startParsed.value,
                    end: _endParsed.value,
                    unit: _startParsed.unit,
                    easing: easing
                };
                if (_startParsed.unit !== _endParsed.unit) throw new Error('Must provide matching units for the min and max offset values of each axis.');
            }
        }
    });
    return parsedEffects;
}
/**
 * Returns the percent (0 - 100) moved based on position in the viewport
 */ function $a4d75d360527989b$export$38a9484962d47f0(/*
 * The start value from cache
 */ start, /*
 * total dist the element has to move to be 100% complete (view width/height + element width/height)
 */ totalDist, /*
 * Current scroll value
 */ currentScroll, /*
 * an optional easing function to apply
 */ easing) {
    // adjust cached value
    var startAdjustedScroll = currentScroll - start; // Amount the element has moved based on current and total distance to move
    var amount = startAdjustedScroll / totalDist; // Apply bezier easing if provided
    if (easing) amount = easing(amount);
    return amount;
}
/**
 * Takes two values (start, end) and returns whether the current scroll is within range
 * @param {number} start - start of scroll (x/y)
 * @param {number} end - end of scroll (x/y)
 * @param {number} scroll - current scroll (x/y)
 * @return {boolean} isInView
 */ function $a4d75d360527989b$export$b0ee05d02dd6bfe1(start, end, scroll) {
    var isInView = scroll >= start && scroll <= end;
    return isInView;
}
// Scale between AKA normalize
function $a4d75d360527989b$export$db36a4c8b7964dc9(value, newMin, newMax, oldMin, oldMax) {
    return (newMax - newMin) * (value - oldMin) / (oldMax - oldMin) + newMin;
}
/**
 * Scales a start and end value of an effect based on percent moved and easing function
 */ function $a4d75d360527989b$export$3acd7b0f77a61174(effect, progress) {
    var value = $a4d75d360527989b$export$db36a4c8b7964dc9(typeof effect.easing === 'function' ? effect.easing(progress) : progress, (effect == null ? void 0 : effect.start) || 0, (effect == null ? void 0 : effect.end) || 0, 0, 1);
    return {
        value: value,
        unit: effect == null ? void 0 : effect.unit
    };
}
var $a4d75d360527989b$var$TRANSFORM_EFFECTS = /*#__PURE__*/ Object.values($a4d75d360527989b$export$7b7b3d2b003b3688).filter(function(v) {
    return v !== 'opacity';
});
function $a4d75d360527989b$var$setWillChangeStyles(el, effects) {
    var keys = Object.keys(effects);
    var hasOpacity = keys.includes('opacity');
    var willChange = "transform" + (hasOpacity ? ',opacity' : '');
    el.style.willChange = willChange;
}
function $a4d75d360527989b$export$d16b2ab591686b(effects, progress, el) {
    if (!el) return;
    var transform = $a4d75d360527989b$var$getTransformStyles(effects, progress);
    var opacity = $a4d75d360527989b$var$getOpacityStyles(effects, progress);
    el.style.transform = transform;
    el.style.opacity = opacity;
}
function $a4d75d360527989b$var$getOpacityStyles(effects, progress) {
    var scaledOpacity = effects['opacity'] && $a4d75d360527989b$export$3acd7b0f77a61174(effects['opacity'], progress);
    if (typeof scaledOpacity === 'undefined' || typeof scaledOpacity.value === 'undefined' || typeof scaledOpacity.unit === 'undefined') return '';
    var styleStr = "" + scaledOpacity.value;
    return styleStr;
}
function $a4d75d360527989b$var$getTransformStyles(effects, progress) {
    var transform = $a4d75d360527989b$var$TRANSFORM_EFFECTS.reduce(function(acc, key) {
        var scaledEffect = effects[key] && $a4d75d360527989b$export$3acd7b0f77a61174(effects[key], progress);
        if (typeof scaledEffect === 'undefined' || typeof scaledEffect.value === 'undefined' || typeof scaledEffect.unit === 'undefined') return acc;
        var styleStr = key + "(" + scaledEffect.value + scaledEffect.unit + ")";
        return acc + styleStr;
    }, '');
    return transform;
}
/**
 * Takes a parallax element and removes parallax offset styles.
 * @param {object} element
 */ function $a4d75d360527989b$export$6b6f359a824920a4(element) {
    var el = element.el;
    if (!el) return;
    el.style.transform = '';
    el.style.opacity = '';
}
function $a4d75d360527989b$var$createLimitsForRelativeElements(rect, view, scroll, shouldAlwaysCompleteAnimation) {
    var startY = rect.top - view.height;
    var startX = rect.left - view.width;
    var endY = rect.bottom;
    var endX = rect.right; // add scroll
    startX += scroll.x;
    endX += scroll.x;
    startY += scroll.y;
    endY += scroll.y;
    if (shouldAlwaysCompleteAnimation) {
        if (scroll.y + rect.top < view.height) startY = 0;
        if (scroll.x + rect.left < view.width) startX = 0;
        if (endY > view.scrollHeight - view.height) endY = view.scrollHeight - view.height;
        if (endX > view.scrollWidth - view.width) endX = view.scrollWidth - view.width;
    }
    var limits = new $a4d75d360527989b$export$6288b6b9c90bc00({
        startX: startX,
        startY: startY,
        endX: endX,
        endY: endY
    });
    return limits;
}
function $a4d75d360527989b$var$getTranslateScalar(startTranslatePx, endTranslatePx, totalDist) {
    var slow = endTranslatePx > startTranslatePx; // calculating necessary scale to increase translations
    var totalAbsOff = (Math.abs(startTranslatePx) + Math.abs(endTranslatePx)) * (slow ? -1 : 1);
    var totalDistTrue = totalDist + totalAbsOff; // Determine multiple to scale by, only values greater than 1
    var scale = Math.max(totalDist / totalDistTrue, 1);
    return scale;
}
/**
 * Return the start and end pixel values for an elements translations
 */ function $a4d75d360527989b$var$getStartEndValueInPx(translate, elementSize) {
    var start = translate.start, end = translate.end, unit = translate.unit;
    if (unit === '%') {
        var scale = elementSize / 100;
        start = start * scale;
        end = end * scale;
    }
    if (unit === 'vw') {
        var startScale = start / 100;
        var endScale = end / 100;
        start = window.innerWidth * startScale;
        end = window.innerWidth * endScale;
    }
    if (unit === 'vh') {
        var _startScale = start / 100;
        var _endScale = end / 100;
        start = window.innerHeight * _startScale;
        end = window.innerHeight * _endScale;
    }
    return {
        start: start,
        end: end
    };
}
var $a4d75d360527989b$var$DEFAULT_VALUE = {
    start: 0,
    end: 0,
    unit: ''
};
function $a4d75d360527989b$var$createLimitsWithTranslationsForRelativeElements(rect, view, effects, scroll, scrollAxis, shouldAlwaysCompleteAnimation) {
    // get start and end accounting for percent effects
    var translateX = effects.translateX || $a4d75d360527989b$var$DEFAULT_VALUE;
    var translateY = effects.translateY || $a4d75d360527989b$var$DEFAULT_VALUE;
    var _getStartEndValueInPx = $a4d75d360527989b$var$getStartEndValueInPx(translateX, rect.width), startTranslateXPx = _getStartEndValueInPx.start, endTranslateXPx = _getStartEndValueInPx.end;
    var _getStartEndValueInPx2 = $a4d75d360527989b$var$getStartEndValueInPx(translateY, rect.height), startTranslateYPx = _getStartEndValueInPx2.start, endTranslateYPx = _getStartEndValueInPx2.end; // default starting values
    var startY = rect.top - view.height;
    var startX = rect.left - view.width;
    var endY = rect.bottom;
    var endX = rect.right;
    var startMultiplierY = 1;
    var endMultiplierY = 1;
    if (scrollAxis === $a4d75d360527989b$export$8cb8b2cea11e53d2.vertical) {
        startMultiplierY = $a4d75d360527989b$var$getTranslateScalar(startTranslateYPx, endTranslateYPx, view.height + rect.height);
        endMultiplierY = startMultiplierY;
    }
    var startMultiplierX = 1;
    var endMultiplierX = 1;
    if (scrollAxis === $a4d75d360527989b$export$8cb8b2cea11e53d2.horizontal) {
        startMultiplierX = $a4d75d360527989b$var$getTranslateScalar(startTranslateXPx, endTranslateXPx, view.width + rect.width);
        endMultiplierX = startMultiplierX;
    } // Apply the scale to initial values
    if (startTranslateYPx < 0) startY = startY + startTranslateYPx * startMultiplierY;
    if (endTranslateYPx > 0) endY = endY + endTranslateYPx * endMultiplierY;
    if (startTranslateXPx < 0) startX = startX + startTranslateXPx * startMultiplierX;
    if (endTranslateXPx > 0) endX = endX + endTranslateXPx * endMultiplierX;
     // add scroll
    startX += scroll.x;
    endX += scroll.x;
    startY += scroll.y;
    endY += scroll.y; // NOTE: please refactor and isolate this :(
    if (shouldAlwaysCompleteAnimation) {
        var topBeginsInView = scroll.y + rect.top < view.height;
        var leftBeginsInView = scroll.x + rect.left < view.width;
        var bottomEndsInView = scroll.y + rect.bottom > view.scrollHeight - view.height;
        var rightEndsInView = scroll.x + rect.right > view.scrollWidth - view.height;
        if (topBeginsInView && bottomEndsInView) {
            startMultiplierY = 1;
            endMultiplierY = 1;
            startY = 0;
            endY = view.scrollHeight - view.height;
        }
        if (leftBeginsInView && rightEndsInView) {
            startMultiplierX = 1;
            endMultiplierX = 1;
            startX = 0;
            endX = view.scrollWidth - view.width;
        }
        if (!topBeginsInView && bottomEndsInView) {
            startY = rect.top - view.height + scroll.y;
            endY = view.scrollHeight - view.height;
            var totalDist = endY - startY;
            startMultiplierY = $a4d75d360527989b$var$getTranslateScalar(startTranslateYPx, endTranslateYPx, totalDist);
            endMultiplierY = 1;
            if (startTranslateYPx < 0) startY = startY + startTranslateYPx * startMultiplierY;
        }
        if (!leftBeginsInView && rightEndsInView) {
            startX = rect.left - view.width + scroll.x;
            endX = view.scrollWidth - view.width;
            var _totalDist = endX - startX;
            startMultiplierX = $a4d75d360527989b$var$getTranslateScalar(startTranslateXPx, endTranslateXPx, _totalDist);
            endMultiplierX = 1;
            if (startTranslateXPx < 0) startX = startX + startTranslateXPx * startMultiplierX;
        }
        if (topBeginsInView && !bottomEndsInView) {
            startY = 0;
            endY = rect.bottom + scroll.y;
            var _totalDist2 = endY - startY;
            startMultiplierY = 1;
            endMultiplierY = $a4d75d360527989b$var$getTranslateScalar(startTranslateYPx, endTranslateYPx, _totalDist2);
            if (endTranslateYPx > 0) endY = endY + endTranslateYPx * endMultiplierY;
        }
        if (leftBeginsInView && !rightEndsInView) {
            startX = 0;
            endX = rect.right + scroll.x;
            var _totalDist3 = endX - startX;
            startMultiplierX = 1;
            endMultiplierX = $a4d75d360527989b$var$getTranslateScalar(startTranslateXPx, endTranslateXPx, _totalDist3);
            if (endTranslateXPx > 0) endX = endX + endTranslateXPx * endMultiplierX;
        }
    }
    var limits = new $a4d75d360527989b$export$6288b6b9c90bc00({
        startX: startX,
        startY: startY,
        endX: endX,
        endY: endY,
        startMultiplierX: startMultiplierX,
        endMultiplierX: endMultiplierX,
        startMultiplierY: startMultiplierY,
        endMultiplierY: endMultiplierY
    });
    return limits;
}
function $a4d75d360527989b$var$scaleTranslateEffectsForSlowerScroll(effects, limits) {
    var effectsCopy = $a4d75d360527989b$var$_extends({}, effects);
    if (effectsCopy.translateX) effectsCopy.translateX = $a4d75d360527989b$var$_extends({}, effects.translateX, {
        start: effectsCopy.translateX.start * limits.startMultiplierX,
        end: effectsCopy.translateX.end * limits.endMultiplierX
    });
    if (effectsCopy.translateY) effectsCopy.translateY = $a4d75d360527989b$var$_extends({}, effects.translateY, {
        start: effectsCopy.translateY.start * limits.startMultiplierY,
        end: effectsCopy.translateY.end * limits.endMultiplierY
    });
    return effectsCopy;
}
function $a4d75d360527989b$var$getShouldScaleTranslateEffects(props, effects, scrollAxis) {
    if (props.rootMargin || props.targetElement || props.shouldDisableScalingTranslations) return false;
    if (!!effects.translateX && scrollAxis === $a4d75d360527989b$export$8cb8b2cea11e53d2.horizontal || !!effects.translateY && scrollAxis === $a4d75d360527989b$export$8cb8b2cea11e53d2.vertical) return true;
    return false;
}
var $a4d75d360527989b$var$clamp = function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
};
var $a4d75d360527989b$export$db77ccec0bb4ccac = /*#__PURE__*/ function() {
    function Element(options) {
        this.el = options.el;
        this.props = options.props;
        this.scrollAxis = options.scrollAxis;
        this.disabledParallaxController = options.disabledParallaxController || false;
        this.id = $a4d75d360527989b$export$7149c6ffc9994c32();
        this.effects = $a4d75d360527989b$export$9575fa683f69aade(this.props, this.scrollAxis);
        this.isInView = null;
        this.progress = 0;
        this._setElementEasing(options.props.easing);
        $a4d75d360527989b$var$setWillChangeStyles(options.el, this.effects);
    }
    var _proto = Element.prototype;
    _proto.updateProps = function updateProps(nextProps) {
        this.props = $a4d75d360527989b$var$_extends({}, this.props, nextProps);
        this.effects = $a4d75d360527989b$export$9575fa683f69aade(nextProps, this.scrollAxis);
        this._setElementEasing(nextProps.easing);
        return this;
    };
    _proto.setCachedAttributes = function setCachedAttributes(view, scroll) {
        // NOTE: Must reset styles before getting the rect, as it might impact the natural position
        $a4d75d360527989b$export$6b6f359a824920a4(this);
        this.rect = new $a4d75d360527989b$export$c79fc6492f3af13d({
            el: this.props.targetElement || this.el,
            rootMargin: this.props.rootMargin,
            view: view
        });
        var shouldScaleTranslateEffects = $a4d75d360527989b$var$getShouldScaleTranslateEffects(this.props, this.effects, this.scrollAxis);
        if (typeof this.props.startScroll === 'number' && typeof this.props.endScroll === 'number') {
            this.limits = new $a4d75d360527989b$export$6288b6b9c90bc00({
                startX: this.props.startScroll,
                startY: this.props.startScroll,
                endX: this.props.endScroll,
                endY: this.props.endScroll
            }); // Undo the reset -- place it back at current position with styles
            this._setElementStyles();
            return this;
        }
        if (shouldScaleTranslateEffects) {
            this.limits = $a4d75d360527989b$var$createLimitsWithTranslationsForRelativeElements(this.rect, view, this.effects, scroll, this.scrollAxis, this.props.shouldAlwaysCompleteAnimation);
            this.scaledEffects = $a4d75d360527989b$var$scaleTranslateEffectsForSlowerScroll(this.effects, this.limits);
        } else this.limits = $a4d75d360527989b$var$createLimitsForRelativeElements(this.rect, view, scroll, this.props.shouldAlwaysCompleteAnimation);
         // Undo the reset -- place it back at current position with styles
        this._setElementStyles();
        return this;
    };
    _proto._updateElementIsInView = function _updateElementIsInView(nextIsInView) {
        // NOTE: Check if this is the first change to make sure onExit isn't called
        var isFirstChange = this.isInView === null;
        if (nextIsInView !== this.isInView) {
            if (nextIsInView) this.props.onEnter && this.props.onEnter(this);
            else if (!isFirstChange) {
                this._setFinalProgress();
                this._setElementStyles();
                this.props.onExit && this.props.onExit(this);
            }
        }
        this.isInView = nextIsInView;
    };
    _proto._setFinalProgress = function _setFinalProgress() {
        var finalProgress = $a4d75d360527989b$var$clamp(Math.round(this.progress), 0, 1);
        this._updateElementProgress(finalProgress);
    };
    _proto._setElementStyles = function _setElementStyles() {
        if (this.props.disabled || this.disabledParallaxController) return;
        var effects = this.scaledEffects || this.effects;
        $a4d75d360527989b$export$d16b2ab591686b(effects, this.progress, this.el);
    };
    _proto._updateElementProgress = function _updateElementProgress(nextProgress) {
        this.progress = nextProgress;
        this.props.onProgressChange && this.props.onProgressChange(this.progress);
        this.props.onChange && this.props.onChange(this);
    };
    _proto._setElementEasing = function _setElementEasing(easing) {
        this.easing = $a4d75d360527989b$var$createEasingFunction(easing);
    };
    _proto.updateElementOptions = function updateElementOptions(options) {
        this.scrollAxis = options.scrollAxis;
        this.disabledParallaxController = options.disabledParallaxController || false;
    };
    _proto.updatePosition = function updatePosition(scroll) {
        if (!this.limits) return this;
        var isVertical = this.scrollAxis === $a4d75d360527989b$export$8cb8b2cea11e53d2.vertical;
        var isFirstChange = this.isInView === null; // based on scroll axis
        var start = isVertical ? this.limits.startY : this.limits.startX;
        var end = isVertical ? this.limits.endY : this.limits.endX;
        var total = isVertical ? this.limits.totalY : this.limits.totalX;
        var s = isVertical ? scroll.y : scroll.x; // check if in view
        var nextIsInView = $a4d75d360527989b$export$b0ee05d02dd6bfe1(start, end, s);
        this._updateElementIsInView(nextIsInView); // set the progress if in view or this is the first change
        if (nextIsInView) {
            var nextProgress = $a4d75d360527989b$export$38a9484962d47f0(start, total, s, this.easing);
            this._updateElementProgress(nextProgress);
            this._setElementStyles();
        } else if (isFirstChange) {
            // NOTE: this._updateElementProgress -- dont use this because it will trigger onChange
            this.progress = $a4d75d360527989b$var$clamp(Math.round($a4d75d360527989b$export$38a9484962d47f0(start, total, s, this.easing)), 0, 1);
            this._setElementStyles();
        }
        return this;
    };
    return Element;
}();
var $a4d75d360527989b$export$27a5bd065ad55220 = /*#__PURE__*/ function() {
    function View(config) {
        this.scrollContainer = config.scrollContainer;
        this.width = config.width;
        this.height = config.height;
        this.scrollHeight = config.scrollHeight;
        this.scrollWidth = config.scrollWidth;
    }
    var _proto = View.prototype;
    _proto.hasChanged = function hasChanged(params) {
        if (params.width !== this.width || params.height !== this.height || params.scrollWidth !== this.scrollWidth || params.scrollHeight !== this.scrollHeight) return true;
        return false;
    };
    _proto.setSize = function setSize(params) {
        this.width = params.width;
        this.height = params.height;
        this.scrollHeight = params.scrollHeight;
        this.scrollWidth = params.scrollWidth;
        return this;
    };
    return View;
}();
var $a4d75d360527989b$export$6ed4a4084f55ee7c = /*#__PURE__*/ function() {
    function Scroll(x, y) {
        this.x = x;
        this.y = y;
        this.dx = 0;
        this.dy = 0;
    }
    var _proto = Scroll.prototype;
    _proto.setScroll = function setScroll(x, y) {
        this.dx = x - this.x;
        this.dy = y - this.y;
        this.x = x;
        this.y = y;
        return this;
    };
    return Scroll;
}();
function $a4d75d360527989b$export$e12bcf805b412120() {
    var supportsPassiveOption = false;
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function get() {
                supportsPassiveOption = true;
                return true;
            }
        }); // @ts-expect-error
        window.addEventListener('test', null, opts); // @ts-expect-error
        window.removeEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
}
/**
 * -------------------------------------------------------
 * Parallax Controller
 * -------------------------------------------------------
 *
 * The global controller for setting up and managing a scroll view of elements.
 *
 */ var $a4d75d360527989b$export$2d3fa02b3cf57f0d = /*#__PURE__*/ function() {
    function ParallaxController(_ref) {
        var _ref$scrollAxis = _ref.scrollAxis, scrollAxis = _ref$scrollAxis === void 0 ? $a4d75d360527989b$export$8cb8b2cea11e53d2.vertical : _ref$scrollAxis, scrollContainer = _ref.scrollContainer, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled;
        this.disabled = disabled;
        this.scrollAxis = scrollAxis; // All parallax elements to be updated
        this.elements = [];
        this._hasScrollContainer = !!scrollContainer;
        this.viewEl = scrollContainer != null ? scrollContainer : window; // Scroll and View
        var _this$_getScrollPosit = this._getScrollPosition(), x = _this$_getScrollPosit[0], y = _this$_getScrollPosit[1];
        this.scroll = new $a4d75d360527989b$export$6ed4a4084f55ee7c(x, y);
        this.view = new $a4d75d360527989b$export$27a5bd065ad55220({
            width: 0,
            height: 0,
            scrollWidth: 0,
            scrollHeight: 0,
            scrollContainer: this._hasScrollContainer ? scrollContainer : undefined
        }); // Ticking
        this._ticking = false; // Passive support
        this._supportsPassive = $a4d75d360527989b$export$e12bcf805b412120(); // Bind methods to class
        this._bindAllMethods(); // If this is initialized disabled, don't do anything below.
        if (this.disabled) return;
        this._addListeners(this.viewEl);
        this._addResizeObserver();
        this._setViewSize();
    }
    /**
   * Static method to instantiate the ParallaxController.
   * @returns {Class} ParallaxController
   */ ParallaxController.init = function init(options) {
        var hasWindow = typeof window !== 'undefined';
        if (!hasWindow) throw new Error('Looks like ParallaxController.init() was called on the server. This method must be called on the client.');
        return new ParallaxController(options);
    };
    var _proto = ParallaxController.prototype;
    _proto._bindAllMethods = function _bindAllMethods() {
        var _this = this;
        [
            '_addListeners',
            '_removeListeners',
            '_getScrollPosition',
            '_handleScroll',
            '_handleUpdateCache',
            '_updateAllElements',
            '_updateElementPosition',
            '_setViewSize',
            '_addResizeObserver',
            '_checkIfViewHasChanged',
            '_getViewParams',
            'getElements',
            'createElement',
            'removeElementById',
            'resetElementStyles',
            'updateElementPropsById',
            'update',
            'updateScrollContainer',
            'destroy'
        ].forEach(function(method) {
            // @ts-expect-error
            _this[method] = _this[method].bind(_this);
        });
    };
    _proto._addListeners = function _addListeners(el) {
        el.addEventListener('scroll', this._handleScroll, this._supportsPassive ? {
            passive: true
        } : false);
        window.addEventListener('resize', this._handleUpdateCache, false);
        window.addEventListener('blur', this._handleUpdateCache, false);
        window.addEventListener('focus', this._handleUpdateCache, false);
        window.addEventListener('load', this._handleUpdateCache, false);
    };
    _proto._removeListeners = function _removeListeners(el) {
        var _this$_resizeObserver;
        el.removeEventListener('scroll', this._handleScroll, false);
        window.removeEventListener('resize', this._handleUpdateCache, false);
        window.removeEventListener('blur', this._handleUpdateCache, false);
        window.removeEventListener('focus', this._handleUpdateCache, false);
        window.removeEventListener('load', this._handleUpdateCache, false);
        (_this$_resizeObserver = this._resizeObserver) == null || _this$_resizeObserver.disconnect();
    };
    _proto._addResizeObserver = function _addResizeObserver() {
        var _this2 = this;
        try {
            var observedEl = this._hasScrollContainer ? this.viewEl : document.documentElement;
            this._resizeObserver = new ResizeObserver(function() {
                return _this2.update();
            });
            this._resizeObserver.observe(observedEl);
        } catch (e) {
            console.warn('Failed to create the resize observer in the ParallaxContoller');
        }
    };
    _proto._getScrollPosition = function _getScrollPosition() {
        // Save current scroll
        // Supports IE 9 and up.
        var nx = this._hasScrollContainer ? this.viewEl.scrollLeft : window.pageXOffset;
        var ny = this._hasScrollContainer ? this.viewEl.scrollTop : window.pageYOffset;
        return [
            nx,
            ny
        ];
    };
    _proto._handleScroll = function _handleScroll() {
        var _this$elements;
        var _this$_getScrollPosit2 = this._getScrollPosition(), nx = _this$_getScrollPosit2[0], ny = _this$_getScrollPosit2[1];
        this.scroll.setScroll(nx, ny); // Only called if the last animation request has been
        // completed and there are parallax elements to update
        if (!this._ticking && ((_this$elements = this.elements) == null ? void 0 : _this$elements.length) > 0) {
            this._ticking = true; // @ts-ignore
            window.requestAnimationFrame(this._updateAllElements);
        }
    };
    _proto._handleUpdateCache = function _handleUpdateCache() {
        this._setViewSize();
        this._updateAllElements({
            updateCache: true
        });
    };
    _proto._updateAllElements = function _updateAllElements(_temp) {
        var _this3 = this;
        var _ref2 = _temp === void 0 ? {} : _temp, updateCache = _ref2.updateCache;
        if (this.elements) this.elements.forEach(function(element) {
            if (updateCache) element.setCachedAttributes(_this3.view, _this3.scroll);
            _this3._updateElementPosition(element);
        });
         // reset ticking so more animations can be called
        this._ticking = false;
    };
    _proto._updateElementPosition = function _updateElementPosition(element) {
        if (element.props.disabled || this.disabled) return;
        element.updatePosition(this.scroll);
    };
    _proto._getViewParams = function _getViewParams() {
        if (this._hasScrollContainer) {
            // @ts-expect-error
            var _width = this.viewEl.offsetWidth; // @ts-expect-error
            var _height = this.viewEl.offsetHeight; // @ts-expect-error
            var _scrollHeight = this.viewEl.scrollHeight; // @ts-expect-error
            var _scrollWidth = this.viewEl.scrollWidth;
            return this.view.setSize({
                width: _width,
                height: _height,
                scrollHeight: _scrollHeight,
                scrollWidth: _scrollWidth
            });
        }
        var html = document.documentElement;
        var width = window.innerWidth || html.clientWidth;
        var height = window.innerHeight || html.clientHeight;
        var scrollHeight = html.scrollHeight;
        var scrollWidth = html.scrollWidth;
        return {
            width: width,
            height: height,
            scrollHeight: scrollHeight,
            scrollWidth: scrollWidth
        };
    };
    _proto._setViewSize = function _setViewSize() {
        return this.view.setSize(this._getViewParams());
    };
    _proto._checkIfViewHasChanged = function _checkIfViewHasChanged() {
        return this.view.hasChanged(this._getViewParams());
    };
    _proto.getElements = function getElements() {
        return this.elements;
    };
    _proto.createElement = function createElement(options) {
        var newElement = new $a4d75d360527989b$export$db77ccec0bb4ccac($a4d75d360527989b$var$_extends({}, options, {
            scrollAxis: this.scrollAxis,
            disabledParallaxController: this.disabled
        }));
        newElement.setCachedAttributes(this.view, this.scroll);
        this.elements = this.elements ? [].concat(this.elements, [
            newElement
        ]) : [
            newElement
        ];
        this._updateElementPosition(newElement); // NOTE: This checks if the view has changed then update the controller and all elements if it has
        // This shouldn't always be necessary with a resize observer watching the view element
        // but there seems to be cases where the resize observer does not catch and update.
        if (this._checkIfViewHasChanged()) this.update();
        return newElement;
    };
    _proto.removeElementById = function removeElementById(id) {
        if (!this.elements) return;
        this.elements = this.elements.filter(function(el) {
            return el.id !== id;
        });
    };
    _proto.updateElementPropsById = function updateElementPropsById(id, props) {
        if (this.elements) this.elements = this.elements.map(function(el) {
            if (el.id === id) return el.updateProps(props);
            return el;
        });
        this.update();
    };
    _proto.resetElementStyles = function resetElementStyles(element) {
        $a4d75d360527989b$export$6b6f359a824920a4(element);
    };
    _proto.update = function update() {
        // Save the latest scroll position because window.scroll
        // may be called and the handle scroll event may not be called.
        var _this$_getScrollPosit3 = this._getScrollPosition(), nx = _this$_getScrollPosit3[0], ny = _this$_getScrollPosit3[1];
        this.scroll.setScroll(nx, ny);
        this._setViewSize();
        this._updateAllElements({
            updateCache: true
        });
    };
    _proto.updateScrollContainer = function updateScrollContainer(el) {
        // remove existing listeners with current el first
        this._removeListeners(this.viewEl);
        this.viewEl = el;
        this._hasScrollContainer = !!el;
        this.view = new $a4d75d360527989b$export$27a5bd065ad55220({
            width: 0,
            height: 0,
            scrollWidth: 0,
            scrollHeight: 0,
            scrollContainer: el
        });
        this._setViewSize();
        this._addListeners(this.viewEl);
        this._updateAllElements({
            updateCache: true
        });
    };
    _proto.disableParallaxController = function disableParallaxController() {
        this.disabled = true; // remove listeners
        this._removeListeners(this.viewEl); // reset all styles
        if (this.elements) this.elements.forEach(function(element) {
            return $a4d75d360527989b$export$6b6f359a824920a4(element);
        });
    };
    _proto.enableParallaxController = function enableParallaxController() {
        var _this4 = this;
        this.disabled = false;
        if (this.elements) this.elements.forEach(function(element) {
            return element.updateElementOptions({
                disabledParallaxController: false,
                scrollAxis: _this4.scrollAxis
            });
        });
         // add back listeners
        this._addListeners(this.viewEl);
        this._addResizeObserver();
        this._setViewSize();
    };
    _proto.disableAllElements = function disableAllElements() {
        console.warn('deprecated: use disableParallaxController() instead');
        if (this.elements) this.elements = this.elements.map(function(el) {
            return el.updateProps({
                disabled: true
            });
        });
        this.update();
    };
    _proto.enableAllElements = function enableAllElements() {
        console.warn('deprecated: use enableParallaxController() instead');
        if (this.elements) this.elements = this.elements.map(function(el) {
            return el.updateProps({
                disabled: false
            });
        });
        this.update();
    };
    _proto.destroy = function destroy() {
        this._removeListeners(this.viewEl);
        if (this.elements) this.elements.forEach(function(element) {
            return $a4d75d360527989b$export$6b6f359a824920a4(element);
        });
         // @ts-expect-error
        this.elements = undefined;
    };
    return ParallaxController;
}();



var $8tsvq = parcelRequire("8tsvq");
function $8e8c8abc5cb5bd06$var$_extends() {
    $8e8c8abc5cb5bd06$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8e8c8abc5cb5bd06$var$_extends.apply(this, arguments);
}
function $8e8c8abc5cb5bd06$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8e8c8abc5cb5bd06$var$removeUndefinedObjectKeys(obj) {
    Object.keys(obj).forEach(function(key) {
        return obj[key] === undefined && delete obj[key];
    });
    return obj;
}
var $8e8c8abc5cb5bd06$var$_excluded = [
    "disabled",
    "easing",
    "endScroll",
    "onChange",
    "onEnter",
    "onExit",
    "onProgressChange",
    "opacity",
    "rootMargin",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "scaleX",
    "scaleY",
    "scaleZ",
    "shouldAlwaysCompleteAnimation",
    "shouldDisableScalingTranslations",
    "speed",
    "startScroll",
    "targetElement",
    "translateX",
    "translateY"
];
function $8e8c8abc5cb5bd06$var$getIsolatedParallaxProps(props) {
    var disabled = props.disabled, easing = props.easing, endScroll = props.endScroll, onChange = props.onChange, onEnter = props.onEnter, onExit = props.onExit, onProgressChange = props.onProgressChange, opacity = props.opacity, rootMargin = props.rootMargin, rotate = props.rotate, rotateX = props.rotateX, rotateY = props.rotateY, rotateZ = props.rotateZ, scale = props.scale, scaleX = props.scaleX, scaleY = props.scaleY, scaleZ = props.scaleZ, shouldAlwaysCompleteAnimation = props.shouldAlwaysCompleteAnimation, shouldDisableScalingTranslations = props.shouldDisableScalingTranslations, speed = props.speed, startScroll = props.startScroll, targetElement = props.targetElement, translateX = props.translateX, translateY = props.translateY, rest = $8e8c8abc5cb5bd06$var$_objectWithoutPropertiesLoose(props, $8e8c8abc5cb5bd06$var$_excluded);
    var parallaxProps = $8e8c8abc5cb5bd06$var$removeUndefinedObjectKeys({
        disabled: disabled,
        easing: easing,
        endScroll: endScroll,
        onChange: onChange,
        onEnter: onEnter,
        onExit: onExit,
        onProgressChange: onProgressChange,
        opacity: opacity,
        rootMargin: rootMargin,
        rotate: rotate,
        rotateX: rotateX,
        rotateY: rotateY,
        rotateZ: rotateZ,
        scale: scale,
        scaleX: scaleX,
        scaleY: scaleY,
        scaleZ: scaleZ,
        shouldAlwaysCompleteAnimation: shouldAlwaysCompleteAnimation,
        shouldDisableScalingTranslations: shouldDisableScalingTranslations,
        speed: speed,
        startScroll: startScroll,
        targetElement: targetElement,
        translateX: translateX,
        translateY: translateY
    });
    return {
        parallaxProps: parallaxProps,
        rest: rest
    };
}
function $8e8c8abc5cb5bd06$var$useVerifyController(controller) {
    (0, $8tsvq.useEffect)(function() {
        var isServer = typeof window === 'undefined'; // Make sure the provided controller is an instance of the Parallax Controller
        var isInstance = controller instanceof (0, $a4d75d360527989b$export$2d3fa02b3cf57f0d); // Throw if neither context or global is available
        if (!isServer && !controller && !isInstance) throw new Error("Must wrap your application's <Parallax /> components in a <ParallaxProvider />.");
    }, [
        controller
    ]);
}
var $8e8c8abc5cb5bd06$export$a42913da4acdf478 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createContext(null);
function $8e8c8abc5cb5bd06$export$f1fe063217e567a8() {
    var parallaxController = (0, $8tsvq.useContext)($8e8c8abc5cb5bd06$export$a42913da4acdf478);
    var isServer = typeof window === 'undefined';
    if (isServer) return null;
    if (!parallaxController) throw new Error('Could not find `react-scroll-parallax` context value. Please ensure the component is wrapped in a <ParallaxProvider>');
    return parallaxController;
}
function $8e8c8abc5cb5bd06$export$78dabaa73e04c89f(props) {
    var controller = $8e8c8abc5cb5bd06$export$f1fe063217e567a8();
    var ref = (0, $8tsvq.useRef)(null);
    var _getIsolatedParallaxP = $8e8c8abc5cb5bd06$var$getIsolatedParallaxProps(props), parallaxProps = _getIsolatedParallaxP.parallaxProps;
    $8e8c8abc5cb5bd06$var$useVerifyController(controller);
    var _useState = (0, $8tsvq.useState)(), element = _useState[0], setElement = _useState[1]; // create element
    (0, $8tsvq.useEffect)(function() {
        var newElement;
        if (ref.current instanceof HTMLElement) {
            var options = {
                el: ref.current,
                props: parallaxProps
            };
            newElement = controller == null ? void 0 : controller.createElement(options);
            setElement(newElement);
        } else throw new Error('You must assign the ref returned by the useParallax() hook to an HTML Element.');
        return function() {
            if (newElement) controller == null || controller.removeElementById(newElement.id);
        };
    }, []); // update element
    (0, $8tsvq.useEffect)(function() {
        if (element) {
            if (props.disabled) {
                controller == null || controller.resetElementStyles(element);
                controller == null || controller.updateElementPropsById(element.id, parallaxProps);
            } else controller == null || controller.updateElementPropsById(element.id, parallaxProps);
        }
    }, [
        props.disabled,
        props.easing,
        props.endScroll,
        props.onChange,
        props.onEnter,
        props.onExit,
        props.onProgressChange,
        props.opacity,
        props.rootMargin,
        props.rotate,
        props.rotateX,
        props.rotateY,
        props.rotateZ,
        props.scale,
        props.scaleX,
        props.scaleY,
        props.scaleZ,
        props.shouldAlwaysCompleteAnimation,
        props.shouldDisableScalingTranslations,
        props.speed,
        props.startScroll,
        props.targetElement,
        props.translateX,
        props.translateY
    ]);
    return {
        ref: ref,
        controller: controller,
        element: element
    };
}
function $8e8c8abc5cb5bd06$export$1bc430945f060dd1(props) {
    var _getIsolatedParallaxP = $8e8c8abc5cb5bd06$var$getIsolatedParallaxProps(props), parallaxProps = _getIsolatedParallaxP.parallaxProps, rest = _getIsolatedParallaxP.rest;
    var _useParallax = $8e8c8abc5cb5bd06$export$78dabaa73e04c89f(parallaxProps), ref = _useParallax.ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("div", Object.assign({
        ref: ref
    }, rest), props.children);
}
var $8e8c8abc5cb5bd06$var$FALLBACK_RECT = {
    height: 0
};
function $8e8c8abc5cb5bd06$var$getExpandedStyle(layer) {
    if (Array.isArray(layer.translateY)) {
        var translateYStart = (0, $a4d75d360527989b$export$aaeb52f31f3429bc)(layer.translateY[0]);
        var translateYEnd = (0, $a4d75d360527989b$export$aaeb52f31f3429bc)(layer.translateY[1]);
        if (translateYStart.unit === 'px' && translateYEnd.unit === 'px') return {
            top: Math.abs(translateYEnd.value) * -1 + "px",
            bottom: Math.abs(translateYStart.value) * -1 + "px"
        };
        if (translateYStart.unit === '%' && translateYEnd.unit === '%') {
            var _layer$targetElement$, _layer$targetElement;
            var clientRect = (_layer$targetElement$ = (_layer$targetElement = layer.targetElement) == null ? void 0 : _layer$targetElement.getBoundingClientRect()) != null ? _layer$targetElement$ : $8e8c8abc5cb5bd06$var$FALLBACK_RECT;
            var top = Math.abs(clientRect.height * 0.01 * translateYEnd.value) * -1;
            var bottom = Math.abs(clientRect.height * 0.01 * translateYStart.value) * -1;
            return {
                top: top + "px",
                bottom: bottom + "px"
            };
        }
    }
    if (layer.speed) {
        var speed = layer.speed || 0;
        var absSpeed = Math.abs(speed) * -10;
        return {
            top: absSpeed + "px",
            bottom: absSpeed + "px"
        };
    }
    return {};
}
function $8e8c8abc5cb5bd06$var$getImageStyle(layer) {
    return layer.image ? {
        backgroundImage: "url(" + layer.image + ")",
        backgroundPosition: 'center',
        backgroundSize: 'cover'
    } : {};
}
var $8e8c8abc5cb5bd06$var$_excluded$1 = [
    "children",
    "disabled",
    "style",
    "expanded",
    "image",
    "testId"
];
var $8e8c8abc5cb5bd06$var$absoluteStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
};
var $8e8c8abc5cb5bd06$export$b63f1c4843584916 = function ParallaxBannerLayer(props) {
    var _getIsolatedParallaxP = $8e8c8abc5cb5bd06$var$getIsolatedParallaxProps(props), parallaxProps = _getIsolatedParallaxP.parallaxProps, rest = _getIsolatedParallaxP.rest;
    var style = rest.style, _rest$expanded = rest.expanded, expanded = _rest$expanded === void 0 ? true : _rest$expanded, testId = rest.testId, divProps = $8e8c8abc5cb5bd06$var$_objectWithoutPropertiesLoose(rest, $8e8c8abc5cb5bd06$var$_excluded$1);
    var imageStyle = $8e8c8abc5cb5bd06$var$getImageStyle(props);
    var expandedStyle = expanded ? $8e8c8abc5cb5bd06$var$getExpandedStyle(props) : {};
    var parallax = $8e8c8abc5cb5bd06$export$78dabaa73e04c89f($8e8c8abc5cb5bd06$var$_extends({
        targetElement: props.targetElement,
        shouldDisableScalingTranslations: true
    }, parallaxProps));
    return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("div", Object.assign({
        "data-testid": testId,
        ref: parallax.ref,
        style: $8e8c8abc5cb5bd06$var$_extends({}, imageStyle, $8e8c8abc5cb5bd06$var$absoluteStyle, expandedStyle, style)
    }, divProps), rest.children);
};
var $8e8c8abc5cb5bd06$var$_excluded$2 = [
    "disabled",
    "style",
    "layers"
];
var $8e8c8abc5cb5bd06$var$containerStyle = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%'
};
var $8e8c8abc5cb5bd06$export$7e2ae52bed89b740 = function ParallaxBanner(props) {
    var _useState = (0, $8tsvq.useState)(null), targetElement = _useState[0], setTargetElement = _useState[1];
    var containerRef = (0, $8tsvq.useRef)(null);
    (0, $8tsvq.useEffect)(function() {
        setTargetElement(containerRef.current);
    }, []);
    var rootStyle = props.style, _props$layers = props.layers, layers = _props$layers === void 0 ? [] : _props$layers, rootRest = $8e8c8abc5cb5bd06$var$_objectWithoutPropertiesLoose(props, $8e8c8abc5cb5bd06$var$_excluded$2);
    function renderLayers() {
        if (targetElement) {
            var shouldUseLayers = layers && layers.length > 0;
            if (shouldUseLayers) return layers.map(function(layer, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement($8e8c8abc5cb5bd06$export$b63f1c4843584916, Object.assign({}, layer, {
                    targetElement: targetElement,
                    key: "layer-" + i,
                    testId: "layer-" + i
                }));
            });
        }
        return null;
    }
    function renderChildren() {
        if (targetElement) return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).Children.map(props.children, function(child) {
            var item = child; // adds the targetElement prop to any ParallaxBannerLayer components
            if ((item == null ? void 0 : item.type) === $8e8c8abc5cb5bd06$export$b63f1c4843584916) {
                var clone = (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).cloneElement(item, {
                    targetElement: targetElement
                });
                return clone;
            }
            return child;
        });
        return null;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement("div", Object.assign({
        ref: containerRef,
        style: $8e8c8abc5cb5bd06$var$_extends({}, $8e8c8abc5cb5bd06$var$containerStyle, rootStyle)
    }, rootRest), renderLayers(), renderChildren());
};
var $8e8c8abc5cb5bd06$var$createController = function createController(options) {
    // Don't initialize on the server
    var isServer = typeof window === 'undefined';
    if (!isServer) // Must not be the server so kick it off...
    return (0, $a4d75d360527989b$export$2d3fa02b3cf57f0d).init(options);
    return null;
};
function $8e8c8abc5cb5bd06$export$df63e15c6fb592aa(props) {
    var controller = (0, $8tsvq.useRef)(null);
    if (!controller.current) controller.current = $8e8c8abc5cb5bd06$var$createController({
        scrollAxis: props.scrollAxis || (0, $a4d75d360527989b$export$8cb8b2cea11e53d2).vertical,
        scrollContainer: props.scrollContainer,
        disabled: props.isDisabled
    });
     // update scroll container
    (0, $8tsvq.useEffect)(function() {
        if (props.scrollContainer && controller.current) controller.current.updateScrollContainer(props.scrollContainer);
    }, [
        props.scrollContainer,
        controller.current
    ]); // disable/enable parallax
    (0, $8tsvq.useEffect)(function() {
        if (props.isDisabled && controller.current) controller.current.disableParallaxController();
        if (!props.isDisabled && controller.current) controller.current.enableParallaxController();
    }, [
        props.isDisabled,
        controller.current
    ]); // remove the controller when unmounting
    (0, $8tsvq.useEffect)(function() {
        return function() {
            (controller == null ? void 0 : controller.current) && (controller == null || controller.current.destroy());
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).createElement($8e8c8abc5cb5bd06$export$a42913da4acdf478.Provider, {
        value: controller.current
    }, props.children);
}



parcelRequire("8tsvq");



var $8tsvq = parcelRequire("8tsvq");
const $d1f5500ae4b98358$var$GuestContext = /*#__PURE__*/ (0, $8tsvq.createContext)(undefined);
const $d1f5500ae4b98358$export$4b30cee399b85eb7 = ()=>{
    const context = (0, $8tsvq.useContext)($d1f5500ae4b98358$var$GuestContext);
    if (!context) throw new Error('useGuest must be used within a GuestProvider');
    return context;
};
const $d1f5500ae4b98358$export$2fa019930f86d50c = ({ children: children })=>{
    const [guestType, setGuestTypeState] = (0, $8tsvq.useState)(null);
    // Load guest type from localStorage on mount
    (0, $8tsvq.useEffect)(()=>{
        const stored = localStorage.getItem('guestType');
        if (stored === 'weekend' || stored === 'farmhouse') setGuestTypeState(stored);
    }, []);
    // Persist to localStorage whenever it changes
    const setGuestType = (type)=>{
        if (type) localStorage.setItem('guestType', type);
        else localStorage.removeItem('guestType');
        setGuestTypeState(type);
    };
    const isAuthenticated = guestType !== null;
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)($d1f5500ae4b98358$var$GuestContext.Provider, {
        value: {
            guestType: guestType,
            setGuestType: setGuestType,
            isAuthenticated: isAuthenticated
        },
        children: children
    });
};


var $ab9fc1621a183d86$exports = {};
$ab9fc1621a183d86$exports = import.meta.resolve("45RIe");


const $e2b5c92b51e44ae9$var$TravelAccommodation = ()=>{
    const { guestType: guestType } = (0, $d1f5500ae4b98358$export$4b30cee399b85eb7)();
    const imageUrl = (0, (/*@__PURE__*/$parcel$interopDefault($ab9fc1621a183d86$exports)));
    const headerContent = /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h1", {
        children: "Travel & Accommodation"
    });
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $07da3d8704e766dd$export$15784c9f808e4a72), {
                imageUrl: imageUrl,
                headerContent: headerContent
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
                className: "block-content block-content-longtext",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        children: "Getting Here"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "Stroud is easily accessible by rail, with a central train station offering frequent, direct services to London Paddington."
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "It's also a lovely drive through the rolling hills, and many of the accommodations we've found have ample parking."
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                        children: [
                            "Our venue, ",
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("em", {
                                children: "Copsegrove Farm"
                            }),
                            ", is just a 15 minute drive from Stroud station."
                        ]
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                        children: "Directions to the Venue"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "The venue is by car only (unless you fancy a country walk in your gladrags!)."
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                        children: [
                            "If you're using Satnav, use ",
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                children: '"Back Lane, Bisley, Stroud GL6 7BG"'
                            }),
                            " to make sure you're heading to the right place. It's at the end of a very, very long lane, so don't panic!"
                        ]
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                        children: [
                            "Alternatively, you can use the ",
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                children: "whatthreewords"
                            }),
                            " location: ",
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                href: "https://what3words.com/copiers.informs.increment",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: "///copiers.informs.increment"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h3", {
                        children: "Parking"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "There's a whole field of parking available to you! The field is on the right hand side and clearly marked as you approach the venue. Cars can be left overnight and collected on Sunday morning."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("article", {
                className: "block-content block-content-longtext",
                children: guestType === 'farmhouse' ? /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                            children: "Your Accommodation"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            children: "You're staying with us at the venue!"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            children: "We're excited to have you as our special guests at Copsegrove Farm."
                        })
                    ]
                }) : /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                            children: "Where to Stay"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            children: "The venue is situated between Stroud, Bisley and Circencester, and there are so many great hotels and B&Bs nearby. Here are some favourites suggested by the venue:"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "The Painswick"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "Calcot and Spa"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "Burleigh Court Hotel"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "The Crown - Frampton Mansell"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "The Royal George - Birdlip"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "The Bell Sapperton"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "The Bear - Bisley"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                            href: "https://thestroudhotel.com/",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: "The Stroud Hotel"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                            href: "https://www.premierinn.com/gb/en/hotels/england/gloucestershire/stroud/stroud.html",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: "The Premier Inn"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                    children: "Please note:"
                                }),
                                " We recommend booking your stay as early as possible to ensure availability and the best rates."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
                className: "block-content block-content-longtext",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        children: "Taxi Services"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "We strongly recommend pre-booking a taxi back from the venue. Our venue have recommended:"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                        href: "https://www.prestigestroudprivatehire.com/",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "Prestige Stroud Taxi"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("a", {
                                        href: "https://www.wonkyswheels.co.uk/",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: "Wonky's Wheels"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "If you would like us to help you buddy up with people staying near you to share a cab, please let us know where you're staying and we'll put you in touch."
                    })
                ]
            })
        ]
    });
};
var $e2b5c92b51e44ae9$export$2e2bcd8739ae039 = $e2b5c92b51e44ae9$var$TravelAccommodation;



parcelRequire("8tsvq");


var $ff4a3fd811a878fe$exports = {};
$ff4a3fd811a878fe$exports = import.meta.resolve("dKzEq");


const $40479649b65a7509$var$WeekendSchedule = ()=>{
    const { guestType: guestType } = (0, $d1f5500ae4b98358$export$4b30cee399b85eb7)();
    const imageUrl = (0, (/*@__PURE__*/$parcel$interopDefault($ff4a3fd811a878fe$exports)));
    const headerContent = /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h1", {
        children: "Weekend Schedule"
    });
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $07da3d8704e766dd$export$15784c9f808e4a72), {
                imageUrl: imageUrl,
                headerContent: headerContent
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
                className: "block-content block-content-longtext",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        children: "Friday 9th October 2026"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        className: "subheader",
                        children: "Pub Quiz!"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "We will host a pub quiz at 7:30pm at the Stroud Hotel, Station Road, Stroud GL5 3AP."
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "The quiz will be a chance for us to welcome you to Stroud, for you to meet some of our other guests, and to test your knowledge with a friendly competition."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
                className: "block-content block-content-longtext",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        children: "Saturday 10th October 2026"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        className: "subheader",
                        children: "Wedding Ceremony & Reception"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("ul", {
                        className: "timeline-list",
                        children: [
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "12:00"
                                    }),
                                    "Guests arrive - fizz on arrival in the courtyard"
                                ]
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "13:00"
                                    }),
                                    "Ceremony begins in the Barn"
                                ]
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "13:30"
                                    }),
                                    "Drinks reception, canap\xe9s & games in the Courtyard"
                                ]
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "14:30"
                                    }),
                                    "The Bar opens"
                                ]
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "15:00"
                                    }),
                                    "A sit down Feast in the Barn"
                                ]
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "15:30"
                                    }),
                                    "Speeches - the Best Man, the Maid of Honour, The Groom, The Bride"
                                ]
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "17:30"
                                    }),
                                    "Dessert table opens + tea & coffee "
                                ]
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "18:30"
                                    }),
                                    "First dance & two live sets from What's New, a Welsh Jazz Quintet"
                                ]
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "20:30"
                                    }),
                                    "Evening food served in the Barn"
                                ]
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "21:00"
                                    }),
                                    "Dancing, drinks, fire, frivolity in the Barn and Courtyard"
                                ]
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                        children: "23:00-23:45"
                                    }),
                                    "Carriages home"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("article", {
                className: "block-content block-content-longtext",
                children: guestType === 'farmhouse' && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                            children: "Farmhouse Week - Monday to Thursday"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            children: "The bulk of the wedding activities are Friday to Sunday, but we'll be arranging some events in the house from Monday to Thursday to reconnect with everyone who's staying around."
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            children: "Think big screen Mario Kart, a casino & cocktails night, a Padel court and a swimming pool / sauna double feature."
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            children: "More details to follow closer to the date!"
                        })
                    ]
                })
            })
        ]
    });
};
var $40479649b65a7509$export$2e2bcd8739ae039 = $40479649b65a7509$var$WeekendSchedule;



parcelRequire("8tsvq");

parcelRequire("8tsvq");
var $96304ddd2fa7de4a$exports = {};
$96304ddd2fa7de4a$exports = import.meta.resolve("iHR2i");


var $f6c254b9981c8292$exports = {};
$f6c254b9981c8292$exports = import.meta.resolve("1M1MR");


var $199122653931904b$exports = {};
$199122653931904b$exports = import.meta.resolve("cURgg");


var $1eb001de7f2da819$exports = {};
$1eb001de7f2da819$exports = import.meta.resolve("3DkVD");


const $84a7c653d6af8e24$var$celebrant = [
    {
        name: 'Ben Borowiecki',
        role: '"The Chronicler"',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($1eb001de7f2da819$exports))),
        description: 'Every great quest needs a narrator. In some realms, they\'d be a warlock sealing contracts with demons.',
        subDescription: 'Here, they seal contracts with vows. It\'s slightly less dangerous, but just as permanent.'
    }
];
const $84a7c653d6af8e24$var$groomPeople = [
    {
        name: 'Holly Taylor',
        role: '"The Emotional Heavy"',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($96304ddd2fa7de4a$exports))),
        description: 'The watcher of the inner circle and keeper of the family secrets. When the noise gets loud and the heat is on, she minds what matters most.',
        subDescription: 'If things get heavy, she carries the weight; if the drama gets loud, she makes it "disappear."'
    }
];
const $84a7c653d6af8e24$var$bridePeople = [
    {
        name: 'Kat Price',
        role: '"The Right Hand of the Bride"',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($f6c254b9981c8292$exports))),
        description: 'The Bride\'s other life partner. Has the Bride\'s ear at all times, and occasionally her wine glass too.',
        subDescription: 'If you need something from the Bride today, talk to the Hand.'
    },
    {
        name: 'Judith Durkin',
        role: '"The Enforcer"',
        img: (0, (/*@__PURE__*/$parcel$interopDefault($199122653931904b$exports))),
        description: 'She has a list, a watch, and a clipboard. If you hear your name coming from this woman, you\'re needed somewhere.',
        subDescription: 'Shame she didn\'t send us a photo of her face. Best of luck.'
    }
];
const $84a7c653d6af8e24$var$WeddingGrid = ()=>{
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
                className: "block-content block-content-longtext",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "We\u2019ve always believed that family isn't just about who you\u2019re born to; it\u2019s about who\u2019s willing to help you bury a body at 3am, no questions asked. One of them would probably advise us on what to plant over the burial site to get a good harvest."
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "Jokes aside, we are incredibly blessed to have a massive crew of both blood and chosen family."
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                        children: "These are people who stood by us through thick and thin, and today they\u2019re standing with us to make sure this whole operation goes off without a hitch. They\u2019re here to ensure we make good on an offer we can\u2019t refuse: till death do us part."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
                className: "block-content block-content-longtext block-content-wide",
                children: [
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        children: "The Bridal Party"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                        className: "wedding-grid",
                        children: $84a7c653d6af8e24$var$bridePeople.map((p)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                className: "wedding-card",
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                        className: "wedding-image",
                                        style: {
                                            backgroundImage: `url(${p.img})`
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                        className: "wedding-info",
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                                children: p.name
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                                className: "role",
                                                children: p.role
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                                children: p.description
                                            }),
                                            p.subDescription && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                                children: p.subDescription
                                            })
                                        ]
                                    })
                                ]
                            }, p.name))
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("h2", {
                        children: [
                            "The Best ",
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                className: "minipadded"
                            }),
                            '"Man"'
                        ]
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                        className: "wedding-grid wedding-grid--single",
                        children: $84a7c653d6af8e24$var$groomPeople.map((p)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                className: "wedding-card",
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                        className: "wedding-image",
                                        style: {
                                            backgroundImage: `url(${p.img})`
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                        className: "wedding-info",
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                                children: p.name
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                                className: "role",
                                                children: p.role
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                                children: p.description
                                            }),
                                            p.subDescription && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                                children: p.subDescription
                                            })
                                        ]
                                    })
                                ]
                            }, p.name))
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h2", {
                        children: "The Celebrant"
                    }),
                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                        className: "wedding-grid wedding-grid--single",
                        children: $84a7c653d6af8e24$var$celebrant.map((p)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                className: "wedding-card",
                                children: [
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                        className: "wedding-image",
                                        style: {
                                            backgroundImage: `url(${p.img})`
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                        className: "wedding-info",
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                                children: p.name
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                                className: "role",
                                                children: p.role
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                                children: p.description
                                            }),
                                            p.subDescription && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                                                children: p.subDescription
                                            })
                                        ]
                                    })
                                ]
                            }, p.name))
                    })
                ]
            })
        ]
    });
};
var $84a7c653d6af8e24$export$2e2bcd8739ae039 = $84a7c653d6af8e24$var$WeddingGrid;




const $c3af2c8e75cf1c1c$var$WeddingParty = ()=>{
    const imageUrl = (0, (/*@__PURE__*/$parcel$interopDefault($5eb8d1c489a3f960$exports)));
    const headerContent = /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h1", {
        children: "The Wedding Party"
    });
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $07da3d8704e766dd$export$15784c9f808e4a72), {
                headerContent: headerContent,
                imageUrl: imageUrl
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("main", {
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("section", {
                    className: "block-content",
                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $84a7c653d6af8e24$export$2e2bcd8739ae039), {})
                })
            })
        ]
    });
};
var $c3af2c8e75cf1c1c$export$2e2bcd8739ae039 = $c3af2c8e75cf1c1c$var$WeddingParty;



parcelRequire("8tsvq");

var $9c221fc2f90e0c66$exports = {};
$9c221fc2f90e0c66$exports = import.meta.resolve("c4fZK");


var $08640bc30854c8b9$exports = {};
$08640bc30854c8b9$exports = import.meta.resolve("aLkwO");


var $fd448b812dfc5367$exports = {};
$fd448b812dfc5367$exports = import.meta.resolve("35gpq");


var $d2c4d819ee7e0e17$exports = {};
$d2c4d819ee7e0e17$exports = import.meta.resolve("fFdPl");


var $9b3caa0eb5394c0d$exports = {};
$9b3caa0eb5394c0d$exports = import.meta.resolve("eXmoy");


const $671546ee8f0b0210$var$Gifts = ()=>{
    const imageUrl = (0, (/*@__PURE__*/$parcel$interopDefault($9c221fc2f90e0c66$exports)));
    const headerContent = /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h1", {
        children: "Gifts"
    });
    const charities = [
        {
            name: 'Gendered Intelligence',
            description: 'Supporting trans, non-binary and gender diverse people',
            url: 'https://genderedintelligence.co.uk/',
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($08640bc30854c8b9$exports)))
        },
        {
            name: 'Shout',
            description: 'Free 24/7 mental health text support service',
            url: 'https://giveusashout.org',
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($fd448b812dfc5367$exports)))
        },
        {
            name: 'Brain Aneurysm Foundation',
            description: 'Funding research and early detection to save lives',
            url: 'https://www.bafound.org/',
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($d2c4d819ee7e0e17$exports)))
        },
        {
            name: 'Celia Hammond Animal Trust',
            description: 'Rescuing and rehoming cats and providing low-cost veterinary care',
            url: 'https://www.celiahammond.org/',
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($9b3caa0eb5394c0d$exports)))
        }
    ];
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $d00e5d22a0b5e103$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $07da3d8704e766dd$export$15784c9f808e4a72), {
                headerContent: headerContent,
                imageUrl: imageUrl
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("main", {
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("article", {
                    className: "block-content block-content-longtext",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            children: "Our cupboards are full, our shelves are tilting under the weight of Erin\u2019s books, and our hearts are content."
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            children: "If you'd like to give something, we'd be honoured if you donated to one of our chosen causes instead."
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            children: "Feel free to ask us about them, and thank you for any support you give."
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("ul", {
                            className: "charity-list",
                            children: charities.map((charity)=>/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("a", {
                                        href: charity.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "charity-link",
                                        children: [
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                                className: "charity-logo",
                                                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("img", {
                                                    src: charity.logo,
                                                    alt: `${charity.name} logo`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                                className: "charity-info",
                                                children: [
                                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("strong", {
                                                        children: charity.name
                                                    }),
                                                    /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                                        children: charity.description
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, charity.name))
                        })
                    ]
                })
            })
        ]
    });
};
var $671546ee8f0b0210$export$2e2bcd8739ae039 = $671546ee8f0b0210$var$Gifts;





var $8tsvq = parcelRequire("8tsvq");

// Set your passwords here
const $fb057aa1774d1a5f$var$PASSWORDS = {
    weekend: 'AutumnLeaves',
    farmhouse: 'TwilightPrincess'
};
const $fb057aa1774d1a5f$export$db1e0fe8090cf853 = ({ onPasswordSuccess: onPasswordSuccess })=>{
    const [password, setPassword] = (0, $8tsvq.useState)('');
    const [error, setError] = (0, $8tsvq.useState)('');
    const [isLoading, setIsLoading] = (0, $8tsvq.useState)(false);
    const [showPassword, setShowPassword] = (0, $8tsvq.useState)(true);
    const [colorTheme] = (0, $8tsvq.useState)(()=>Math.random() > 0.5 ? 'bluegreen' : 'darkred');
    const handleSubmit = (e)=>{
        e.preventDefault();
        setIsLoading(true);
        setError('');
        // Simulate a small delay for better UX
        setTimeout(()=>{
            const trimmedPassword = password.trim().replace(/\s/g, '').toLowerCase();
            if (trimmedPassword === $fb057aa1774d1a5f$var$PASSWORDS.weekend.toLowerCase()) onPasswordSuccess('weekend');
            else if (trimmedPassword === $fb057aa1774d1a5f$var$PASSWORDS.farmhouse.toLowerCase()) onPasswordSuccess('farmhouse');
            else {
                setError('Incorrect password. Please check your invitation for the correct password.');
                setPassword('');
                setIsLoading(false);
            }
        }, 500);
    };
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
        className: "password-gate",
        children: [
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: `password-gate__overlay ${colorTheme}`
            }),
            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: "password-gate__content",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "password-gate__card",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("h1", {
                            className: "password-gate__title",
                            children: "Erin & Luka"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            className: "password-gate__subtitle",
                            children: "Join the quest"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("p", {
                            children: "Please enter the password from your invitation to continue"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("form", {
                            onSubmit: handleSubmit,
                            className: "password-gate__form",
                            children: [
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                                    className: "password-gate__input-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("input", {
                                            type: showPassword ? 'text' : 'password',
                                            value: password,
                                            onChange: (e)=>setPassword(e.target.value.replace(/\s/g, '')),
                                            placeholder: "Enter your password (no spaces)",
                                            className: "password-gate__input",
                                            disabled: isLoading,
                                            autoFocus: true
                                        }),
                                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                            onClick: ()=>setShowPassword(!showPassword),
                                            className: "password-gate__toggle",
                                            role: "button",
                                            tabIndex: 0,
                                            onKeyDown: (e)=>{
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    setShowPassword(!showPassword);
                                                }
                                            },
                                            "aria-label": showPassword ? 'Hide password' : 'Show password',
                                            children: showPassword ? "\uD83D\uDC41\uFE0F" : "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                                    className: "password-gate__visibility-hint",
                                    children: showPassword ? 'Password visible' : 'Password hidden'
                                }),
                                error && /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                                    className: "password-gate__error",
                                    children: error
                                }),
                                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("button", {
                                    type: "submit",
                                    disabled: isLoading || !password.trim(),
                                    className: "password-gate__button",
                                    children: isLoading ? 'Checking...' : 'Continue'
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};



parcelRequire("8tsvq");


const $aa17dfa04b3203a5$export$b95cfdecb3b715e0 = ()=>{
    const { guestType: guestType } = (0, $d1f5500ae4b98358$export$4b30cee399b85eb7)();
    if (guestType !== 'farmhouse') return null;
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
        className: "venue-badge",
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
            className: "venue-badge__coin",
            children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("div", {
                className: "venue-badge__inner",
                children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
                    className: "venue-badge__text",
                    children: [
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                            className: "venue-badge__line1",
                            children: "Staying"
                        }),
                        /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("span", {
                            className: "venue-badge__line2",
                            children: "at Venue"
                        })
                    ]
                })
            })
        })
    });
};


function $77abae077dfc33c4$var$AppContent() {
    const { isAuthenticated: isAuthenticated, setGuestType: setGuestType } = (0, $d1f5500ae4b98358$export$4b30cee399b85eb7)();
    if (!isAuthenticated) return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $fb057aa1774d1a5f$export$db1e0fe8090cf853), {
        onPasswordSuccess: setGuestType
    });
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $8e8c8abc5cb5bd06$export$df63e15c6fb592aa), {
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $aa17dfa04b3203a5$export$b95cfdecb3b715e0), {}),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $43609086a6b3b5b3$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)("main", {
                    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsxs)((0, $5bc57f835864eb51$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5bc57f835864eb51$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $781388f0543f1959$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5bc57f835864eb51$export$e7b0ac011bb776c6), {
                                path: "/wedding-party",
                                element: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $c3af2c8e75cf1c1c$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5bc57f835864eb51$export$e7b0ac011bb776c6), {
                                path: "/faqs",
                                element: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $910b92dea6c4c2fb$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5bc57f835864eb51$export$e7b0ac011bb776c6), {
                                path: "/travel-and-accommodation",
                                element: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $e2b5c92b51e44ae9$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5bc57f835864eb51$export$e7b0ac011bb776c6), {
                                path: "/weekend-schedule",
                                element: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $40479649b65a7509$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $5bc57f835864eb51$export$e7b0ac011bb776c6), {
                                path: "/gifts",
                                element: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $671546ee8f0b0210$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $609bd98e3ae67327$export$2e2bcd8739ae039), {})
            ]
        })
    });
}
function $77abae077dfc33c4$var$App() {
    return /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $63c245eaedba316b$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $d1f5500ae4b98358$export$2fa019930f86d50c), {
            children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)($77abae077dfc33c4$var$AppContent, {})
        })
    });
}
var $77abae077dfc33c4$export$2e2bcd8739ae039 = $77abae077dfc33c4$var$App;


const $22cce652dfc8bdb5$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($416246511aeb39de$exports))).createRoot(document.getElementById('root'));
$22cce652dfc8bdb5$var$root.render(/*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tsvq))).StrictMode, {
    children: /*#__PURE__*/ (0, $d00e5d22a0b5e103$exports.jsx)((0, $77abae077dfc33c4$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=public.382f35c1.js.map
